var lib_agathe_link;
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./projects/lib-agathe-link/js/ADRService.js":
/*!***************************************************!*\
  !*** ./projects/lib-agathe-link/js/ADRService.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

const $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
__webpack_require__(/*! ./PatientIdentite */ "./projects/lib-agathe-link/js/PatientIdentite.js");

//definition d'un module pour la communication avec le TLA via ce qu'ona appelé la partie lib fsvemotionlink
const mokLogTra = __webpack_require__(/*! ./logtra */ "./projects/lib-agathe-link/js/logtra.js");
const logTra = new mokLogTra();
(function init(exports) {
  var _IInternal = {
    verifParams: _verifParams,
    httpUtilities: {
      isError: _isError
    }
  };
  var _self = null;
  function ADRService() {
    _self = this;
  }
  ADRService.prototype.getAssertionCps = getAssertionCps;
  ADRService.prototype.getAssertionVitale = getAssertionVitale;
  ADRService.prototype.isUndefinedOrNull = isUndefinedOrNull;
  function isUndefinedOrNull(value) {
    return value === undefined || value === null;
  }

  /**
   * TLSi d'assertion CPS.
   *
   * @author AAL
   * @date 02 juin 2017
   * @param signature si l'assertion doit être signée (0 ou 1)
   * @param idFact id de facturation d'une {cbaLink.shared.beans.situation}
   * @return {Promise<>}
   */
  function getAssertionCps(idFactCle) {
    var signature = true;
    // Niveau de sécurite de l'assertion PS
    var niveauSecuriteAssertion = 2;
    var attributeStatement = `identifiantFacturation#:#${idFactCle}#/#codeSpecialiteAMO#:#80`;
    var idf = `ADR${idFactCle}`; // Permet de créer un TLSi valable pendant 1 heure, et d'avoir l'assertion pour chaque situation.
    var def = $.Deferred();
    cbaLink.services.fsvcall.getAssertionCps(signature, idf, niveauSecuriteAssertion, attributeStatement).then(function (exMsg) {
      def.resolve(exMsg);
    }, error => {
      def.reject(error);
    });
    return def.promise();
  }

  /**
   * TLSi d'assertion Vitale.
   *
   * @author AAL
   * @date 02 juin 2017
   * @param cvNumeroSerie Numéro de série de la CV pour vérification bonne CV
   * @return {Promise<>}
   */
  function getAssertionVitale(cvNumeroSerie) {
    // ADR la'assertion Vitale n'est pas signée
    var signature = false;
    // Niveau de sécurite de l'assertion Vitale
    var niveauSecuriteAssertion = 2;
    var def = $.Deferred();
    cbaLink.services.fsvcall.getAssertionVitale(signature, cvNumeroSerie, niveauSecuriteAssertion).then(function (exMsg) {
      def.resolve(exMsg);
    }, error => {
      if (error.erreurApi != 0 || error.erreurGlobale != 0) {
        logTra.error(`[${error.erreurApi}] ${error.message}`);
        // @DQ Si la demande d'assertion Vitale retourne une erreur on arrête
        // A l'exception de la CV non présente qui devient pas d'assertion Vitale
        // @DQ 26/10/17 Suite release et problème configuration du Galss
        // On ne bloque plus jamais si l'assertion Vitale ne marche pas
        // L'assertion Vitale n'est pas obligatoire et majoritairement jamais présente
        // SAUF cas du test CNDA CV différente, on continu de bloquer
        if (error.erreurApi == -1 && error.message == "La carte Vitale insérée dans le " + "lecteur ne correspond pas à la carte Vitale du bénéficiaire demandé") {
          error.erreurApi = -165;
          def.reject(error);
        } else {
          error.erreurApi = 0;
          def.resolve(error);
        }
      } else {
        def.resolve(error);
      }
    });
    return def.promise();
  }
  function _verifParams(...params) {
    params.forEach(param => {
      if (isUndefinedOrNull(param.value)) {
        throw new Error(`${param.name} can't be null or undefined.`);
      }
    });
  }
  function _isError(response) {
    return response.returnAction && response.returnAction === 'error';
  }
  exports.adrService = new ADRService();
  function AppelAdrParams() {
    _self.dateReference = null;
    _self.manuel = false;
    _self.patientIdentite = null;
    _self.typeOs = null;
    _self.assertionCPS = null;
    _self.assertionVitale = null;
  }
})(cbaLink.services);

/***/ }),

/***/ "./projects/lib-agathe-link/js/EmotionGenDialog.js":
/*!*********************************************************!*\
  !*** ./projects/lib-agathe-link/js/EmotionGenDialog.js ***!
  \*********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
const mokLogTra = __webpack_require__(/*! ./logtra */ "./projects/lib-agathe-link/js/logtra.js");
const logTra = new mokLogTra();
const EmotionGenDialog = function () {
  function EmotionGenDialog() {
    this.alreadyTreated = false;
    this.okButtonHidden = false;
    this.cancelButtonHidden = false;
    this.okCallback = null;
    this.cancelCallback = null;
    this.hideCallback = null;
    this.runCancelCallBack = true;
    this.title = 'Information';
    this.okButtonLabel = null;
    this.cancelButtonLabel = null;
    this.theDialog = null;
    this.closeButtonHidden = false;
    this.validationCallBack = null;
    this.parseIt = false;
    this.width = "500px";
    this.onLoadCallBack = null;
    this.delay = null;
    this.footer = null;
    this.rightBox = null;
    this.zindexForce = null;

    // reinitialisation des composants
    if (document.getElementById('okBtnDialogGen')) {
      document.getElementById('okBtnDialogGen').innerHTML = 'OUI';
    }
    if (document.getElementById('cancelBtnDialogGen')) {
      document.getElementById('cancelBtnDialogGen').innerHTML = 'NON';
    }
  }
  EmotionGenDialog.prototype.setDelay = function (delay) {
    this.delay = delay;
  };
  //callback appelr lors du clic sur le bouton 'OK'
  EmotionGenDialog.prototype.setOkCallback = function (cb) {
    this.okCallback = cb;
  };
  //callback appelr lors du clic sur le bouton 'ANNULER'
  EmotionGenDialog.prototype.setCancelCallback = function (cb) {
    this.cancelCallback = cb;
  };
  //callback appelé lors du clic sur le bouton 'OK': permet de faire une validation de contenu
  // si ce callback renvoi true le okCallback sera appelé
  // si le callback renvoi false le okCallback n'est pas appelé
  EmotionGenDialog.prototype.setValidationCallback = function (cb) {
    this.validationCallback = cb;
  };
  //callback appelé lors de la femeture de la fenetre. La definition d'une fonction de callback par cette
  //méthode surcharge le comportement par défaut.
  // le comportement par défaut consiste a appeler le cancelCallback lors de la fermeture de la fenêtre
  EmotionGenDialog.prototype.setHideCallback = function (cb) {
    this.hideCallback = cb;
  };
  //mise à jour du titre de la popup'
  EmotionGenDialog.prototype.setTitle = function (t) {
    this.title = t;
  };
  //place un content dans le footer sous les buttons OK & CANCEL
  EmotionGenDialog.prototype.setFooter = function (content) {
    this.footer = content;
  };
  //place un content dans la boite à droite des buttons OK & CANCEL
  EmotionGenDialog.prototype.setRightBox = function (content) {
    this.rightBox = content;
  };

  //mise à jour du label du bouton 'OK'
  EmotionGenDialog.prototype.setOkButtonLabel = function (lbl) {
    this.okButtonLabel = lbl;
  };
  //mise à jour du label du bouton 'Annuler'
  EmotionGenDialog.prototype.setCancelButtonLabel = function (lbl) {
    this.cancelButtonLabel = lbl;
  };
  //appel a cette méthode aura pour effet de cacher le bouton 'OK
  EmotionGenDialog.prototype.hideOkButton = function () {
    this.okButtonHidden = true;
  };
  //l'appel de cette méthode aura pour effet de cacher le bouton 'Annuler'
  EmotionGenDialog.prototype.hideCancelButton = function () {
    this.cancelButtonHidden = true;
  };
  //appel a cette méthode aura pour effet de cacher le bouton 'croix' de fermeture de la fenetre
  EmotionGenDialog.prototype.hideCloseButton = function () {
    this.closeButtonHidden = true;
  };
  //indique à la popup qu'elle contient du code dojo qu il faut 'parser'
  EmotionGenDialog.prototype.parse = function () {
    this.parseIt = true;
  };
  EmotionGenDialog.prototype.setWidth = function (width) {
    this.width = width;
  };
  EmotionGenDialog.prototype.setHeight = function (height) {
    this.height = height;
  };
  EmotionGenDialog.prototype.setOnLoadCallBack = function (cb) {
    this.onLoadCallBack = cb;
  };
  EmotionGenDialog.prototype.setZindexForce = function (zindexForce) {
    this.zindexForce = zindexForce;
  };

  //lance l'affichage de la popup
  EmotionGenDialog.prototype.show = function (msg, cbOk, cbCancel, title) {
    alert(title + " " + msg);
  };
  EmotionGenDialog.prototype.hide = function () {
    hideDialog('dialogGen');
  };
  EmotionGenDialog.prototype.doShowDialog = function (msg) {};
  function showDialog(dialogId, content, title, width, height, loadedCallback, duration, top, hideCallback) {
    alert(title + " " + content);
  }
  function showDialogold(dialogId, content, title, width, height, loadedCallback, duration, top, hideCallback) {
    alert(title + " " + content);
  }
  function hideDialog(dialogId) {}
  return EmotionGenDialog;
}();
module.exports = EmotionGenDialog;

/***/ }),

/***/ "./projects/lib-agathe-link/js/MessagesAgatheyou.js":
/*!**********************************************************!*\
  !*** ./projects/lib-agathe-link/js/MessagesAgatheyou.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// import * as $ from 'jquery';
const $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
// import 'fsvcall.js';

//definition d'un module pour la communication avec le TLA via ce qu'ona appelé la partie lib fsvemotionlink
const mokLogTra = __webpack_require__(/*! ./logtra */ "./projects/lib-agathe-link/js/logtra.js");
const logTra = new mokLogTra();
(function (exports) {
  {
    var baseUrl = "";
    var _self;
    //
    // {
    //     class Messages {

    function Messages() {
      logTra.debug("MODULE : Messages");
      _self = this;
      this.ordonnanceSmartFacturationController = {
        showDialogUtiliseMutuelleFromADR: {
          message(mutuelle, nom) {
            return `<div style="font-size:15px">Le contrôle SMART FACTURATION a détecté la ${mutuelle} ${nom} pour ce patient.</div>
                       <div  class="text-center mt30 mb10 font2" style="font-size:15px;" >
                            Souhaites-tu utiliser cette ${mutuelle} pour la création de cette ordonnance ?
                       </div>`;
          },
          non() {
            return `Non`;
          },
          oui(mutuelle) {
            return `Oui, j'utilise la ${mutuelle}`;
          },
          annuler() {
            return `Je réessaye plus tard`;
          }
        },
        showDialogAvertissementCmuFromAdr: {
          message() {
            return `<div style="font-size:15px">Le contrôle SMART FACTURATION n'a détecté aucune CMU pour ce patient.</div>
                       <div  class="text-center mt30 mb10 font2" style="font-size:15px;" >
                            Es-tu sûr de vouloir ajouter une CMU pour ce patient ? L'ordonnance ne sera pas prise en compte par le service Facturation Assurée.
                       </div>`;
          },
          changeMutuelle() {
            return "Choisir une autre mutuelle";
          },
          abandonGP() {
            return "Continuer sans la Facturation Assurée";
          },
          cancel() {
            return 'Je réessaye plus tard';
          }
        },
        showIncitationBrancherLecteur: {
          message() {
            return `<div style="font-size:16px;"><b>Hep ! Ton lecteur ne semble pas branché…</b><br/> </div>
                       <div  class="text-center mt20 mb10" >
                        <div style="font-size:14px">Pour que cette ordonnance soit prise en compte par ton service de Facturation Assurée, j’ai besoin de vérifier les droits de ton patient.
                            Peux-tu brancher ton lecteur, stp ?<br/> </div>
                        </div>`;
          },
          okButtonLabel() {
            return "C'est fait !";
          },
          message_deuxieme_fois() {
            return `<div style="font-size:16px;"><b>En l'absence de lecteur de CPS nous ne pouvons pas garantir cette ordonnance.</b></b><span class="smiley-abs-cps"> 🤷‍♀ </span><br/> </div>
                        <div  class="text-center mt20 mb10" >
                        <div style="font-size:14px">Si tu souhaites continuer, en cas de rejet, les factures liées à cette ordonnance ne seront pas
                        prise en charge par ton service de Facturation Assurée.<br/> </div>
                        </div>
                    `;
          },
          okButtonLabel_deuxieme_fois() {
            return 'Je branche mon lecteur';
          },
          cancelButtonLabel() {
            return `Continuer sans la Facturation Assurée`;
          }
        },
        showDialogAssertionCpsInvalide: {
          message() {
            return `<div style="font-size:16px">
                            <b>La CPS utilisée semble être périmée ou révoquée</b></br>
                            Tu dois utiliser ta dernière CPS reçue.
                       </div>
                       <div  class="text-center mt20 mb10" >
                            <div id="enSavoirPlus" class="text-center" style="font-size:14px; text-decoration: underline;"
                                onclick="show('enSavoirPlusTexte'); hide('enSavoirPlus');">En savoir plus</div>
                            <div id="enSavoirPlusTexte" class="invisible" style="font-size:14px">Vérifier les droits de ton patient te permet de garantir l'exactitude de ton ordonnance et ainsi
                            <b>d'éviter les rejets de paiement.</b><br>
                            <br>
                            Nous te conseillons de <b>recréer ton ordonnance après avoir inséré une CPS valide.</b></div>
                       </div>`;
          }
        },
        showDialogAbandonADR: {
          message() {
            return `<div class="text-center">
                            <p style="font-size:16px"><b>En l'absence de contrôle des droits du patient, nous ne pouvons pas garantir cette ordonnance. </b><span style="white-space: nowrap"> 🤷‍♀️</span></p>
                            <p class="mt20 mb20"  style="font-size:14px">Si tu souhaites continuer, en cas de rejet, les factures liées à cette ordonnance ne seront pas prises en charge par ton service de Facturation assurée.</p>
                        </div>`;
          }
        },
        demandeConfirmationIgnorerInterAMC: {
          message() {
            return `<div class="text-center">
                            <p style="font-size:16px"><b>En l'absence de vérification de la prise en charge des soins du patient, nous ne pouvons garantir cette ordonnance. </b><span style="white-space: nowrap"> 🤷‍♀️</span></p>
                            <p class="mt20 mb20"  style="font-size:14px">Si tu souhaites continuer, en cas de rejet, les factures liées à cette ordonnance ne pourront pas être prises en charge par ton service de Facturation assurée.</p>
                        </div>`;
          }
        },
        showDialogAbandonGPCausePrescripteur: {
          message() {
            return `<div class="text-center">
                            <p style="font-size:16px"><b>En l'absence d'un prescripteur valide, nous ne pouvons pas garantir cette ordonnance. </b><span style="white-space: nowrap"> 🤷‍♀ </span></p>
                            <p class="mt20 mb20"  style="font-size:14px">Si tu souhaites continuer, en cas de rejet, les factures liées à cette ordonnance ne seront pas prises en charge par ton service de Facturation assurée.</p>
                        </div>`;
          }
        }
      };
      this.fsvemotionlink = {
        fsvConnectAsync: {
          titre() {
            return `Connexion avec AgatheLink perdue !`;
          },
          message() {
            return `Je tente de rétablir la connexion avec AgatheLink...`;
          }
        }
      };
      this.ordonnanceMutuelleService = {
        positionneUtiliseMutuelle: {
          mutuelleAbsente() {
            return `Afin d’utiliser ce mode de paiement, tu dois renseigner une mutuelle pour ce patient.`;
          },
          mutuelleDroitsFermes() {
            return `Les droits de mutuelle et la date de l’ordonnance ne correspondent pas. <br>
                        Pour utiliser ce mode de règlement, assure-toi que la date de prescription soit bien située dans la période de validité de la mutuelle renseignée pour ton patient.`;
          }
        }
      };
      this.ordonnanceALDService = {
        showDialogConfirmALDOnContexte: {
          titre() {
            return `Oup’s ! Les droits ne semblent pas correspondre…`;
          },
          message() {
            return `Je ne retrouve pas de trace de l’ALD dans les droits du patient… <br><br>
                        Il peut donc y avoir un risque d’impayé à la facturation. <br><br>
                        💡 Dans ce cas, je te conseille de demander au patient une attestation.`;
          },
          okButtonLabel() {
            return `Continuer avec l’ALD`;
          },
          cancelButtonLabel() {
            return `Modifier les droits`;
          }
        }
      };
      this.ordonnanceActionsSerieSoinsController = {
        doValidCurrentTraitementOrdoEdit: {
          serieSoinsVideMessage() {
            return `N’oublie pas d’ajouter les soins.`;
          }
        },
        prepareValidCurrentTraitementOrdoEdit: {
          titre() {
            return `Nouvelle attribution de soins`;
          },
          message() {
            return `Tu t’apprêtes à valider l’ordonnance avec une nouvelle règle d’attribution de tous les soins (par tournée ou infirmier.e). <br><br>
                                    Si tu avais précédemment attribué certains soins manuellement à des infirmier.e.s spécifiques, ces modifications seront perdues. <br><br>
                                    Que souhaites-tu faire ?`;
          },
          okButtonLabel() {
            return `Conserver mes modifications`;
          },
          cancelButtonLabel() {
            return `Valider la nouvelle attribution`;
          },
          choixTiersPayant() {
            return `N’oublie pas de saisir un mode de règlement`;
          }
        }
      };
      this.ordonnanceListController = {
        showDialogFacturation: {
          messageAucunActe() {
            return `Il n’y a rien à facturer pour ce patient… <span class="text-underline"
                    onclick="show('suiteMessageAucunActe')"> Cela te surprend ?</span> <br>
                    <span id="suiteMessageAucunActe" class="invisible">💡  Si cela ne semble pas cohérent, je te conseille de vérifier que l’attribution des soins a été faite correctement ou que les soins ne sont pas suspendus.</span>
                    `;
          }
        }
      };
      this.ordonnanceRenouvellementPopupController = {
        showPopupInfo: {
          exonerationMessage() {
            return `Une exonération est présente sur l’ordonnance initiale. Pense à l’ajouter aussi sur la nouvelle ordonnance, si les droits du patient n’ont pas changé.`;
          }
        },
        validatePopup: {
          datePremierSoinMessage() {
            return `La date du premier soin de cette nouvelle ordonnance doit être postérieure à celle de l’ordonnance initiale.`;
          }
        }
      };
      this.ordonnanceTPController = {
        confirmForcageTpAMO: {
          droitsFermes() {
            return `Les droits du patient ne sont pas à jour.`;
          },
          forcageTPAMO() {
            return `<div  class="mb10"> Sans droits à jour, il est possible que la caisse rejette ta facture.</div>
                                    <div  class="mb10"> 💡  Dans ce cas-là, je te conseille de te faire directement régler les soins pour éviter un impayé.</div>
                                    <div  class="mb10"> Que souhaites-tu faire ?</div>`;
          }
        }
      };
      this.planningController = {
        afficheNotificationPlanningChange: {
          message1Jour() {
            return `Le planning a été changé pour 1 jour, pense à cliquer sur "Appliquer mon planning" pour que tes modifications soient bien prises en compte.`;
          },
          messageNbJour(nb) {
            return `Le planning a été changé pour ${nb} jours, pense à cliquer sur "Appliquer mon planning" pour que tes modifications soient bien prises en compte.`;
          }
        }
      };
      this.teletransBase = {
        askForRetraiterFacture: {
          messageImpressionFactureErreur() {
            return "Modifie la mutuelle du patient sur l’ordonnance. Souhaites-tu générer le duplicata de la facture afin de l’imprimer et l'envoyer à la mutuelle ?";
          }
        }
      };
      this.ordonnanceTraitementService = {
        displayAvertissementBsiSimultane: {
          message(dateSeance, dateDebutPossible) {
            return `<div class="mt10 mb10">Attention, une autre ordonnance a déjà été saisie avec un forfait BSI pour la journée du ${dateSeance}, pour valider cette ordonnance, tu as 2 options :
                                </div>
                                <ul class="text-left"><li><span class="bullet-ay"></span>Clôturer l'ancien BSI s'il n'a pas été totalement facturé</li>
                                <li><span class="bullet-ay"></span>Modifier la date de début des soins de l'ordonnance en cours à la date du ${dateDebutPossible}</li></ul>
                            `;
          },
          ok() {
            return `J'ai compris`;
          }
        },
        dialogBsiDejaExistant: {
          message() {
            return `Une ordonnance avec des soins de BSI existe aux mêmes dates et heures. Souhaites-tu que l’on change l’ordo en BSI “Soins complémentaires” afin de pouvoir la valider ? Si des actes AMI existent, nous les changerons automatiquement en AMX.`;
          }
        }
      };
      this.lireCpsController = {
        dialogCPSPerimee: {
          message() {
            return "Ta carte CPS est périmée ! Insère ta nouvelle carte dans le lecteur pour continuer la configuration de ton logiciel";
          }
        }
      };
      this.emotionLinkTlaErrorManager = {
        showUserChoiceToResolveProbem: {
          titre() {
            return `Oup’s ! Je n’arrive pas à joindre ton lecteur`;
          },
          contentHtml(message) {
            return `<div class="bs">
                            <div class="row m0 fsize15" style="height: 200px">
                                <div class="col-md-12 pt10 pb10 m0 mt20 mb20 text-center" >
                                    Peux-tu vérifier que Ted est correctement branché à ton ordinateur, stp ?
                                    <span class="ml10"><img id="tlaAttenteOrdreInfoBulle" src="/images/${cbaLink.services.frontend.repertoireProfil}/info.png" /></span>
                                </div>
                                <div data-dojo-type="dijit/Tooltip" data-dojo-props="connectId:'tlaAttenteOrdreInfoBulle', position:['above']">${message}</div>

                                <div class="row d-flex align-items-center justify-content-center">
                                    <div class="col-md-3 pt10 pb10 m0 text-center" ><img src="${cbaLink.services.frontend.repertoireImgCommon}/maj_ted/icone_ted.png"/></div>
                                    <div class="col-md-1 pt10 pb10 m0 "><div class="rondTed" style="background:#5c9be2;"></div></div>
                                    <div class="col-md-1 pt10 pb10 m0 "><div class="rondTed" style="background:#2980e4;"></div></div>
                                    <div class="col-md-1 pt10 pb10 m0 "><div class="rondTed" style="background:#006ce7;"></div></div>
                                    <div class="col-md-3 pt10 pb10 m0 text-center" ><img src="${cbaLink.services.frontend.repertoireImgCommon}/maj_ted/icone_pdt_ted.png"/></div>
                                </div>
                            </div>
                        </div>`;
          },
          okButtonLabel() {
            return `C’est bon ! Continuer`;
          }
        },
        showIncitationBrancherLecteur: {
          titre() {
            return `Hep !  Ton lecteur ne semble pas branché...`;
          },
          cancelButtonLabel() {
            return `Je souhaite continuer sans lecteur`;
          },
          okButtonLabel() {
            return `C'est fait !`;
          },
          message() {
            return `J’ai besoin de vérifier les droits de ton patient pour garantir cette ordonnance. <br> <br> Peux-tu brancher ton lecteur, stp ?`;
          }
        }
      };
      this.tlaCommunicationController = {
        displayVideoDemarrageAgatheLink: {
          titre(titre) {
            return `Connexion avec AgatheLink perdue !`;
          },
          content(contentVideo) {
            return ` <p>Pour rétablir la connexion avec AgatheLink, peux-tu effectuer ma procédure en vidéo ci-dessous, stp ? </p> ${contentVideo}`;
          }
        },
        enumErrDetectionLecteur: {
          errAucunLecteur() {
            return `Désolée, mais je ne détecte aucun lecteur. <br> <br>
                                Si ton lecteur est bien branché, tu devrais contacter un de nos conseillers au 04 90 84 20 58.`;
          }
        },
        checkStatutEmotionLink: {
          titre() {
            return `Connexion avec AgatheLink perdue !`;
          },
          message(baseUrl) {
            return `Ça n’a pas fonctionné… <br> <br>
                                Pour résoudre ton problème, peux-tu te rendre <a href="https://localhost:8013/emotionLink/fsv/detect?url=${baseUrl}/#app" id="but_check_certif_emotionlink" > <u>ici</u> </a>
                                et valider le certificat, stp ? <br> <br>
                                Si le problème persiste, tu peux contacter un de nos conseillers au 04 90 84 20 58 <br> <br>`;
          }
        }
      };
      this.factureDetailsController = {
        showDialogSignaleFactureNonPayee: {
          _getOrganisme(typePayeur) {
            let s = "caisse";
            if (typePayeur == "MUTUELLE") {
              s = "mutuelle";
            }
            return s;
          },
          tooltip(typePayeur) {
            return `La ${this._getOrganisme(typePayeur)} n'a pas envoyé de retour de télétransmission.</br>
                        Il ne nous est pas possible de savoir si un règlement a été effectué ou non.</br>
                        Dans 90% des cas, la facture est réglée.</br>
                        N'hésite pas à consulter ton compte bancaire pour le contrôler.</br>
                        Pour assurer une qualité de service, sache qu'une relance a été faite auprès de la ${this._getOrganisme(typePayeur)}.`;
          },
          message(typePayeur) {
            return `Après avoir contrôlé ton compte bancaire, tu ne trouves pas de trace de ce paiement.<br>
                                    Sache qu'une relance a été faite auprès de la ${this._getOrganisme(typePayeur)}.<br><br>

                                    Souhaites tu signaler cette facture comme non payée ?<br>
                                    Un conseiller t'aidera à trouver le paiement.<br><br>`;
          },
          titre() {
            return `Signalement d'une facture non payée`;
          },
          okButtonLabel() {
            return `Je n'ai pas été payé`;
          }
        }
      };
    }
  }

  //     cbaLink.ui.tools.messages = new Messages();
  // }
  exports.messages = new Messages();
})(cbaLink.uitools);

/***/ }),

/***/ "./projects/lib-agathe-link/js/PatientIdentite.js":
/*!********************************************************!*\
  !*** ./projects/lib-agathe-link/js/PatientIdentite.js ***!
  \********************************************************/
/***/ (() => {

"use strict";


//Ceci est le bean patient dans un contexte ADR, qui différent que celui qui pourrait être
//présent / utilisé dans le contexte Patient
(function init(exports) {
  var _self = null;
  function PatientIdentite() {
    this.patientId = null;
    this.codeRegime = null;
    this.codeCaisse = null;
    this.codeCentre = null;
    this.assureNir = null;
    this.assureCleNir = null;
    this.benNirCertifie = null;
    this.benCleNirCertifie = null;
    this.benDateCertifie = null;
    this.dateNaissance = null;
    this.rangNaissance = null;
    this.assure = null;
    this.cvNumeroSerie = null;
    _self = this;
  }
  PatientIdentite.prototype.isNewPatient = function () {
    return cbaLink.ui.tools.booltox.isUndefinedOrNull(this.id);
  };
  function of() {
    return new PatientIdentiteBuilder();
  }
  function PatientIdentiteBuilder() {
    this.me = new PatientIdentite();
  }
  PatientIdentiteBuilder.prototype.codeRegime = function (codeRegime) {
    this.me.codeRegime = codeRegime;
    return this;
  };
  PatientIdentiteBuilder.prototype.codeCaisse = function (codeCaisse) {
    this.me.codeCaisse = codeCaisse;
    return this;
  };
  PatientIdentiteBuilder.prototype.codeCentre = function (codeCentre) {
    this.me.codeCentre = codeCentre;
    return this;
  };
  PatientIdentiteBuilder.prototype.assureNir = function (assureNir) {
    this.me.assureNir = assureNir;
    return this;
  };
  PatientIdentiteBuilder.prototype.assureCleNir = function (assureCleNir) {
    this.me.assureCleNir = assureCleNir;
    return this;
  };
  PatientIdentiteBuilder.prototype.benNirCertifie = function (benNirCertifie) {
    this.me.benNirCertifie = benNirCertifie;
    return this;
  };
  PatientIdentiteBuilder.prototype.benCleNirCertifie = function (benCleNirCertifie) {
    this.me.benCleNirCertifie = benCleNirCertifie;
    return this;
  };
  PatientIdentiteBuilder.prototype.benDateCertifie = function (benDateCertifie) {
    this.me.benDateCertifie = benDateCertifie;
    return this;
  };
  PatientIdentiteBuilder.prototype.dateNaissance = function (dateNaissance) {
    this.me.dateNaissance = dateNaissance;
    return this;
  };
  PatientIdentiteBuilder.prototype.rangNaissance = function (rangNaissance) {
    this.me.rangNaissance = rangNaissance;
    return this;
  };
  PatientIdentiteBuilder.prototype.assure = function (assure) {
    this.me.assure = assure;
    return this;
  };
  PatientIdentiteBuilder.prototype.patientId = function (patientId) {
    this.me.patientId = patientId;
    return this;
  };
  PatientIdentiteBuilder.prototype.cvNumeroSerie = function (cvNumeroSerie) {
    this.me.cvNumeroSerie = cvNumeroSerie;
    return this;
  };
  PatientIdentiteBuilder.prototype.build = function () {
    return this.me;
  };
  exports.PatientIdentite = PatientIdentite;
  exports.PatientIdentite.of = of;
})(cbaLink.beans);

/***/ }),

/***/ "./projects/lib-agathe-link/js/SELAMCService.js":
/*!******************************************************!*\
  !*** ./projects/lib-agathe-link/js/SELAMCService.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

const $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
__webpack_require__(/*! ./PatientIdentite */ "./projects/lib-agathe-link/js/PatientIdentite.js");

//definition d'un module pour la communication avec le TLA via ce qu'ona appelé la partie lib fsvemotionlink
const mokLogTra = __webpack_require__(/*! ./logtra */ "./projects/lib-agathe-link/js/logtra.js");
const logTra = new mokLogTra();
(function init(exports) {
  var _IInternal = {
    verifParams: _verifParams,
    httpUtilities: {
      isError: _isError
    }
  };
  var _self = null;
  function SELAMCService() {
    _self = this;
  }
  SELAMCService.prototype.getAssertionCps = getAssertionCps;
  SELAMCService.prototype.getAssertionVitale = getAssertionVitale;
  SELAMCService.prototype.callUrlServiceAMC = callUrlServiceAMC;
  SELAMCService.prototype.isUndefinedOrNull = isUndefinedOrNull;
  function isUndefinedOrNull(value) {
    return value === undefined || value === null;
  }

  /**
   * TLSi d'assertion CPS.
   *
   * @author AAL
   * @date 02 juin 2017
   * @param signature si l'assertion doit être signée (0 ou 1)
   * @param idFact id de facturation d'une {cbaLink.shared.beans.situation}
   * @return {Promise<>}
   */
  function getAssertionCps(idFactCle) {
    var signature = true;
    // Niveau de sécurite de l'assertion PS
    var niveauSecuriteAssertion = 2;
    var attributeStatement = `identifiantFacturation#:#${idFactCle}`; //#/#codeSpecialiteAMO#:#80`;
    var idf = `SELAMC${idFactCle}`; // Permet de créer un TLSi valable pendant 1 heure, et d'avoir l'assertion pour chaque situation.
    var def = $.Deferred();
    cbaLink.services.fsvcall.getAssertionCps(signature, idf, niveauSecuriteAssertion, attributeStatement).then(function (exMsg) {
      def.resolve(exMsg);
    }, error => {
      def.reject(error);
    });
    return def.promise();
  }

  /**
   * TLSi d'assertion Vitale.
   *
   * @author AAL
   * @date 02 juin 2017
   * @param cvNumeroSerie Numéro de série de la CV pour vérification bonne CV
   * @return {Promise<>}
   */
  function getAssertionVitale(cvNumeroSerie) {
    // ADR la'assertion Vitale n'est pas signée
    var signature = false;
    // Niveau de sécurite de l'assertion Vitale
    var niveauSecuriteAssertion = 2;
    var def = $.Deferred();
    cbaLink.services.fsvcall.getAssertionVitale(signature, cvNumeroSerie, niveauSecuriteAssertion).then(function (exMsg) {
      def.resolve(exMsg);
    }, error => {
      if (error.erreurApi != 0 || error.erreurGlobale != 0) {
        logTra.error(`[${error.erreurApi}] ${error.message}`);
        // @DQ Si la demande d'assertion Vitale retourne une erreur on arrête
        // A l'exception de la CV non présente qui devient pas d'assertion Vitale
        // @DQ 26/10/17 Suite release et problème configuration du Galss
        // On ne bloque plus jamais si l'assertion Vitale ne marche pas
        // L'assertion Vitale n'est pas obligatoire et majoritairement jamais présente
        // SAUF cas du test CNDA CV différente, on continu de bloquer
        if (error.erreurApi == -1 && error.message == "La carte Vitale insérée dans le " + "lecteur ne correspond pas à la carte Vitale du bénéficiaire demandé") {
          error.erreurApi = -165;
          def.reject(error);
        } else {
          error.erreurApi = 0;
          def.resolve(error);
        }
      } else {
        def.resolve(error);
      }
    });
    return def.promise();
  }

  /**
   * Appel à l'annuaire AMC (passe par AgatheLink - CbaLink)
   * Si le service demandé est IDB, tente un appel à l'annuaire pour le service CLC
   *
   */
  let listUrlAmcAndParamsToSave = [];
  function callUrlServiceAMC(appelSelAmcParams) {
    listUrlAmcAndParamsToSave = [];
    let dfd = $.Deferred();

    //en cas de demande de recherche d'url pour le service IDB, tente une recherche d'URL pour le service CLC également
    let tryFindUrlCLC = appelSelAmcParams.service && appelSelAmcParams.service == "IDB" || appelSelAmcParams.urlAmc && appelSelAmcParams.urlAmc.service && appelSelAmcParams.urlAmc.service == "IDB";
    let tryFindConvHtp = appelSelAmcParams.service && appelSelAmcParams.service == "FTP" || appelSelAmcParams.urlAmc && appelSelAmcParams.urlAmc.service && appelSelAmcParams.urlAmc.service == "FTP";
    let appelSelAmcParamsCLC = {};
    let appelSelAmcParamsFHP = {};
    if (tryFindUrlCLC) {
      //prepare un eventuel appel à l'annuaire pour le service CLC
      appelSelAmcParamsCLC = Object.assign(appelSelAmcParamsCLC, appelSelAmcParams);
      appelSelAmcParamsCLC.service = "CLC";
      appelSelAmcParamsCLC.urlAmc = {};
      appelSelAmcParamsCLC.urlAmc = Object.assign(appelSelAmcParamsCLC.urlAmc, appelSelAmcParams.urlAmc);
      appelSelAmcParamsCLC.urlAmc.codeService = "CLC";
      appelSelAmcParamsCLC.urlAmc.service = "CLC";
      appelSelAmcParamsCLC.urlAmc.versionNorme = "CLC1";
    }
    if (tryFindConvHtp) {
      //prepare un eventuel appel à l'annuaire pour le service CLC
      appelSelAmcParamsFHP = Object.assign(appelSelAmcParamsFHP, appelSelAmcParams);
      appelSelAmcParamsFHP.service = "FHP";
      appelSelAmcParamsFHP.urlAmc = {};
      appelSelAmcParamsFHP.urlAmc = Object.assign(appelSelAmcParamsFHP.urlAmc, appelSelAmcParams.urlAmc);
      appelSelAmcParamsFHP.urlAmc.service = "FHP";
      appelSelAmcParamsFHP.urlAmc.codeService = "FHP";
    }
    _callAnnuaireToFindUrlAmcAndSaveIt(appelSelAmcParams).then(resultAppelSelAmc => {
      if (tryFindConvHtp) {
        //si l'url demandée est pour FTP, on vérfie si il y a une url correspondante pour FHP
        appelSelAmcParamsFHP.urlAmc.csr = resultAppelSelAmc.urlAmc.csr;
        appelSelAmcParamsFHP.urlAmc.typeConv = resultAppelSelAmc.urlAmc.typeConv;
        return _callAnnuaireToFindUrlAmcAndSaveIt(appelSelAmcParamsFHP).always(() => {
          //ajoute l'url convention FHP au resultat FTP :
          appelSelAmcParams.urlAmcHTP = appelSelAmcParamsFHP.urlAmc;
          dfd.resolve({
            appelSelAmcParams: resultAppelSelAmc,
            listUrlAmcAndParamsToSave
          });
        });
      } else if (tryFindUrlCLC) {
        //si l'url demandée est pour IDB, on vérfie si il y a une url correspondante pour CLC
        appelSelAmcParamsCLC.urlAmc.csr = resultAppelSelAmc.urlAmc.csr;
        appelSelAmcParamsCLC.urlAmc.typeConv = resultAppelSelAmc.urlAmc.typeConv;
        return _callAnnuaireToFindUrlAmcAndSaveIt(appelSelAmcParamsCLC).always(() => {
          dfd.resolve({
            appelSelAmcParams: resultAppelSelAmc,
            listUrlAmcAndParamsToSave
          });
        });
      } else {
        dfd.resolve({
          appelSelAmcParams: resultAppelSelAmc,
          listUrlAmcAndParamsToSave
        });
      }
    }, echec => {
      if (tryFindConvHtp) {
        //en cas d'echec de recherche de convention TP, on tente une recherche de convention HTP
        return _callAnnuaireToFindUrlAmcAndSaveIt(appelSelAmcParamsFHP).then(resultAppelSelAmc => {
          dfd.resolve({
            appelSelAmcParams: resultAppelSelAmc,
            listUrlAmcAndParamsToSave
          });
        }, () => {
          dfd.reject(echec);
        });
      } else {
        dfd.reject(echec);
      }
    });
    return dfd.promise();
  }

  /**
   * Appel à l'annuaire AMC (FSVCall)
   * Et sauvegarde de l'url (ou la convention) en BDD
   *
   * @param idFactCle
   * @returns {*}
   * @private
   */
  function _callAnnuaireToFindUrlAmcAndSaveIt(appelSelAmcParams) {
    //les paramètres d'appel vers le service d'annuaire sont fournit dans l'objet urlAMC
    //l'objet urlAMC est passé directement à la commande "fsvcall"
    let def = $.Deferred();
    let modeCnda = true; //TODO  à changer en parametre dans appelSelAmcParams
    cbaLink.services.fsvcall.getUrlServiceAMC(modeCnda, appelSelAmcParams.urlAmc, appelSelAmcParams.annuaireAgreementSiteVersion, appelSelAmcParams.ordonnanceId).then(exMsg => {
      if (exMsg.erreurApi != 0 || exMsg.erreurGlobale != 0) def.reject(exMsg);else {
        //une liste d'url est retournée dans exMsg.message
        // Récupération des données:
        let jsonResult = exMsg.message;
        let listeUrlAMC = JSON.parse(jsonResult);
        //à sauvegarder en cache le résultat de l'appel à l'annuaire et ses parametres d'appel
        listUrlAmcAndParamsToSave.push({
          listeUrlAMC,
          paramAppelAnnuaireToSave: appelSelAmcParams?.urlAmc
        });
        //_appelSaveListeUrlAmc(paramAppelAnnuaire, listeUrlAMC); // TODO should save the annuaire url amc in backend cash
        //TODO gerer si on est en facturation, on veut une seule url possible, sinon erreur
        if (listeUrlAMC.length === 1) {
          const selectedUrl = listeUrlAMC[0];
          delete selectedUrl.executingTime;
          appelSelAmcParams.urlAmc = selectedUrl; // this.serviceAmcSelected;
          def.resolve(appelSelAmcParams);
        } else if (listeUrlAMC.length > 1) {
          // plusieurs url possibles, il faut faire un choix //
          return window.showUrlSelectDialog(listeUrlAMC).then(selectedUrl => {
            if (selectedUrl) {
              delete selectedUrl.executingTime;
              appelSelAmcParams.urlAmc = selectedUrl; // this.serviceAmcSelected;
              def.resolve(appelSelAmcParams);
            } else {
              def.reject("selection invalide");
            }
          }, error => {
            def.reject(error);
          });
        } else {
          const errMsg = "l'annuaire AMC ne retourne aucun service pour cette mutuelle";
          def.reject({
            code: "errServiceAnnuaireNotFound",
            message: errMsg,
            originalError: errMsg
          });
        }
      }
    }, error => {
      def.reject(error);
    });
    return def.promise();
  }
  function _verifParams(...params) {
    params.forEach(param => {
      if (isUndefinedOrNull(param.value)) {
        throw new Error(`${param.name} can't be null or undefined.`);
      }
    });
  }
  function _isError(response) {
    return response.returnAction && response.returnAction === 'error';
  }
  exports.selAmcService = new SELAMCService();
})(cbaLink.services);

/***/ }),

/***/ "./projects/lib-agathe-link/js/TlaCommunicationController.js":
/*!*******************************************************************!*\
  !*** ./projects/lib-agathe-link/js/TlaCommunicationController.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

const $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
const EmotionGenDialog = __webpack_require__(/*! ./EmotionGenDialog */ "./projects/lib-agathe-link/js/EmotionGenDialog.js");

//definition d'un module pour la communication avec le TLA via ce qu'ona appelé la partie lib fsvemotionlink
const mokLogTra = __webpack_require__(/*! ./logtra */ "./projects/lib-agathe-link/js/logtra.js");
const logTra = new mokLogTra();
__webpack_require__(/*! ./MessagesAgatheyou */ "./projects/lib-agathe-link/js/MessagesAgatheyou.js");
(function (exports) {
  {
    var baseUrl = "";
    var _self;
    TlaCommunicationController.prototype.checkEmotionLinkAndLecteurConnected = checkEmotionLinkAndLecteurConnected;
    TlaCommunicationController.prototype.showDialogAideDemarrageAgatheLink = showDialogAideDemarrageAgatheLink;
    TlaCommunicationController.prototype._connectEmotionlink = _connectEmotionlink;
    TlaCommunicationController.prototype._deselectAllLecteurs = _deselectAllLecteurs;
    TlaCommunicationController.prototype._redetecteLecteur = _redetecteLecteur;
    TlaCommunicationController.prototype._readManualConfigurationGalss = _readManualConfigurationGalss;
    TlaCommunicationController.prototype._selectLecteurConnectedWithPromise = _selectLecteurConnectedWithPromise;
    TlaCommunicationController.prototype._searchLecteurConnecte = _searchLecteurConnecte;
    TlaCommunicationController.prototype._runTestAccesAllLecteursPromise = _runTestAccesAllLecteursPromise;
    TlaCommunicationController.prototype._runTestAccesAllLecteurs = _runTestAccesAllLecteurs;
    TlaCommunicationController.prototype.saveLecteurSelectedWithPromise = saveLecteurSelectedWithPromise;
    TlaCommunicationController.prototype.resetController = resetController;
    function hideDialog(idDialog) {
      cbaLink.services.frontend.hideDialog(idDialog);
    }
    function showDialog(idDialog, errMessage) {
      cbaLink.services.frontend.showDialog(idDialog, errMessage);
    }
    function TlaCommunicationController() {
      logTra.debug("MODULE : TlaCommunicationController");
      _self = this;
      this.galssChecked = false;
      this.tlaPortComChecked = false;
      this.listeLecteurs = [{
        numero: null,
        port: null,
        ressourceLecteur: null
      }];
      this.switchNextError = false;
      this.ressourceCpsK300 = 'Kapelse CCID Interface slot0 0';
      this.ressourceVitaleK300 = 'Kapelse CCID Interface slot1 0';
      this.ressourceCpsEskapad = /^KAPELSE [0-9]* TL eS-KAP-Ad 1 0/; // expression regulière pour déterminé si une ressource  PCSC est un slot de lecteur Eskapad contenant une CPS. Attention, dans le cas de l'eskapad, le numero de serie du lecteur est dans le nom de la ressource
      this.ressourceVitaleEskapad = /^KAPELSE [0-9]* TL eS-KAP-Ad 2 0/; //expression regulière pour déterminé si une ressource  PCSC est un slot de lecteur Eskapad contenant une carte Vitale

      this.enumErrDetectionLecteur = {
        errConnectEL: {
          code: "errConnectEL",
          libelle: "EmotionLink - AgatheLink n'est peut-être pas démarré"
        },
        errDetecteLecteurEL: {
          code: "errDetecteLecteurEL",
          libelle: "Les composants du poste de travail sont peut-être mal installés"
        },
        errReadGalss: {
          code: "errReadGalss",
          libelle: "Erreur de lecture de la configuration des lecteurs"
        },
        errAucunLecteurAvecCPS: {
          code: "errAucunLecteurAvecCPS",
          libelle: cbaLink.uitools.messages.tlaCommunicationController.enumErrDetectionLecteur.errAucunLecteur()
        },
        errAucunLecteur: {
          code: "errAucunLecteur",
          libelle: cbaLink.uitools.messages.tlaCommunicationController.enumErrDetectionLecteur.errAucunLecteur()
        },
        errMajRequise: {
          code: "errMajRequise",
          libelle: "Mise à jour nécessaire"
        }
      };
    }
    function resetController() {
      this.listeLecteurs = [];
      this.tlaPortComChecked = false;
      this.galssChecked = false;
    }
    function addLecteurToListeLecteurs(numero, port, ressourceLecteur) {
      let lecteur = {};
      lecteur.numero = numero;
      lecteur.port = port;
      lecteur.ressourceLecteur = ressourceLecteur ? ressourceLecteur : null; //Pour un lecteur PCSC, ressourcelecteur n'est pas défini
      this.listeLecteurs.push(lecteur);
    }
    function _runTestAccesAllLecteursPromise(idx, findLecteurWithCps) {
      let dfdAllLecteur = $.Deferred();
      this._runTestAccesAllLecteurs(idx, dfdAllLecteur, findLecteurWithCps);
      return dfdAllLecteur.promise();
    }
    function _runTestAccesAllLecteurs(idx, dfdAllLecteur, findLecteurWithCps) {
      if (idx < this.listeLecteurs.length) {
        let lecteur = this.listeLecteurs[idx];
        let _ressourceCps = lecteur.type == 'PCSC' ? null : lecteur.ressourceCps;
        if (findLecteurWithCps) {
          cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_CPS_READINFOSCARTE, _ressourceCps == null ? null : cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + _ressourceCps, null).then(exMsg => {
            if (exMsg.erreurApi !== 0) {
              //pas le bon lecteur
              idx++;
              this._runTestAccesAllLecteurs(idx, dfdAllLecteur, findLecteurWithCps);
            } else {
              //lecteur pcsc ou pss avec cps presente
              dfdAllLecteur.resolve(lecteur);
            }
          });
        } else {
          //recherche lecteur sans CPS
          let parametre = null;
          let isAgatheYou = cbaLink.services.frontend.isClientProfilAgatheyou();
          let lecteurTlaExists = this.listeLecteurs.filter(lec => lec.type == "TLA").length > 0;
          //let lecteurPcscExists = this.listeLecteurs.filter( ()=>{ return this.type=='PCSC' }).length>0;

          if (lecteur.type == 'PCSC' && isAgatheYou) {
            //par défaut sur agathe you si un lecteur PCSC est trouvé, on le selectionne (cas sans CPS uniquement)
            dfdAllLecteur.resolve(lecteur);
          }
          if (lecteur.type == 'PCSC' && !lecteurTlaExists) {
            // si un lecteur PCSC est trouvé et qu'il n'y a pas de lecteur de type TLA/PSS, on le selectionne (cas sans CPS uniquement)
            dfdAllLecteur.resolve(lecteur);
          } else {
            if (lecteur.type == 'TLA') {
              //ressource lecteur est défini : on est sur un lecteur PSS, il fait définir la ressource
              parametre = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + lecteur.ressourceLecteur;
              cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_LIREDATELECTEUR, parametre, null).then(exMsg => {
                if (exMsg.erreurApi !== 0) {
                  //pas le bon lecteur
                  idx++;
                  this._runTestAccesAllLecteurs(idx, dfdAllLecteur, findLecteurWithCps);
                } else {
                  //un lecteur sans cps present
                  dfdAllLecteur.resolve(lecteur);
                }
              });
            } else {
              //pas le bon lecteur
              idx++;
              this._runTestAccesAllLecteurs(idx, dfdAllLecteur, findLecteurWithCps);
            }
          }
        }
      } else {
        //pas de lecteur trouvé
        dfdAllLecteur.reject();
      }
    }
    function checkEmotionLinkAndLecteurConnected(forcage = false) {
      if (forcage) {
        this.resetController();
      }
      showDialog("dialogAccesLecteur");
      logTra.debug("checkEmotionLinkAndLecteurConnected - " + this.galssChecked);
      let dfd = $.Deferred();
      this._connectEmotionlink().then(success => {
        return this._redetecteLecteur(!forcage);
      }, err => {
        logTra.debug("Echec _connectEmotionlink , EmotionLink - AgatheLink pas démarré ?");
        return dfd.reject(this.enumErrDetectionLecteur.errConnectEL);
      }).then(success => {
        if (forcage || cbaLink.environment.ressourceCps === undefined || cbaLink.environment.ressourceCps === null || cbaLink.environment.ressourceVitale === undefined || cbaLink.environment.ressourceVitale === null) {
          return this._readManualConfigurationGalss();
        } else {
          return $.Deferred().resolve(); //hors cas de forcage et ressources cps définie, pas besoin de relire la configuation galss -> optimisation
        }
      }, err => {
        if (err === this.enumErrDetectionLecteur.errMajRequise) {
          return dfd.reject(err);
        }
        //EmotionLink - AgatheLink pas démarré
        logTra.debug("Echec redetecteLecteur , EmotionLink - AgatheLink composant du poste de travail mal installés ?");
        return dfd.reject(this.enumErrDetectionLecteur.errDetecteLecteurEL);
      }).then(success => {
        if (forcage || cbaLink.environment.ressourceCps === undefined || cbaLink.environment.ressourceCps === null) {
          //Lit la liste des lecteurs, choisit le premier lecteur avec une cps
          return this._selectLecteurConnectedWithPromise(true);
        } else {
          return $.Deferred().resolve(); //hors cas de forcage et ressources cps définie, pas besoin de relire la configuation galss -> optimisation
        }
      }, err => {
        //Erreur de lecture de la conf Galss
        logTra.debug("Echec readManualConfigurationGalss");
        return dfd.reject(this.enumErrDetectionLecteur.errReadGalss);
      }).then(success => {
        // un lecteur a été trouvé avec une cps, on continue la suite du process
        return success;
      }, err => {
        //Erreur ou pas de lecteur avec CPS touvé, on refait une recherche de lecteur (TLA) sans CPS (Lire Date lecteur)

        if (err == this.enumErrDetectionLecteur.errAucunLecteurAvecCPS) {
          logTra.debug("Aucun lecteur avec CPS trouvé, on recherche sans CPS");
          //Lit la liste des lecteurs, choisit celui qui marche et les mets en session
          return this._selectLecteurConnectedWithPromise(false);
        } else return dfd.reject(err); //propage l'erreur
      }).then(() => {
        hideDialog("dialogAccesLecteur");
        return dfd.resolve();
      }, err => {
        //Pas de lecteur connecté
        logTra.debug("Echec _selectLecteurConnectedWithPromise, pas de lecteur connecté");
        hideDialog("dialogAccesLecteur");
        this._deselectAllLecteurs();
        if (err === this.enumErrDetectionLecteur.errMajRequise) {
          //on n'afffiche pas l'erreur, on va faire la maj EL
          dfd.reject(err);
        } else if (err === this.enumErrDetectionLecteur.errConnectEL) {
          //on n'afffiche pas l'erreur, elle est traitée en vidéo
          dfd.reject(err);
        } else if (err && err.libelle) {
          dfd.reject(err);
        } else {
          showDialog("dialogError", err, undefined, undefined, undefined, undefined, undefined, undefined, () => dfd.reject(err));
        }
      });
      return dfd.promise();
    }
    function _deselectAllLecteurs() {}
    function _connectEmotionlink() {
      let promise = $.Deferred();

      // Connection à EmotionLink - AgatheLink nécéssaire
      if (cbaLink.services.fsvlink.fsvConnect(true)) {
        //la connexion a EmotionLink - AgatheLink est établie
        promise.resolve();
      } else {
        //la connexion à EmotionLink - AgatheLink à échoué
        //on affiche la video d'aide à la connexion
        this.showDialogAideDemarrageAgatheLink(promise);
      }
      return promise;
    }

    //la connexion à EmotionLink - AgatheLink à échoué
    //on affiche la video d'aide à la connexion
    function showDialogAideDemarrageAgatheLink(dfd) {
      //cas particulier : Si OS trop ancien on ne propose pas la MAJ
      let osInformation = cbaLink.services.fsvlink.getOsInformations();
      if (osInformation.osName == "Macintosh") {
        if (osInformation.majorVersion < 10 || osInformation.majorVersion == 10 && osInformation.minorVersion < 14
        //||  (osInformation.majorVersion==10 && osInformation.minorVersion==13 && osInformation.releaseVersion<6 )
        ) {
          cbaLink.tla.controllers.tlaCommunicationController.showDialogDemarreEmotionLink().done(() => dfd.resolve()).fail(() => dfd.reject());
        } else {
          cbaLink.services.frontend.callService('isMajAgatheLinkMacForcee', null).then(data => {
            if (data.returnAction === "success") {
              hideDialog("dialogAccesLecteur");
              cbaLink.tla.controllers.tlaMajAgatheLinkController.displayGuideMajAgatheLink(data.returnMessage).always(() => dfd.reject());
            } else {
              cbaLink.tla.controllers.tlaCommunicationController.showDialogDemarreEmotionLink().done(() => dfd.resolve()).fail(() => dfd.reject());
            }
          });
        }
      } else {
        showDialogDemarreEmotionLink().done(() => dfd.resolve()).fail(err => dfd.reject(err));
      }
    }

    /**
     * Lance une détection des lecteurs sur AgatheLink (lecture Galls.ini + recherche lecteurs PCSC)
     * Retourne une promesse.
     *
     * @param skipIt ignore l'étape recherche de lecteur, si actif alors la promesse est réolue avec succes systématiquement
     * @returns {jQuery|{}} une promesse
     * @private
     */
    function _redetecteLecteur(skipIt) {
      let promise = $.Deferred();
      if (skipIt) {
        promise.resolve('continue');
      } else {
        //reset des parametres d'acces au lecteur
        cbaLink.environment.ressourceCps = undefined;
        cbaLink.environment.ressourceVitale = undefined;
        cbaLink.environment.ressourceLec = undefined;
        cbaLink.environment.typeLec = undefined;
        cbaLink.services.fsvcall.redetectTla().then(exMsg => {
          promise.resolve('continue');
        }, error => {
          if (error === undefined || error === this.enumErrDetectionLecteur.errMajRequise) {
            promise.reject(this.enumErrDetectionLecteur.errMajRequise);
          }
          promise.reject('erreur detection lecteur');
        });
      }
      return promise;
    }

    /**
     * WEBSOCKET compliant. Demande de lecture manuelle de la configuration Galss/lecteurs
     */
    function _readManualConfigurationGalss() {
      logTra.debug("readManualConfigurationGalss");
      let dfd = $.Deferred();
      if (this.galssChecked) {
        dfd.resolve();
      }

      // Chargement de fsv link nécéssaire
      if (!cbaLink.services.fsvcall.chargeFsvLink_Basic(true)) {
        dfd.reject();
      }
      cbaLink.services.fsvcall.readConfigurationGalss().then(exMsg => {
        if (exMsg.erreurGlobale === -1) {
          dfd.reject("Configuration Galss incorrecte ou introuvable");
        }
        if (exMsg.erreurApi !== 0) {
          const erreur = cbaLink.services.fsvcall.traiteErreurApi(exMsg.erreurApi, exMsg.message);
          logTra.debug("Erreur FSV : " + erreur);
          dfd.reject(erreur);
        }

        // Action qui traite la configuration récupérée
        let content = [];
        content['configurationGalssData'] = exMsg.message;

        // traduitConfigurationGalss().then((data)=> {
        const data = cbaLink.services.frontend.traduitConfigurationGalss(content);
        if (data.returnAction === "success") {
          this.galssChecked = true;
          this.listeLecteurs = data.strJsonLecteurs;
          dfd.resolve();
        } else {
          this.galssChecked = false;
          dfd.reject(data.returnMessage);
        }
        // {"numero":1,"port":1,"type":"TLA","ressourceCps":"CPS11","ressourceVitale":"Vit11","ressourceLecteur":"Log11"},{"numero":2,"port":1,"type":"PCSC","nomLecteur":"Kapelse CCID","ressourceCps":"Kapelse CCID Interface slot0 0","ressourceVitale":"Kapelse CCID Interface slot1 0"}

        // cbaLink.services.frontend.callService('/common/readConfigurationGalss', content).then((data)=> {
        //
        //     if (data.returnAction === "success") {
        //         this.galssChecked = true;
        //         this.listeLecteurs =  JSON.parse(data.strJsonLecteurs);
        //         dfd.resolve();
        //     } else {
        //         this.galssChecked = false;
        //         dfd.reject(data.returnMessage);
        //     }
        //
        // }, (error)=> {
        //     this.galssChecked = false;
        //     dfd.reject(data.returnMessage);
        // });
      });

      return dfd.promise();
    }
    function _selectLecteurConnectedWithPromise(findLecteurWithCps) {
      logTra.debug("_selectLecteurConnectedWithPromise");
      let dfd = $.Deferred();
      if (findLecteurWithCps && cbaLink.environment.ressourceCps && this.tlaPortComChecked) {
        //test du lecteur qui doit marcher
        cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_CPS_READINFOSCARTE, cbaLink.environment.ressourceCps == null ? null : cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps, null).then(exMsg => {
          if (exMsg.erreurApi !== 0) {
            //recherche du bon lecteur
            this._searchLecteurConnecte(dfd, findLecteurWithCps);
          } else {
            //si c'est ok on le garde
            dfd.resolve();
          }
        });
      } else if (!findLecteurWithCps && cbaLink.environment.ressourceLec && this.tlaPortComChecked) {
        //test du lecteur qui doit marcher
        cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_LIREDATELECTEUR, cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceLec, null).then(exMsg => {
          if (exMsg.erreurApi !== 0) {
            //recherche du bon lecteur
            this._searchLecteurConnecte(dfd, findLecteurWithCps);
          } else {
            //si c'est ok on le garde
            dfd.resolve();
          }
        });
      } else {
        this._searchLecteurConnecte(dfd, findLecteurWithCps);
      }
      return dfd.promise();
    }
    function _searchLecteurConnecte(dfd, findLecteurWithCps) {
      logTra.debug("recupereLeBonTla");
      this._runTestAccesAllLecteursPromise(0, findLecteurWithCps).then(lecteur => {
        return this.saveLecteurSelectedWithPromise(lecteur.numero, dfd);
      }, () => {
        logTra.debug("pas de lecteur trouvé");
        this.tlaPortComChecked = false;
        dfd.reject(findLecteurWithCps ? this.enumErrDetectionLecteur.errAucunLecteurAvecCPS : this.enumErrDetectionLecteur.errAucunLecteur);
      });
    }
    function saveLecteurSelectedWithPromise(numeroLecteur, dfd) {
      logTra.debug("saveLecteurSelected (" + numeroLecteur + ")");
      let contentArray = new Array();
      contentArray['numeroLecteurSelected'] = numeroLecteur;

      // cbaLink.services.frontend.callService('/common/lecteurSelection', contentArray).then((data)=> {
      //     if (data.returnAction === "success") {
      if (this.listeLecteurs) {
        let tla = null;
        for (i = 0; i < this.listeLecteurs.length; i++) {
          if (this.listeLecteurs[i].numero == numeroLecteur) {
            tla = this.listeLecteurs[i];
          }
        }
        if (tla) {
          //Log TODO mettre en message
          cbaLink.environment.typeLec = tla.type == 'PCSC' ? 'P' : 'T';
          if (cbaLink.environment.typeLec === 'T') {
            //Lecteur de type TLA en mode PSS
            cbaLink.environment.ressourceCps = tla.ressourceCps;
            cbaLink.environment.ressourceVitale = tla.ressourceVitale;
            cbaLink.environment.ressourceLec = tla.ressourceLecteur;
          } else {
            //Lecteur de type PCSC

            //par défaut, on met les ressources à null = versino non opitimisé et detection auto des ressources par les FSV
            // = fonctionnement historique
            cbaLink.environment.ressourceCps = null;
            cbaLink.environment.ressourceVitale = null;
            cbaLink.environment.ressourceLec = null; //dans le cas des lecteurs PCSC la ressource lecteur est renseignée soit avec le nom du slot CPS soit avec le nom du slot C-Vitale. Dépend de la fonction SSV appelée.

            //Optimisation du nom des ressources
            //2 cas possible suivant la version de AgatheLink

            //Cas 1  Agathelink 1.19 ou supérieur

            if (tla.ressourceCps && tla.ressourceVitale) {
              //Cas 1.a -> CPS et Vitale présentes, les ressources CPS et Vitale sont renseignées par AgatheLink
              cbaLink.environment.ressourceCps = tla.ressourceCps;
              cbaLink.environment.ressourceVitale = tla.ressourceVitale;
            } else if (tla.ressourceCps) {
              //Cas 1.b -> CPS présente et CV absente, seule la ressource CPS est renseignées par AgatheLink
              cbaLink.environment.ressourceCps = tla.ressourceCps;
              if (cbaLink.environment.ressourceCps === this.ressourceCpsK300) {
                //il s'agit d'un lecteur K300, on connait le nom de la ressource Vitale, on le renseigne
                cbaLink.environment.ressourceVitale = this.ressourceVitaleK300;
              } else if (this.ressourceCpsEskapad.test(cbaLink.environment.ressourceCps)) {
                //il s'agit de la ressource CPS d'un lecteur Eskapad, le nom de la ressource Vitale peut etre construit à partir du nom de la ressource CPS :
                cbaLink.environment.ressourceVitale = cbaLink.environment.ressourceCps.replace('eS-KAP-Ad 1 0', 'eS-KAP-Ad 2 0');
              }
            } else if (tla.ressourceVitale) {
              //Cas CPS Absente mais Vitale présente

              cbaLink.environment.ressourceVitale = tla.ressourceVitale;
              if (cbaLink.environment.ressourceVitale === this.ressourceCpsK300) {
                //il s'agit d'un lecteur K300, on connait le nom de la ressource CPS, on le renseigne
                cbaLink.environment.ressourceCps = this.ressourceCpsK300;
              } else if (this.ressourceVitaleEskapad.test(cbaLink.environment.ressourceVitale)) {
                //il s'agit de la ressource Vitale d'un lecteur Eskapad, le nom de la ressource CPS peut etre construit à partir du nom de la ressource Vitale :
                cbaLink.environment.ressourceCps = cbaLink.environment.ressourceVitale.replace('eS-KAP-Ad 2 0', 'eS-KAP-Ad 1 0');
              }
            }
          }
          cbaLink.environment.numeroSerieLec = tla.numeroSerie;
          cbaLink.environment.versionCDCSV = "SV140800"; // data.versionCDCSV; debugjeje .. fourni par le back

          this.tlaPortComChecked = true;
          dfd.resolve();
        } else {
          this.tlaPortComChecked = false;
          dfd.reject(data.returnMessage);
        }
      } else {
        this.tlaPortComChecked = false;
        dfd.reject(data.returnMessage);
      }
      // }, (err)=> {
      //     this.tlaPortComChecked = false;
      //     dfd.reject(err);
      // });
    }

    function showDialogDemarreEmotionLink() {
      let dfd = $.Deferred();
      let osInformation = cbaLink.services.fsvlink.getOsInformations();
      let path = "emotionlink/" + osInformation.osName;
      if (osInformation.osName === "Window" && osInformation.majorVersion < 8) {
        path = "emotionlink/" + osInformation.osName + "/7";
      }
      // STATS GOOGLE ANALYTICS

      this.switchNextError = false;
      dfd.reject(""); //on pourrait attendre qu'EmotionLink - AgatheLink soit démarré, comme dans le cas de la vidéo

      return dfd.promise();
    }
    function _displayVideoDemarrageAgatheLink(communication, dfd) {
      let dialog = new EmotionGenDialog();
      dialog.setTitle(cbaLink.ui.tools.messages.tlaCommunicationController.displayVideoDemarrageAgatheLink.titre(communication.titre));
      dialog.setWidth("1000px");
      let content = cbaLink.ui.tools.messages.tlaCommunicationController.displayVideoDemarrageAgatheLink.content(communication.contenu);
      dialog.hideOkButton();
      dialog.hideCancelButton();
      dialog.setCancelCallback(() => {});
      dialog.setHideCallback(() => {
        cbaLink.tla.controllers.tlaCommunicationController.switchNextErrorDemarreEmotionLink();
      });
      if (communication.type === "Video") {
        let parent = document.getElementById("dialogGenMsg");
        parent.innerHTML = "";
      }
      dialog.show(content);
      this._checkStatutEmotionLink(dialog, dfd); // la promesse sera resolue ou rejeté en fonction de l'etat d'EmotionLink - AgatheLink
    }

    function _checkStatutEmotionLink(dialog, dfd) {
      logTra.debug("_checkStatutEmotionLink");
      let compteur = 0; //passe au moins 10 fois dans la boucle (= 100 sec) pour etre sure d'afficher et le message et etre sure qu'EL ce soit fermé
      let processingLoop = false;
      let boucle = window.setInterval(() => {
        if (!processingLoop) {
          processingLoop = true;
          logTra.debug("fsvConnect()");
          // au bout de 1 mintute, il faut l'arreter
          if (compteur > 12 || this.switchNextError) {
            dialog.hide();
            let baseUrl = cbaLink.services.fsvcall.getUrlBase();
            let diagOups = new EmotionGenDialog();
            diagOups.setTitle(cbaLink.ui.tools.messages.tlaCommunicationController.checkStatutEmotionLink.titre());
            diagOups.hideOkButton();
            diagOups.hideCancelButton();
            diagOups.setHideCallback(() => {
              if (dfd) {
                dfd.reject();
              }
              if (document.getElementById("dialogPreload")) {
                cbaLink.ui.tools.waitingDialog.hideManual();
              }
              hideDialog("dialogWaitingSmartFacturation");
              hideDialog("dialogError");
            });
            diagOups.show(cbaLink.ui.tools.messages.tlaCommunicationController.checkStatutEmotionLink.message(baseUrl));
            window.clearInterval(boucle);

            //Si c'est ok => EmotionLink - AgatheLink est lancé => c'est terminé
          } else if (cbaLink.services.fsvlink.fsvConnect(true)) {
            window.clearInterval(boucle);
            dialog.hide();
            if (dfd) {
              dfd.resolve();
            }
          } else {
            //On attend la prochaine boucle
            compteur += 1;
          }
          processingLoop = false;
        }
      }, 5000 //relancer la fonction toute les 5 sec
      );
    }

    function switchNextErrorDemarreEmotionLink() {
      // STATS GOOGLE ANALYTICS
      cbaLink.services.analytics.sendEvent(cbaLink.services.analytics.events.ACCES_LECTEUR_ERREUR, 'fermer-video-emotionlink');
      //on positionne la variable a true pour éviter le temps d'attente
      this.switchNextError = true;
    }
  }
  exports.tlaCommunicationController = new TlaCommunicationController();
})(cbaLink.controllers);

/***/ }),

/***/ "./projects/lib-agathe-link/js/cbaservice.js":
/*!***************************************************!*\
  !*** ./projects/lib-agathe-link/js/cbaservice.js ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
const cbaservice = function () {
  var baseUrl = "";
  var _self;
  function cbaservice() {
    console.log("MODULE : cbaservice");
    _self = this;
  }
  cbaservice.prototype.callService = callService;
  function callService(txt, txt2) {
    const d = $.Deferred();
    setTimeout(function () {
      const v = {
        returnAction: "SUCCESS"
      };
      d.resolve(this);
    }, 500);
    return d;
  }
  return cbaservice;
}();
module.exports = cbaservice;

/***/ }),

/***/ "./projects/lib-agathe-link/js/frontend.js":
/*!*************************************************!*\
  !*** ./projects/lib-agathe-link/js/frontend.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

const $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
const mokLogTra = __webpack_require__(/*! ./logtra */ "./projects/lib-agathe-link/js/logtra.js");
const EmotionGenDialog = __webpack_require__(/*! ./EmotionGenDialog */ "./projects/lib-agathe-link/js/EmotionGenDialog.js");
const logTra = new mokLogTra();
(function (exports) {
  var baseUrl = "";
  var _self;
  function Frontend() {
    logTra.debug("MODULE : frontend");
    _self = this;
  }
  var _IInternal = {
    // routerAlreadyRegistered: _routerAlreadyRegistered,
    // checkInformationClient: _checkInformationClient,
    // checkCommunicationFormation: _checkCommunicationFormation,
    ClientDroit: {
      Ps: 1,
      Secretaire: 2,
      Remplacant: 3,
      Remplacant_Sans_Acces_Donnees: 4,
      Hotliner: 70,
      OperateurRemede: 71,
      Marketing: 60,
      SuperAdmin: 99
    },
    EnumClientFunctionnalite: {
      Adri: 'Adri',
      INSi: 'INSi',
      SelAmcPatient: 'SelAmcPatient',
      SelAmcOrdonnance: 'SelAmcOrdonnance',
      SelAmcFacturation: 'SelAmcFacturation',
      SelAmcDegradee: 'SelAmcDegradee',
      FactureDetaillee: 'FactureDetaillee',
      Dmp: 'Dmp',
      SmartFacturation: 'SmartFacturation',
      SmartCotation: 'SmartCotation',
      PaiementGaranti: 'PaiementGaranti',
      ExpertiseCompta: 'ExpertiseCompta',
      ComptaClassique: 'ComptaClassique',
      TableauDeBord100Pour100Payees: 'TableauDeBord100Pour100Payees',
      DechargementFsePdtPartiel: 'DechargementFsePdtPartiel',
      BudgetInsight: 'BudgetInsight',
      TlsiWithCnda: 'TLSiWithCnda',
      TeletransmissionWithCnda: 'TeletransmissionWithCnda',
      DmpAlimentation: 'DmpAlimentation',
      ChatHotlineFormation: 'ChatHotlineFormation',
      AppliCarteVitale: 'AppliCarteVitale',
      ChatHotlineFormation: 'ChatHotlineFormation',
      DossierSoinsAvance: 'DossierSoinsAvance',
      AdrInterAMCObligatoire: 'AdrInterAMCObligatoire',
      ResiliationPaiementGaranti: 'ResiliationPaiementGaranti',
      ResiliationExpertiseCompta: 'ResiliationExpertiseCompta'
    },
    EnumClientStatut: {
      NORMAL: 1,
      NOUVEAU: 2,
      VIP: 3,
      PROSPECT: 4
    },
    OrigineCreation: {
      EM_WEB: '1',
      // Création de l'ordonnance sur le poste de travail
      EM_WEB_TLA: '2',
      // Création de l'ordonnance sur le TLA
      EM_WEB_TLA_SERIE: '3',
      // Création de l'ordonnance sur le TLA en préparation série
      EM_WEB_MIG_AC: '4',
      //Création de l'ordonnance sur Agathe Connect
      EM_WEB_MIG_AC_CORRIGEE: 'X',
      //Création de l'ordonnance sur Agathe Connect - corrigée via WS corrigeOrdonnance
      EM_MOB: '5',
      //Création de l'ordonnance sur le mobile - application CBA / application Agathe Emotion
      AY_WEB: 'A',
      // Création de l'ordonnance sur Agathe You logiciel
      AY_MOB: 'B' // Création de l'ordonnance sur Agathe You Mobile
    }
  };

  Frontend.prototype.callService = callService;
  Frontend.prototype.traduitConfigurationGalss = traduitConfigurationGalss;
  Frontend.prototype.showDialog = showDialog;
  Frontend.prototype.hideDialog = hideDialog;
  Frontend.prototype.EnumClientFunctionnalite = _IInternal.EnumClientFunctionnalite;
  Frontend.prototype.ClientDroit = _IInternal.ClientDroit;
  Frontend.prototype.isClientProfilAgatheyou = isClientProfilAgatheyou;
  Frontend.prototype.hasFonctionnalite = hasFonctionnalite;
  Frontend.prototype.getIdFactCle = getIdFactCle;
  Frontend.prototype.repertoireProfil = repertoireProfil;
  Frontend.prototype.repertoireImgCommon = repertoireImgCommon;
  async function callFrontendWebService(calledUrl, paramJson) {
    localStorage.getItem("authToken");
    localStorage.getItem("server");
    var options = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Origin': '',
        'Authorization': 'Bearer ' + localStorage.getItem("authToken"),
        'Host': 'api.producthunt.com'
      },
      body: paramJson
    };
    return await fetch(localStorage.getItem("server") + calledUrl, options);
  }
  function callService(calledFunction, paramJson) {
    console.log("MODULE : frontend-callService " + calledFunction);
    if (paramJson) {
      console.log(paramJson);
    }
    const d = $.Deferred();
    if (calledFunction == "getPatientIdentiteByIdPatient") {
      return callFrontendWebService('patients/' + calledFunction, paramJson);
    } else if (calledFunction == "consulterADR") {
      return callFrontendWebService('patients/' + calledFunction, paramJson);
    } else if (calledFunction == "/common/getVersionEmotionLinkRequise") {
      d.resolve({
        listeComposantsFsvToUpdateJson: null,
        returnAction: "success",
        returnMessage: null,
        versionRequise: null
      });
    } else if (calledFunction == "/common/traceCnda") {
      d.resolve({
        returnAction: "success"
      });
    } else {
      setTimeout(function () {
        d.resolve({
          returnAction: "success"
        });
      }, 1000);
    }
    return d;
  }
  function getIdFactCle() {
    //debugjeje
    return '006082093';
  }
  function isClientProfilAgatheyou() {
    return true;
  }
  function hasFonctionnalite() {
    return true;
  }
  function repertoireProfil() {
    return "/profile/";
  }
  function repertoireImgCommon() {
    return "/common/";
  }

  // cette fonction permet de traduire les infos pour remplacer l'appel au back
  function traduitConfigurationGalss(content) {
    console.log(content);
    var myObject = JSON.parse(content.configurationGalssData);
    return {
      returnAction: "success",
      strJsonLecteurs: myObject.lecteurs
    };
  }
  function hideDialog() {}
  function showDialog(idDialog, message) {}
  exports.frontend = new Frontend();
})(cbaLink.services);

/***/ }),

/***/ "./projects/lib-agathe-link/js/fsvemotioncalls.1.0.js":
/*!************************************************************!*\
  !*** ./projects/lib-agathe-link/js/fsvemotioncalls.1.0.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

const $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
const mokLogTra = __webpack_require__(/*! ./logtra */ "./projects/lib-agathe-link/js/logtra.js");
const logTra = new mokLogTra();
__webpack_require__(/*! ./fsvemotionlink.1.0 */ "./projects/lib-agathe-link/js/fsvemotionlink.1.0.js");
__webpack_require__(/*! ./frontend */ "./projects/lib-agathe-link/js/frontend.js");
__webpack_require__(/*! ./TlaCommunicationController */ "./projects/lib-agathe-link/js/TlaCommunicationController.js");

//ECMA6 : un fix de Internet Explorer dans le scope global tel que proposé dans MDN
if (!String.prototype.endsWith) {
  Object.defineProperty(String.prototype, 'endsWith', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: function (searchString, position) {
      position = position || this.length;
      position = position - searchString.length;
      var lastIndex = this.lastIndexOf(searchString);
      return lastIndex !== -1 && lastIndex === position;
    }
  });
}

/**
 * Objet de gestion de loop asynchrone
 *
 * La boucle est créé par défaut sans couplage avec un autre élément. Elle PEUT être attachée à un tableau qui représente l'avancement de la
 * boucle sur ce contenu de tableau. Dans ce cas il est de la responsabilité du développeur de ne pas transformer la structure de ce tableau
 * référence pendant le parcours de la boucle.
 *
 * L'utilisation de la LOOP est :
 *
 * STEP : indique l'index de la boucle. Démarre à 0 .
 *
 * DONE : renseigne que le step actuel est terminée. Incrémente le step.
 *
 * ISDONE : indique si le STEP actuel a été marqué comme terminée
 *
 * ATTACH (optionnel): couple la boucle à un tableau, pour indiquer la fin de traitement
 *
 * GETITEM (optionnel) : si couplage d'un tableau, renvoit l'élément correspondant à l'étape actuel (step) de la boucle si elle n'est pas
 * terminée.
 *
 * ENDED (optionnel): si couplage d'un tableau, indique si le step actuel dépasse la taille des index du tableau, et que donc on a
 * potentiellement terminé le parcours de la boucle.
 *
 */
function Loop_Async_Semaphore(attachedTableauForMonitoring) {
  var tableauMonitor = attachedTableauForMonitoring;
  var currentIndex = 0;
  var indexStatus = [false, false, false, false, false];
  this.isDone = function () {
    var i = currentIndex;
    if (i + 1 > indexStatus.length) {
      return false;
    }
    return indexStatus[i];
  };
  this.done = function () {
    var i = currentIndex;
    indexStatus[i] = true;
    currentIndex = i + 1;
    indexStatus[currentIndex] = false;
  };
  this.step = function () {
    return currentIndex;
  };
  this.status = function () {
    return "loop status : currentIndex=" + currentIndex + ", indexStatus=" + indexStatus.toString();
  };
  this.attach = function (tableauParcouru) {
    tableauMonitor = tableauParcouru;
  };
  this.getItem = function () {
    if (tableauMonitor) {
      if (!this.ended()) {
        return tableauMonitor[currentIndex];
      }
    }
    return false;
  };
  this.ended = function () {
    if (!tableauMonitor) return false;
    if (currentIndex >= tableauMonitor.length) return true;
    return false;
  };
}

//MODULE

(function (exports) {
  var baseUrl = "";
  var _self;
  function FsvCall() {
    logTra.debug("MODULE : FsvCall");
    _self = this;
    this.ELinkInstructions = {
      Reboot: 'INSTRUCTIONS_REBOOT'
    };
  }
  function hideDialog(idDialog) {
    cbaLink.services.frontend.hideDialog(idDialog);
  }
  function showDialog(idDialog, errMessage) {
    cbaLink.services.frontend.showDialog(idDialog, errMessage);
  }
  var _IInternal = {
    traceCnda: _traceCnda,
    getLecteurCourantConfiguration_whenNoConfigFound: _getLecteurCourantConfiguration_whenNoConfigFound,
    logDatas: _logDatas,
    exceptionHandler_StopTraitement: _exceptionHandler_StopTraitement,
    exceptionHandler_catchErreurGlobale: _exceptionHandler_catchErreurGlobale,
    exceptionHandler_catchErreurApi: _exceptionHandler_catchErreurApi,
    getLecteurCourantConfiguration_whenNoConfigFoundWithPromise: _getLecteurCourantConfiguration_whenNoConfigFoundWithPromise,
    getGuid: _getGuid,
    appelDmpTlsi: _appelDmpTlsi
  };
  FsvCall.prototype.exceptionHandler_catchAll = exceptionHandler_catchAll;
  FsvCall.prototype.exceptionHandler_BasicShowDialog = exceptionHandler_BasicShowDialog;
  FsvCall.prototype.traiteErreurApi = _traiteErreurApi;
  FsvCall.prototype.traiteErreurGlobale = _traiteErreurGlobale;
  FsvCall.prototype.readConfigurationGalss = readConfigurationGalss;
  FsvCall.prototype.rechercheLecteursConnectes = rechercheLecteursConnectes;
  FsvCall.prototype.lireConfigFSV = lireConfigFSV;
  FsvCall.prototype.chargeFsvLink_Basic = chargeFsvLink_Basic;
  FsvCall.prototype.recupereConfigurationLecteur = recupereConfigurationLecteur;
  FsvCall.prototype.checkPresenceLecteurOuTLA = checkPresenceLecteurOuTLA;
  FsvCall.prototype.readConfigFSV = readConfigFSV;
  FsvCall.prototype.readInfosCartePS = readInfosCartePS;
  FsvCall.prototype.readCarteVitale = readCarteVitale;
  FsvCall.prototype.lectureDonneesApCvParNFC = lectureDonneesApCvParNFC;

  /////////
  // Fonctions qui devraient etre dans leurs js respectifs
  FsvCall.prototype.readFromCPSExecutant = readFromCPSExecutant;
  FsvCall.prototype.readFromCPSRemplacantActivation = readFromCPSRemplacantActivation;
  FsvCall.prototype.readFromCPSRemplacant = readFromCPSRemplacant;
  FsvCall.prototype.readFromCPS = readFromCPS;
  /////////

  FsvCall.prototype.readIdentTLA = readIdentTLA;
  FsvCall.prototype.readDateLecteur = readDateLecteur;
  FsvCall.prototype.updateDateLecteur = updateDateLecteur;
  FsvCall.prototype.readFromCV = readFromCV;
  FsvCall.prototype.lanceMajCv = lanceMajCv;
  FsvCall.prototype.formaterFacture = formaterFacture;
  FsvCall.prototype.chifferFacture = chiffrerFacture;
  FsvCall.prototype.calculerHashFactureAssure = calculerHashFactureAssure;
  FsvCall.prototype.ajouterSignatureAssureFacture = ajouterSignatureAssureFacture;
  FsvCall.prototype.signerFactureCPS = signerFactureCPS;
  FsvCall.prototype.signerFactureCPSHorsFacturation = signerFactureCPSHorsFacturation;
  FsvCall.prototype.signerFactureVitale = signerFactureVitale;
  FsvCall.prototype.formaterLot = formaterLot;
  FsvCall.prototype.signerLotCPS = signerLotCPS;
  FsvCall.prototype.formaterFichier = formaterFichier;
  FsvCall.prototype.stopTraitement = stopTraitement;
  FsvCall.prototype.resetDatas = resetDatas;
  FsvCall.prototype.chargerFacturesPdt = chargerFacturesPdt;
  FsvCall.prototype.effaceTLA = effaceTLA;
  FsvCall.prototype.chargerDonneesTLA = chargerDonneesTLA;
  FsvCall.prototype.traduireFseTla = traduireFseTla;
  FsvCall.prototype.securiserFacture = securiserFacture;
  FsvCall.prototype.dechargerFseTla = dechargerFseTla;
  FsvCall.prototype.dechargerFacturesPdt = dechargerFacturesPdt;
  FsvCall.prototype.dechargerBeneficiairesTLA = dechargerBeneficiairesTLA;
  FsvCall.prototype.verificationConfigurationRessources = verificationConfigurationRessources;
  FsvCall.prototype.fsvStsAssistance = fsvStsAssistance;
  FsvCall.prototype.fsvStsTarification = fsvStsTarification;
  FsvCall.prototype.init = init;
  FsvCall.prototype.getUrlBase = getUrlBase;
  FsvCall.prototype.isLecteurAndCodePorteurOK = isLecteurAndCodePorteurOK;
  FsvCall.prototype.verificationConfigurationRessourcesWithPromise = verificationConfigurationRessourcesWithPromise;
  FsvCall.prototype.recupereConfigurationLecteurWithPromise = recupereConfigurationLecteurWithPromise;
  FsvCall.prototype.verificationConfigurationRessourcesWithPromise = verificationConfigurationRessourcesWithPromise;
  FsvCall.prototype.checkLecteurAndConfiguration = checkLecteurAndConfiguration;

  // TLSi
  FsvCall.prototype.getAssertionCps = getAssertionCps;
  FsvCall.prototype.verifieCpsPerimee = verifieCpsPerimee;
  FsvCall.prototype.getAssertionVitale = getAssertionVitale;
  FsvCall.prototype.testPresenceCV = testPresenceCV;
  FsvCall.prototype.rebootELink = rebootELink;
  FsvCall.prototype.redetectTla = redetectTla;
  FsvCall.prototype.tla = tla;
  FsvCall.prototype.rebootELinkMock = rebootELinkMock;
  FsvCall.prototype.getUrlServiceAMC = getUrlServiceAMC;

  //DMP Appel avec EmotionLink - AgatheLink
  FsvCall.prototype.createDmpTlsi = createDmpTlsi;
  FsvCall.prototype.createAccesDmpTlsi = createAccesDmpTlsi;
  FsvCall.prototype.unlockAccesDmpTlsi = unlockAccesDmpTlsi;
  FsvCall.prototype.addAutorisationDmpTlsi = addAutorisationDmpTlsi;
  FsvCall.prototype.alimenterDmpTlsi = alimenterDmpTlsi;
  FsvCall.prototype.removeAutorisationDmpTlsi = removeAutorisationDmpTlsi;
  FsvCall.prototype.traiteCanalOTPDmpTlsi = traiteCanalOTPDmpTlsi;
  FsvCall.prototype.appelCheckTraitsIdentitePatient = appelCheckTraitsIdentitePatient;
  FsvCall.prototype.verifCps = verifCps;
  FsvCall.prototype.verificationConfig = verificationConfig;
  FsvCall.prototype.getStatutEmotionLink = getStatutEmotionLink;

  // FsvCall.prototype.getMemorisedCodePorteur = getMemorisedCodePorteur;

  function init(baseUrl) {
    _self.baseUrl = baseUrl;
  }
  function getUrlBase() {
    return _self.baseUrl;
  }

  /**
   * Précondition d'appel EmotionLink - AgatheLink en asynchrone.
   *
   * la disponibilité de la WebSocket est testée.
   * En cas de pb on cherche à la recréer.
   *
   * les var globales (cache) pour le Lecteur & la CPS sont regardées.
   * En cas d'absence on va les résoudre.
   *
   * si le TLA n'est pas détecté sur EmotionLink - AgatheLink on propose de règler cela
   * de façon auto (=>reboot de EmotionLink - AgatheLink)
   *
   */
  function checkLecteurAndConfiguration() {
    return _self.verificationConfigurationRessourcesWithPromise();
  }

  /**
   * Lance la trace CNDA. Appel une action qui stocke la trace en bdd.
   *
   * @param fonctionNom
   * @param params
   * @param data
   * @param retour
   */
  function _traceCnda(fonctionNom, params, data, retour) {
    logTra.debug("traceCnda - modetraceCnda - " + cbaLink.environment.modeTraceCnda);
    var content = [];
    content['cndaAppelNomFonction'] = fonctionNom;
    content['cndaRetour'] = retour;
    content['cndaAppelParametres'] = params;
    content['cndaDataBase64'] = data;
    window.dispatchEvent(new CustomEvent('angular-trace-cnda', {
      detail: content
    }));
  }

  /**
   * Indique le statut du channel de communication websocket de EmotionLink - AgatheLink. Selon initFsv on tente de créer le channel si il est non
   * existant.
   *
   * @param initFsv
   * @param notificationDivId
   * @returns {Boolean}
   */
  function chargeFsvLink_Basic(initFsv, notificationDivId) {
    logTra.debug("PRE-REQUIS ACTION EmotionLink - AgatheLink : test du channel de communication websocket de EmotionLink - AgatheLink - cbaLink.services.fsvcall.chargeFsvLink_Basic()");

    // Chargement de la connexion avec EmotionLink - AgatheLink
    if (!cbaLink.services.fsvlink.fsvConnect(initFsv)) {
      hideDialog("dialogAccesLecteur");
      _traiteErreurGlobale();
      return false;
    }
    return true;
  }
  function chargeFsvLink_Async() {
    logTra.debug("PRE-REQUIS ACTION EmotionLink - AgatheLink : test du channel de communication websocket de EmotionLink - AgatheLink - cbaLink.services.fsvcall.chargeFsvLink_Async()");
    let dfd = $.Deferred();

    // Chargement de la connexion avec EmotionLink - AgatheLink
    cbaLink.services.fsvlink.fsvConnectAsync().then(function () {
      logTra.debug("cbaLink.services.fsvcall.chargeFsvLink_Async: fsvConnectAsync is resolved");
      dfd.resolve();
    }, function () {
      logTra.debug("cbaLink.services.fsvcall.chargeFsvLink_Async: fsvConnectAsync is rejected");
      _traiteErreurGlobale().done(() => {
        logTra.debug("EmotionLink - AgatheLink semble avoir été démarré.");
        // On refait un appel pour être sûr.
        cbaLink.services.fsvlink.fsvConnectAsync().then(function () {
          logTra.debug("cbaLink.services.fsvcall.chargeFsvLink_Async: fsvConnectAsync is resolved");
          dfd.resolve();
        }, () => {
          hideDialog("dialogAccesLecteur");
          dfd.reject();
        });
      }).fail(() => {
        hideDialog("dialogAccesLecteur");
        dfd.reject();
      });
    });
    return dfd.promise();
  }

  /**
   * Lecture des données de l'Application Carte Vitale par NFC avec AgatheLink
   *
   * @returns {*}
   */
  function lectureDonneesApCvParNFC() {
    logTra.debug('lectureDonneesApCvParNFC');
    let params;

    // trace cnda
    _IInternal.traceCnda(cbaLink.environment.COMMANDE_READ_NFC, params, null, false);

    // APPEL FSVLINK
    return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_READ_NFC, params, null, true, false).then(exMsg => {
      if (exMsg.isInError()) {
        if (exMsg.isInGlobalError()) {
          let erreur = "AgatheLink non disponible, essayez de recharger la page";
          exMsg.message = erreur;
        } else if (exMsg.isErreurAPI().ANY()) {
          erreurApi(exMsg);
        }
      }
      return exMsg;
    }).then(exMsg => {
      // trace cnda (retour)
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_READ_NFC, exMsg.message, exMsg.dataBase64, true);
      return exMsg;
    }).fail(exception => {
      let msg = "";
      if (exception.status) {
        msg = exception.status;
      } else {
        msg = exception;
      }
      let exMsg = new ExchangeMessage(cbaLink.environment.COMMANDE_READ_NFC, params, null, exception);
      return exMsg;
    }).always(exMsg => {
      hideDialog("dialogAccesLecteur");
      return exMsg;
    });
  }

  /**
   * Récupère les informations de ressources du lecteur configuré sur le serveur en xhr
   *
   * @param callbackFuncName
   *            Fonction à lancer, sans parametres
   */
  function recupereConfigurationLecteur(callbackFuncName) {
    logTra.info("PRE-REQUIS ACTION EmotionLink - AgatheLink : obtention de la configuration du lecteur & callback - cbaLink.services.fsvcall.recupereConfigurationLecteur(" + callbackFuncName + ")");

    // def CB xhr
    var _success_recupereConfigurationLecteur_localCB = function (data, callbackFuncName) {
      logTra.debug("cbaLink.services.fsvcall.recupereConfigurationLecteur : des data sont transmises en retour du serveur");
      if (data.returnAction === "success") {
        logTra.debug("cbaLink.services.fsvcall.recupereConfigurationLecteur : return is a success");
        // On a le nom de ressource, et le code porteur est OK

        //les ressources CPS et Vitale sont a déterminés automatisquement avec TlaCommunicationControler

        cbaLink.environment.numeroSerieLec = data.numeroSerie;
        cbaLink.environment.modeTraceCnda = data.modeTraceCnda;
        cbaLink.environment.versionCDCSV = data.versionCDCSV;
        logTra.debug('cbaLink.services.fsvcall.recupereConfigurationLecteur : versionCDCSV=' + cbaLink.environment.versionCDCSV);
        logTra.debug('cbaLink.services.fsvcall.recupereConfigurationLecteur : ressourceLec=' + cbaLink.environment.ressourceLec);
        // Code porteur enregistré coté serveur valide, on continu
        if (callbackFuncName) {
          // FIX TEMPORAIRE : TODO SEB / GBE
          if (callbackFuncName.endsWith(')')) {
            try {
              eval(callbackFuncName);
            } catch (e) {
              logTra.error(e.message);
            }
          } else {
            try {
              eval(callbackFuncName + '()');
            } catch (e) {
              logTra.error(e.message);
            }
          }
        }
      } else if (data.returnAction === "error") {
        logTra.debug("cbaLink.services.fsvcall.recupereConfigurationLecteur : return is an error - try to obtain lecteur conf");
        // On a pas récupéré la configuration du Galss car pas de lecteur
        // courant en session sur le front end
        // Donc on tente de la récupérer via des actions sur le frontend
        _IInternal.getLecteurCourantConfiguration_whenNoConfigFound(callbackFuncName);
      }
    }; // end def CB

    return cbaLink.services.frontend.callService("/common/getLecteurCourantConfiguration").then(function (o) {
      _success_recupereConfigurationLecteur_localCB(o, callbackFuncName);
    }, function (err) {
      stopTraitement(err.returnMessage);
    });
  }
  function verificationConfigurationRessourcesWithPromise() {
    let dfd = $.Deferred();

    // Chargement de la connexion avec EmotionLink - AgatheLink
    chargeFsvLink_Async().then(() => {
      // Récupération de la configuration ressources a appeler si non présente,
      if (cbaLink.environment.ressourceCps === undefined || cbaLink.environment.ressourceVitale === undefined || cbaLink.environment.typeLec === undefined) {
        logTra.debug(`cbaLink.services.fsvcall.verificationConfigurationRessourcesWithPromise: no ressourceCps = ${cbaLink.environment.ressourceCps} , ressourceLec= ${cbaLink.environment.ressourceLec} `);
        dfd.reject(); //on ne lit plus les infos enregistrées sur le PDT, on reclacule les ressources CPS et Vitale
        return;
        //return _self.recupereConfigurationLecteurWithPromise().then(() => dfd.resolve(), () => dfd.reject());
      } else {
        logTra.debug(`cbaLink.services.fsvcall.verificationConfigurationRessourcesWithPromise: yes ressourceCps = ${cbaLink.environment.ressourceCps} , ressourceLec= ${cbaLink.environment.ressourceLec}, type lecteur : ${cbaLink.environment.typeLec} `);
        dfd.resolve();
      }
    }, () => {
      logTra.debug("cbaLink.services.fsvcall.verificationConfigurationRessourcesWithPromise: reject de chargeFsvLink_Async");
      dfd.reject();
    });
    return dfd.promise();
  }

  /**
   * Récupère les informations de ressources du lecteur configuré sur le serveur en xhr
   *
   * @param callbackFuncName
   *            Fonction à lancer, sans parametres
   */
  function recupereConfigurationLecteurWithPromise() {
    console.log("PRE-REQUIS ACTION EmotionLink - AgatheLink : obtention de la configuration du lecteur & callback - cbaLink.services.fsvcall.recupereConfigurationLecteurWithPromise()");
    return cbaLink.services.frontend.callService("/common/getLecteurCourantConfiguration").then(function (data) {
      logTra.debug("cbaLink.services.fsvcall.recupereConfigurationLecteur : des data sont transmises en retour du serveur");
      if (data.returnAction === "success") {
        logTra.debug("cbaLink.services.fsvcall.recupereConfigurationLecteur : return is a success");
        // On a le nom de ressource, et le code porteur est OK

        cbaLink.environment.numeroSerieLec = data.numeroSerie;
        cbaLink.environment.modeTraceCnda = data.modeTraceCnda;
        cbaLink.environment.versionCDCSV = data.versionCDCSV;
        cbaLink.environment.typeLec = data.typeLect;
        logTra.debug('cbaLink.services.fsvcall.recupereConfigurationLecteur : versionCDCSV=' + cbaLink.environment.versionCDCSV);
        logTra.debug('cbaLink.services.fsvcall.recupereConfigurationLecteur : ressourceLec=' + cbaLink.environment.ressourceLec);
        // Code porteur enregistré coté serveur valide, on continu
        return true;
      } else if (data.returnAction === "error") {
        logTra.debug("cbaLink.services.fsvcall.recupereConfigurationLecteur : return is an error - try to obtain lecteur conf");
        // On a pas récupéré la configuration du Galss car pas de lecteur
        // courant en session sur le front end
        // Donc on tente de la récupérer via des actions sur le frontend
        return _IInternal.getLecteurCourantConfiguration_whenNoConfigFoundWithPromise().then(function () {
          return true;
        }, function (errMsg) {
          stopTraitement(errMsg);
        });
      }
    }, function (err) {
      stopTraitement(err.returnMessage);
    });
  }

  /**
   * Génére un GUID
   *
   * @returns {string | *}
   * @private
   */
  function _getGuid() {
    function S4() {
      return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
    }

    // then to call it, plus stitch in '4' in the third group
    guid = (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
    return guid;
  }

  /**
   * suite du CB de cbaLink.services.fsvcall.recupereConfigurationLecteur quand on n'a pas la config a dispo
   */
  function _getLecteurCourantConfiguration_whenNoConfigFoundWithPromise() {
    logTra.debug("_IInternal.getLecteurCourantConfiguration_whenNoConfigFound : start ");
    // On a pas récupéré la configuration du Galss car pas de lecteur
    // Donc on tente de la récupérer

    return readConfigurationGalss().then(function (exMsg) {
      var config = exMsg.message;
      if (!config || config == "") {
        return $.Deferred().reject("Configuration Galss incorrecte ou introuvable");
      }
      var content = [];
      content['configurationGalssData'] = config;
      return cbaLink.services.frontend.callService('/common/readConfigurationGalss', content).then(function (data) {
        // On a bien récupéré la conf du
        // Galss, on refait l'action de
        // recherche de la ressource

        return cbaLink.services.frontend.callService('/common/getLecteurCourantConfiguration', content).then(function (data) {
          if (data.returnAction === "success") {
            // On a le nom de ressource, et le code porteur est OK
            cbaLink.environment.numeroSerieLec = data.numeroSerie;
            cbaLink.environment.modeTraceCnda = data.modeTraceCnda;
            cbaLink.environment.versionCDCSV = data.versionCDCSV;
            cbaLink.environment.typeLec = data.typeLect;
            return true;
          } else if (data.returnAction === "error") {
            return $.Deferred().reject(data.returnMessage);
          }
        }, function (error) {
          return $.Deferred().reject(error.returnMessage);
        });
      }, function (error) {
        return $.Deferred().reject(error.returnMessage);
      });
    }, function (error) {
      return $.Deferred().reject(error.returnMessage);
    });
  }

  /**
   * suite du CB de cbaLink.services.fsvcall.recupereConfigurationLecteur quand on n'a pas la config a dispo
   */
  function _getLecteurCourantConfiguration_whenNoConfigFound(callbackFuncName) {
    logTra.debug("_IInternal.getLecteurCourantConfiguration_whenNoConfigFound : start ");
    // On a pas récupéré la configuration du Galss car pas de lecteur
    // Donc on tente de la récupérer

    // CB def
    var dealwithConfigCB = function (exMsg, callbackFuncName) {
      var config = exMsg.message;
      if (!config || config == "") {
        stopTraitement("Configuration Galss incorrecte ou introuvable", null);
        return;
      }
      var content = [];
      content['configurationGalssData'] = config;
    }; // fin CB def

    // *********** Call Back ***************
    // Appel fonction FSV LINK (fsvemotioncall.js)
    var successCB = function (o) {
      dealwithConfigCB(o, callbackFuncName);
    };
    var configPromise = readConfigurationGalss();
    configPromise.then(successCB);
    // *********** Call Me May be **********
  }

  function readFromCPSExecutant() {
    logTra.debug("ACTION EmotionLink - AgatheLink : cbaLink.services.fsvcall.readFromCPSExecutant");

    // Dialog acces lecteur
    showDialog("dialogAccesLecteur");
    showDialog("dialogLectureCPS");

    // CB def
    var _readFromCPS_localCB = function (exMsg) {
      logTra.debug('_readFromCPS_localCB in readFromCPS()');
      var contentOfCPS = exMsg.dataBase64;
      if (contentOfCPS) {
        var content = [];
        content['cpsDataBase64'] = contentOfCPS;
        destroyWidgetById("situationPses");
        cbaLink.services.frontend.callService("lectureCPSExecutant", content).then(function (data) {
          resetDatas();
          hideDialog("dialogAccesLecteur");
          if (data.returnAction == "success") {
            logTra.debug("ACTION EmotionLink - AgatheLink : cbaLink.services.fsvcall.readFromCPSExecutant - success");
            callActionAndShowDialogCustomWidth('addExecutant', 'Ajout d un exécutant');
          } else if (data.returnAction == "activation") {
            logTra.debug("ACTION EmotionLink - AgatheLink : cbaLink.services.fsvcall.readFromCPSExecutant - activation");
            //logTra.debug(data);
          } else if (data.returnAction == "error") {
            logTra.debug("ACTION EmotionLink - AgatheLink : cbaLink.services.fsvcall.readFromCPSExecutant - error");
            showDialog('dialogError', data.returnMessage);
          }
        }, function (error) {
          stopTraitement(error.returnMessage);
        });
        hideDialog("dialogLectureCPS");
      } // end if
    }; // end CB def

    return checkLecteurAndConfiguration().then(() => readInfosCartePS()).then(o => _readFromCPS_localCB(o));
  }

  /**
   * PARENT : LECTURE DE LA CARTE PS
   */
  function readFromCPSRemplacantActivation() {
    logTra.debug("ACTION EmotionLink - AgatheLink : readFromCPSRemplacantActivation");

    // Dialog acces lecteur
    showDialog("dialogAccesLecteur");

    // CB def
    var _readFromCPS_localCB = function (exMsg) {
      logTra.debug('_readFromCPS_localCB in readFromCPSRemplacantActivation()');
      var contentOfCPS = exMsg.dataBase64;
      if (contentOfCPS) {
        // ACTION pour traiter le résultat car il est non vide
        var content = [];
        content['cpsDataBase64'] = contentOfCPS;
        destroyWidgetById("situationPses");
        cbaLink.services.frontend.callService("addLectureCps", content).then(function (data) {
          // On a traité les données, on reset les variables globales pour sécurité
          resetDatas();
          hideDialog("dialogAccesLecteur");
          if (data.returnAction == "success") {
            callActionAndShowDialogCustomWidth('selectSituationRemplacant', 'Choix de la situation de remplaçant', '450px');
          } else if (data.returnAction == "error") {
            showDialog('dialogError', data.returnMessage);
          }
        }, function (error) {
          stopTraitement(error.returnMessage);
        });
        hideDialog("dialogLectureCPS");
      } // end if
    }; // end CB def

    return checkLecteurAndConfiguration().then(() => readInfosCartePS()).then(o => _readFromCPS_localCB(o));
  }

  /**
   * PARENT : LECTURE DE LA CARTE PS
   */
  function readFromCPSRemplacant() {
    logTra.debug("ACTION EmotionLink - AgatheLink : readFromCPSRemplacant");

    // Dialog acces lecteur
    showDialog("dialogAccesLecteur");
    showDialog("dialogLectureCPS");

    // CB def
    var _readFromCPS_localCB = function (exMsg) {
      logTra.debug('_readFromCPS_localCB in readFromCPS()');
      var contentOfCPS = exMsg.dataBase64;
      if (contentOfCPS) {
        // ACTION pour traiter le résultat car il est non vide
        var content = [];
        content['cpsDataBase64'] = contentOfCPS;
        destroyWidgetById("situationPses");
        cbaLink.services.frontend.callService("addLectureCps", content).then(function (data) {
          // On a traité les données, on reset les variables globales pour sécurité
          resetDatas();
          hideDialog("dialogAccesLecteur");
          if (data.returnAction == "success") {
            callActionAndShowDialogCustomWidth('/remplacants/addRemplacant', 'Ajout d un remplaçant');
          } else if (data.returnAction == "activation") {
            //logTra.debug(data);
          } else if (data.returnAction == "error") {
            showDialog('dialogError', data.returnMessage);
          }
        }, function (error) {
          stopTraitement(error.returnMessage);
        });
        hideDialog("dialogLectureCPS");
      } // end if
    }; // end CB def

    return checkLecteurAndConfiguration().then(() => readInfosCartePS()).then(o => _readFromCPS_localCB(o));
  }

  /**
   * PARENT : LECTURE DE LA CARTE PS
   */
  function readFromCPS() {
    logTra.debug("ACTION EmotionLink - AgatheLink : readFromCPS");

    // Dialog acces lecteur
    showDialog("dialogAccesLecteur");
    showDialog("dialogLectureCPS");

    // CB def
    var _readFromCPS_localCB = function (exMsg) {
      logTra.debug('_readFromCPS_localCB in readFromCPS()');
      var contentOfCPS = exMsg.dataBase64;
      if (contentOfCPS) {
        // ACTION pour traiter le résultat car il est non vide
        var content = [];
        content['cpsDataBase64'] = contentOfCPS;
        destroyWidgetById("situationPses");
        cbaLink.services.frontend.callService("addLectureCps", content).then(function (data) {
          hideDialog("dialogAccesLecteur");
          if (data.returnAction == "success") {
            if (dojo.byId("divCPS")) {
              // Vide le div
              destroyAllWidgets("divCPS");
            }
            showDialog("dialogChooseSitFact");
            var divCPS = dojo.byId("divCPS");
          } else if (data.returnAction == "error") {
            showDialog('dialogError', data.returnMessage);
          }
        }, function (error) {
          stopTraitement(error.returnMessage);
        });
        hideDialog("dialogLectureCPS");
      } // end if
    }; // end CB def

    return checkLecteurAndConfiguration().then(() => readInfosCartePS()).then(o => _readFromCPS_localCB(o));
  }
  function isLecteurAndCodePorteurOK(recall) {
    // LECTURE DES INFOS de la CPS
    var params = cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceLec + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.codePorteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMSERIE + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.cpsNumeroSerie;
    return cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_CHECK, params, null, true, false);
  }

  /**
   * Lecture de la carte ps. Appel FSVLINK.
   *
   * @param callbackFuncName
   */
  function readInfosCartePS() {
    logTra.debug("readCartePs");

    // LECTURE DES INFOS de la CPS
    var params = cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceLec + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.codePorteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMSERIE + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.cpsNumeroSerie;
    _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_LIRECARTEPS, params, null, false);

    // CB def
    var _readInfosCartePS_localCB = function (exMsg) {
      if (exMsg && _IInternal.exceptionHandler_catchErreurApi(exMsg)) {
        hideDialog("dialogLectureCPS");
        let promise = $.Deferred();
        promise.reject(exMsg);
        return promise;
        // return exMsg;
      }

      hideDialog("dialogLectureCPS");
      if (exMsg) {
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_LIRECARTEPS, null, exMsg.dataBase64, false);
      }
      if (exMsg && !exMsg.dataBase64) {
        hideDialog("dialogAccesLecteur");
        logTra.debug("Erreur FSV : Aucune donnée retournée");
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_LIRECARTEPS, "Erreur FSV : Aucune donnée retournée", null, true);
        showDialog('dialogError', "Aucune donnée retournée");
        return exMsg;
      }
      if (exMsg) {
        exMsg.lecture_cps = "conversation : on a lu les infos de la carte PS";
      }
      return exMsg;
    }; // end CB def

    return checkLecteurAndConfiguration().then(() => cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_SSV_LIRECARTEPS, params, null, true, false)).then(o => _readInfosCartePS_localCB(o), o => _readInfosCartePS_localCB(o));
  }

  /**
   * CHILD : LECTURE DE LA CARTE VITALE sur le lecteur Appel secondaire capable de relancer son process parent contraintes :
   * readFromCvDate doit etre renseigné WEBSOCKET compliant.
   */
  function readCarteVitale(readFromCvDate) {
    logTra.debug("readCarteVitale");
    let _readFromCvDate = readFromCvDate;
    if (_readFromCvDate == undefined) {
      _readFromCvDate = cbaLink.ui.tools.booltox.dateFormat_simple(new Date());
    }
    const dateParamLireDroitVitale = '20120601'; // Date par défaut pour la lecture d'une CV

    // Traitement du format de la date, passée au format dd/MM/yyyy, doit etre
    // au format yyyyMMdd pour l'appel
    if (_readFromCvDate.match("\\d\\d/\\d\\d/\\d\\d\\d\\d")) {
      _readFromCvDate = _readFromCvDate.substring(6, 10) + _readFromCvDate.substring(3, 5) + _readFromCvDate.substring(0, 2);
    }

    // Lecture de la carte Vitale

    // APPEL FSVLINK
    var params = cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + (cbaLink.environment.typeLec == 'P' ? cbaLink.environment.ressourceVitale : cbaLink.environment.ressourceLec) + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.codePorteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMSERIE + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.cpsNumeroSerie + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_DATECONSULTATION + cbaLink.environment.ARGS_VALUE_SEPARATOR + dateParamLireDroitVitale;
    _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_LIREDROITSVITALE, params, null, false);

    // CB def
    var _readCarteVitale_localCB = function (exMsg) {
      hideDialog("dialogAccesLecteur");
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_LIREDROITSVITALE, null, exMsg && exMsg.dataBase64 ? exMsg.dataBase64 : null, true);
      if (_IInternal.exceptionHandler_catchErreurGlobale(exMsg)) {
        // let promise = $.Deferred();
        // promise.reject(exMsg);
        // return promise
        return exMsg;
      }
      if (exMsg && exMsg.isErreurAPI().ANY()) {
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_LIREDROITSVITALE, "Erreur FSV : " + exMsg.message, null, true);
        if (exMsg.erreurApi == 61441) {
          // CPS absente en FSV
          exMsg.message = "La CPS est absente. Seules les données administratives seront affichées. Veuillez introduire la CPS.";
        } else if (exMsg.erreurApi == 61478) {
          // Avertissement données administratives, on continue
          // Carte CPS test avec carte Vitale réelle
        } else {
          if (_IInternal.exceptionHandler_catchErreurApi(exMsg)) {
            hideDialog("dialogLectureCV");
            if (exMsg.isErreurAPI().LECTEUR()) {
              // retrait de l'erreur du fsvConstraint
              hideDialog("dialogError");
            }
            // let promise = $.Deferred();
            // promise.reject(exMsg);
            // return promise
            return exMsg;
          }
          erreurApi(exMsg);
        }
        // let promise = $.Deferred();
        // promise.reject(exMsg);
        // return promise
      }

      if (exMsg) {
        exMsg.dateConsultation = _readFromCvDate;

        // action concrête : Récupération des données de la CV
        // cvDataBase64 = exMsg.dataBase64;

        // si pas de données
        if (!exMsg.dataBase64) {
          logTra.debug("Erreur FSV : Aucune donnée retournée");
          showDialog('dialogError', "Aucune donnée retournée");
          let promise = $.Deferred();
          promise.reject(exMsg);
          return promise;
          // return exMsg;
        }
      }

      return exMsg;
    }; // end CB def

    return cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_SSV_LIREDROITSVITALE, params, null, false, false).then(o => _readCarteVitale_localCB(o), o => {
      let promise = $.Deferred();
      promise.reject(_readCarteVitale_localCB(o));
      return promise;
    });
  }

  /**
   * CHILD : Appel de Lecture du chargement facture PDT. Appel FSVLINK.
   *
   * @param ressourceLecteur :
      *            nom de ressource du lecteur pour lequel on veut faire une identification
   * @param versionCDCSV :
      *            version du cahier des charges SESAM-Vitale géré par le poste de travail
   *
   * @return a promise
   *
   */
  function readIdentTLA(ressourceLecteur_param, versionCDCSV_param) {
    if (!ressourceLecteur_param) {
      ressourceLecteur_param = cbaLink.environment.ressourceLec;
      if (cbaLink.environment.typeLec == 'P') {
        //mode PCSC, on utilise la ressources CPS
        ressourceLecteur_param = cbaLink.environment.ressourceCps;
      }
      versionCDCSV_param = versionCDCSV;
      logTra.debug("readIdentTLA - modify the parameter for " + ressourceLecteur_param);
    }

    // APPEL FSVLINK
    var params = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + ressourceLecteur_param + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMVERSIONCDC + cbaLink.environment.ARGS_VALUE_SEPARATOR + versionCDCSV_param;

    // trace cnda
    _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_IDENTIFIERTLA, params, null, false);

    // CB def
    var _readIdentTLA_localCB = function (exMsg) {
      if (exceptionHandler_catchAll(exMsg)) {
        return exMsg;
      }
      if (!exMsg.dataBase64) {
        logTra.debug("Erreur FSV : Aucune donnée retournée");
        showDialog('dialogError', "Aucune donnée retournée");
        return exMsg;
      }

      // trace cnda (retour)
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_IDENTIFIERTLA, null, exMsg.dataBase64, true);
      return exMsg;
    }; // end CB def

    return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_IDENTIFIERTLA, params, null).then(o => _readIdentTLA_localCB(o), o => {
      stopTraitement(o.message);
      return o;
    });
  }

  /**
   * Lecture de la configuration FSV. Appel FSVLINK.
   *
   * @return a promise
   */
  function readConfigFSV() {
    try {
      // APPEL FSVLINK
      let params = "";

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_LIRECONFIG, params, null, false);

      // CB def
      let _readConfigFSV_localCB = function (exMsg) {
        // On filtre les erreurs lecteur indisponible
        if (!exMsg.isErreurAPI().LECTEUR) {
          if (exceptionHandler_catchAll(exMsg)) {
            return exMsg;
          }
        }

        // Récupération des données de lire config
        // lireConfigFSVDataBase64 = exMsg.dataBase64;

        // FIN APPEL FSVLINK
        if (!exMsg.dataBase64) {
          hideDialog("dialogAccesLecteur");
          logTra.debug("Erreur FSV : Aucune donnée retournée");
          showDialog('dialogError', "Aucune donnée retournée");
          return exMsg;
        }

        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_LIRECONFIG, null, exMsg.dataBase64, true);
        return exMsg;
      }; // end CB def

      return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_LIRECONFIG, params, null).then(o => _readConfigFSV_localCB(o));
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }

  /**
   * Lecture de la configuration du Galss. Appel FSVLINK asynchrone.
   */
  function readConfigurationGalss() {
    logTra.debug("readConfigurationGalss : start");
    try {
      var galssPromise = cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_CONF_LIRECONFGALSS, "", null, false);
    } catch (err) {
      stopTraitement(err);
    }
    logTra.debug("readConfigurationGalss : return promise");
    return galssPromise;
  }

  /**
   * Refresh/Redétection de la liste des lecteurs connecté à AgatheLink.
   */
  function rechercheLecteursConnectes() {
    logTra.debug("rechercheLecteursConnectes : start");
    return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_CONF_LECTEURS, "", null, false);
  }

  /**
   * Lecture de la date du lecteur
   *
   * @returns
   */
  function readDateLecteur(lecteur) {
    if (!lecteur) {
      lecteur = cbaLink.environment.ressourceLec;
    }
    logTra.debug("readDateLecteur");

    // APPEL FSVLINK
    var params = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + lecteur;
    _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_LIREDATELECTEUR, params, null, false);
    return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_LIREDATELECTEUR, params, null).then(exMsg => {
      if (exceptionHandler_catchAll(exMsg)) {
        // nothing
      }
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_MAJDATELECTEUR, null, null, true);
      return exMsg;
    });
  }

  /**
   * CHILD : Mise à jour de la date du lecteur (synchronisation avec la date du poste de travail)
   *
   * @returns a promise
   */
  function updateDateLecteur(ressourceLec, date) {
    // APPEL FSVLINK
    var params = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + ressourceLec + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_DATEHEURE + cbaLink.environment.ARGS_VALUE_SEPARATOR + date;
    _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_MAJDATELECTEUR, params, null, false);
    return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_MAJDATELECTEUR, params, null).then(exMsg => {
      if (exceptionHandler_catchAll(exMsg)) {
        // nothing
      }
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_MAJDATELECTEUR, null, null, true);
      return exMsg;
    });
  }

  /**
   * PARENT : AFFICHAGE DE LA CARTE VITALE
   *
   * @param action
   *            Type action
   * @param date
   *            Date de référence de lecture de la CV
   */
  function readFromCV(action, readFromCvDate) {
    logTra.debug("ACTION EmotionLink - AgatheLink : readFromCV( action : " + action + ", dateReference : " + readFromCvDate + " )");
    _IInternal.logDatas();

    // CB def will do something on server
    var _doActionOnServer = function (exMsg, action) {
      if (exMsg.erreurApi == '61441' || exMsg.erreurApi == '61478') {
        // lire Uniquement les données administratives
      } else if (exMsg.isErreurAPI().ANY()) {
        const dialogErrorNotification = new EmotionInfoMessage();
        dialogErrorNotification.setTitle('lecture CV');
        dialogErrorNotification.show(exMsg.message);
        return exMsg;
      }
      var contentOfCV = exMsg.dataBase64;
      if (contentOfCV) {
        // ACTION xhr async pour traiter le résultat
        var content = [];
        content['dataBase64'] = contentOfCV;
        content['dateReference'] = exMsg.dateConsultation;
        cbaLink.services.frontend.callService("lectureCv", content).then(function (data) {
          // On a traité les données, on reset les
          // variables globales pour sécurité
          resetDatas();
          if (data.returnAction == "success") {

            // require([ "dojo/request" ], function(Request2) {
            //
            //     var eDialog = new EmotionDialogCustom();
            //
            //     eDialog.setOnLoadCallBack(function() {});
            //     eDialog.setOkCallback(function(data) {
            //
            //         verifFormCV();
            //     //document.getElementById("formCV").submit();
            //     });
            //     eDialog.setCancelCallback(function(data) {
            //         deleteFromSession('removeSupportDroitsAMO');
            //         deleteFromSession('removeSupportDroitsData');
            //         destroyWidgetsWithPattern('radioBenef_');
            //     });
            //     eDialog.setWidth('900px');
            //
            //     eDialog.okButtonHidden = false;
            //     eDialog.cancelButtonHidden = false;
            //     eDialog.setOkButtonLabel("Valider");
            //     eDialog.setCancelButtonLabel("Annuler");
            //
            //     eDialog.show('afficheResultSupportDroits_' + action, 'Sélectionner un bénéficiaire', null, null, null);
            //
            // });
          } else if (data.returnAction == "error") {
            showDialog('dialogError', data.returnMessage);
          }
        }, function (error) {
          stopTraitement(error.returnMessage);
        });
      } else {
        showDialog('dialogError', exMsg.message);
      }
    }; // end def CB

    showDialog("dialogAccesLecteur");
    cbaLink.services.fsvcall.checkPresenceLecteurOuTLA().always(() => {
      hideDialog("dialogAccesLecteur");
    }).then(checkTlaSuccess => {
      hideDialog("dialogAccesLecteur");
      showDialog("dialogLectureCV");
      return readCarteVitale(readFromCvDate);
    }, checkTlaError => {
      hideDialog("dialogAccesLecteur");
    }).then(exMsg => {
      _doActionOnServer(exMsg);
    }).always(() => {
      hideDialog("dialogLectureCV");
    });
  }

  /**
   * Fonction qui lance la mise à jour de la carte vitale d'un patient.
   */
  function lanceMajCv(idPatient, readFromCvDate) {
    logTra.debug("lanceMajCv( idPatient : " + idPatient + ", dateReference : " + readFromCvDate + " )");
    showDialog("dialogAccesLecteur");

    // CB def will do something on server
    let doActionOnServer = function (exMsg) {
      let contentOfCV = exMsg.dataBase64;
      if (exMsg.isErreurAPI().ANY()) {
        const dialogErrorNotification = new EmotionInfoMessage();
        dialogErrorNotification.setTitle('mise à jour CV');
        dialogErrorNotification.show(exMsg.message);
        return exMsg;
      }
      if (contentOfCV) {
        // ACTION
        var content = [];
        content['dataBase64'] = contentOfCV;
        content['dateReference'] = exMsg.dateConsultation;
        content['patientId'] = idPatient;
        cbaLink.services.frontend.callService("/patients/majCv", content).then(function (data) {
          // On a traité les données, on reset les variables globales
          resetDatas();

          // logTra.debug(data);
          // Affichage du dossier patient
          hideDialog("dialogAccesLecteur");
          if (data.returnAction == "success") {
            showDialog('dialogConfirmSuccess', data.returnMessage);
            setTimeout("hideDialog('dialogConfirmSuccess')", 1000);
            //eElementLink('patient', idPatient);
            //ILM Redmine #36386 : Le eElementLink ne fait rien si on ne change pas de url.
            populateDiv("", "preparePatientFiche", "", "", {
              id: idPatient
            }, "", "");
          } else if (data.returnAction == "error") {
            showDialog('dialogError', data.returnMessage);
          }
        }, function (error) {
          stopTraitement(error.returnMessage);
        });
      } // end if

      return exMsg;
    }; // end def CB on server

    showDialog("dialogAccesLecteur");
    cbaLink.services.fsvcall.checkPresenceLecteurOuTLA().then(checkTlaSuccess => {
      hideDialog("dialogAccesLecteur");
      showDialog("dialogLectureCV");
      return readCarteVitale(readFromCvDate);
    }, checkTlaError => {
      hideDialog("dialogAccesLecteur");
    }).then(exMsg => {
      hideDialog("dialogLectureCV");
      doActionOnServer(exMsg);
    });
  }

  /**
   * Appel des SSV pour signer la facture avec la Carte Vitale
   * Retourne une promesse qui sera resolue avec un exMsg qui contiendra le resultat de SSV_SignerFactureVitale
   * Si erreurAPI=0 alors exMsg.dateBase64 contient la facture signée vitale
   *
   * @param grpFacture Données de la facture chiffrée (groupe(s) 150 et/ou 160)
   * @returns {*}
   */
  function signerFactureVitale(grpFacture, callbackOptions) {
    logTra.debug("signerFactureVitale");
    let exceptionHandlerCatched = false;
    //let params =    cbaLink.environment.ARGS_RESSOURCE_LEC  + cbaLink.environment.ARGS_VALUE_SEPARATOR + ressourceLec    + cbaLink.environment.ARGS_SEPARATOR;
    let params = cbaLink.environment.ARGS_RESSOURCE_VIT + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceVitale + cbaLink.environment.ARGS_SEPARATOR;

    // Dialog acces lecteur qui charge l'applet
    hideDialog("dialogFacturationEnCours");
    try {
      // trace CNDA
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_SIGNERFACTUREVITALE, params, grpFacture, false);
      let signerFactureVitalePromise = cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_SIGNERFACTUREVITALE, params, grpFacture, true);
      return signerFactureVitalePromise.then(exMsg => {
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_SIGNERFACTUREVITALE, null, exMsg.dataBase64, true);
        hideDialog("dialogAccesLecteur");
        if (callbackOptions && callbackOptions.showDialogFromExternalContext) {
          callbackOptions.showDialogFromExternalContext();
        }
        exceptionHandlerCatched = exceptionHandler_catchAll(exMsg);
        return exMsg;
      });
    } catch (err) {
      stopTraitement(err);
    }
  }
  function signerFactureCPS(noLogiqueSituation, modeSecurisation, grpFacture, callbackLastActionName, isDreAnnulation, callbackOptions) {
    logTra.debug("signerFactureCPS");
    let exceptionHandlerCatched = false;
    let params = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceLec + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.codePorteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NOLOGSITUATION + cbaLink.environment.ARGS_VALUE_SEPARATOR + noLogiqueSituation + cbaLink.environment.ARGS_SEPARATOR;

    // Dialog acces lecteur qui charge l'applet
    hideDialog("dialogFacturationEnCours");

    // Signature CPS de la facture
    try {
      // trace CNDA
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_SIGNERFACTURECPS, params, grpFacture, false);

      //la présence du lecteur, de la cps, et du code porteur est nécessaire
      let signerFactureCpsPromise = cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_SSV_SIGNERFACTURECPS, params, grpFacture, true,
      //carte obligatoire
      false,
      // code obligatoire
      null, callbackOptions);
      return signerFactureCpsPromise.then(exMsg => {
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_SIGNERFACTURECPS, null, exMsg.dataBase64, true);
        hideDialog("dialogAccesLecteur");
        if (callbackOptions && callbackOptions.showDialogFromExternalContext) {
          callbackOptions.showDialogFromExternalContext();
        }
        if (exMsg.erreurApi == 61476 || exMsg.erreurApi == 61446) {
          // on connait le type d 'erreur .. on sais qu 'on ne veux pas faire de stop traitement
          return _unSuccessCallBackFormaterFacture(exMsg).then(() => {
            hideDialog("dialogAccesLecteur");
            // on ajoute un flg pour signifier qu'il faut relancer le formatage
            exMsg.doItAgain = true;
            return exMsg;
          }, () => {
            // on ajoute un flag pour signifier qu'il faut passer en erreur
            exMsg.doItAgain = false;
            return exMsg;
          });
        } else {
          exceptionHandlerCatched = exceptionHandler_catchAll(exMsg);
          return exMsg;
        }
      });
      function _unSuccessCallBackFormaterFacture(exMsg) {
        var dfd = $.Deferred();
        if (isDreAnnulation == false && modeSecurisation != cbaLink.environment.MODESECURISATION_DEGRADE) {
          // si la fonction signerFactureCps retourne une erreur liée à la CPS (exMsg.erreurApi == 61476 || exMsg.erreurApi == 61441)
          // on doit proposer la désynchro vitale (sécurisation uniquement avec la carte vitale)

          // dans le param exMsg on a mis le message renvoyé par les API donc on l'affiche dans le dialog.
          var dialog = new EmotionGenDialog();
          var cbOk = function () {
            // si l'utilisateur répond oui le process de facturation est terminé, la facture doit etre noté "désynchro vitale"
            logTra.debug('OK');
            dfd.resolve();
          };
          var cbCancel = function () {
            logTra.debug('pas OK');
            dfd.reject();
          };
          dialog.setTitle("Sécurisation désynchronisée");
          var dialogContent = `<div style="color: #5a4c48; text-align: center; font-style:italic;"> [` + exMsg.erreurApi + `] ` + exMsg.message + `</div>
								<div style="color: #5a4c48; text-align:center; padding:10px; font-size:17px; font-family:'MyriadPro Regular';">Souhaitez-vous effectuer une sécurisation désynchronisée Vitale ?</div>`;
          dialog.show(dialogContent, cbOk, cbCancel);
        } else if (modeSecurisation == cbaLink.environment.MODESECURISATION_DEGRADE && exMsg.erreurApi == 61476) {
          let dialog = new EmotionInfoMessage();
          dialog.setTitle("Facturation dégradée");
          const dialogContent = `<div><img src='${cbaLink.services.frontend.repertoireImgCommon}/popup_erreur.png' /></div> <div style="color: #5a4c48; text-align: center; font-style:italic;"> [` + exMsg.erreurApi + `] ` + exMsg.message + `</div>
                     <div style="color: #5a4c48; text-align:center; padding:10px; font-size:17px; font-family:'MyriadPro Regular';">La facturation est interrompue.</div>`;
          dialog.show(dialogContent, -1, function () {
            dfd.reject();
          });
        } else {
          dfd.reject();
        }
        return dfd.promise();
      }
    } catch (err) {
      stopTraitement(err);
    }
  }
  function signerFactureCPSHorsFacturation(noLogiqueSituation, modeSecurisation, grpFacture) {
    logTra.debug("signerFactureCPS");
    let exceptionHandlerCatched = false;
    let params = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceLec + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.codePorteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NOLOGSITUATION + cbaLink.environment.ARGS_VALUE_SEPARATOR + noLogiqueSituation + cbaLink.environment.ARGS_SEPARATOR;

    // Signature CPS de la facture
    try {
      // trace CNDA
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_SIGNERFACTURECPS, params, grpFacture, false);

      //la présence du lecteur, de la cps, et du code porteur est nécessaire
      let signerFactureCpsPromise = cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_SSV_SIGNERFACTURECPS, params, grpFacture, true,
      //carte obligatoire
      true,
      // code obligatoire
      null);
      return signerFactureCpsPromise.then(exMsg => {
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_SIGNERFACTURECPS, null, exMsg.dataBase64, true);
        exceptionHandlerCatched = exceptionHandler_catchAll(exMsg);
        return exMsg;
      });
    } catch (err) {
      stopTraitement(err);
    }
  }

  /**
   * Appel de la fonction SSV_FormaterFacture
   * Génère le B2 de la facture à l'aide des groupes SSV fournis en entrée
   *
   * @param typeFlux
   * @param typeFacture
   * @param modeSecurisation
   * @param grpFacture
   * @param callbackLastActionName
   * @param isDreAnnulation
   * @param callbackOptions
   * @returns {*}
   */
  function formaterFacture(typeFlux, typeFacture, modeSecurisation, grpFacture, callbackLastActionName, isDreAnnulation, callbackOptions) {
    logTra.debug("formaterFacture - Création de factures ");
    var formaterFacturePromise;
    var exceptionHandlerCatched = false;
    var params = cbaLink.environment.ARGS_TYPEFLUX + cbaLink.environment.ARGS_VALUE_SEPARATOR + typeFlux + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_FACTUREACREER + cbaLink.environment.ARGS_VALUE_SEPARATOR + typeFacture + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_MODESECUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + modeSecurisation;

    // Dialog acces lecteur qui charge l'applet
    hideDialog("dialogFacturationEnCours");

    // Formatage de la facture, à partir de Add8, la fonction n'accède plus au lecteur de carte
    try {
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_FORMATERFACTURES, params, grpFacture, false);
      formaterFacturePromise = cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_FORMATERFACTURES, params, grpFacture);
      return formaterFacturePromise.then(exMsg => {
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_FORMATERFACTURES, null, exMsg.dataBase64, true);
        hideDialog("dialogAccesLecteur");
        if (callbackOptions && callbackOptions.showDialogFromExternalContext) {
          callbackOptions.showDialogFromExternalContext();
        }
        exceptionHandlerCatched = exceptionHandler_catchAll(exMsg);
        if (!exceptionHandlerCatched) {
          // Récupération des données de formater facture
          // grpFacturesZmsBase64 = exMsg.dataBase64;
        } else {
          // if (callbackOptions && callbackOptions.hideDialogOpenedFromExternalContext) {
          //    callbackOptions.hideDialogOpenedFromExternalContext();
          // }
        }
        return exMsg;
      }).then(exMsg => {
        return exMsg;
      });
    } catch (err) {
      stopTraitement(err);
    }
  }
  function chiffrerFacture(grpFacture, callbackLastActionName, callbackOptions) {
    logTra.debug("chiffrerFacture - Chiffrement de factures ");
    let chiffrerFacturePromise;
    let exceptionHandlerCatched = false;
    let params = "";

    // Dialog acces lecteur qui charge l'applet
    hideDialog("dialogFacturationEnCours");

    // Chiffrement de la facture, la fonction n'accède pas au lecteur de carte
    try {
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_CHIFFRERFACTURE, params, grpFacture, false); // trace CNDA

      chiffrerFacturePromise = cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_CHIFFRERFACTURE, params, grpFacture); //Appel fonction AgatheLink

      return chiffrerFacturePromise.then(exMsg => {
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_CHIFFRERFACTURE, null, exMsg.dataBase64, true);
        hideDialog("dialogAccesLecteur");
        if (callbackOptions && callbackOptions.showDialogFromExternalContext) {
          callbackOptions.showDialogFromExternalContext();
        }
        if (exMsg.erreurApi >= 65025 && exMsg.erreurApi <= 65279) {
          //Erreur API SSV : 65025 -> 65279
          //cas Warnning Certificat de chiffrement pas à jour, on ignore l'erreur et on affiche un message
          showNotificationMessage("globalNotificationZone", true, "warning", "Attention, les certificats de chiffrement des factures sur votre poste de travail sont obsolètes");
          exMsg.erreurApi = 0; //on ignore l'erreur
        } else {
          exceptionHandlerCatched = exceptionHandler_catchAll(exMsg);
        }
        return exMsg;
      });
    } catch (err) {
      stopTraitement(err);
    }
  }

  /**
   * Appel API SSV_CalculerHashFactureAssure
   * Calcul de le hash FSE et/ou DRE d'une facture à sécuriser Vitale avec l'ApCV
   *
   * @param grpFacture
   * @param callbackLastActionName
   * @param callbackOptions
   * @returns {*}
   */
  function calculerHashFactureAssure(grpFacture, numeroSerieCv, callbackLastActionName, callbackOptions) {
    logTra.debug("calculerHashFactureAssure ");
    let calculerHashFacturePromise;
    let exceptionHandlerCatched = false;
    let params = cbaLink.environment.ARGS_NUMSERIE + cbaLink.environment.ARGS_VALUE_SEPARATOR + numeroSerieCv;

    // Dialog acces lecteur qui charge l'applet
    hideDialog("dialogFacturationEnCours");

    // Calculer le hash de la facture, la fonction n'accède pas au lecteur de carte
    try {
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_CALCULERHASHFACTUREASSURE, params, grpFacture, false); // trace CNDA

      calculerHashFacturePromise = cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_CALCULERHASHFACTUREASSURE, params, grpFacture); //Appel fonction AgatheLink

      return calculerHashFacturePromise.always(exMsg => {
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_CALCULERHASHFACTUREASSURE, null, exMsg.dataBase64, true);
        hideDialog("dialogAccesLecteur");
      }).then(exMsg => {
        if (callbackOptions && callbackOptions.showDialogFromExternalContext) {
          callbackOptions.showDialogFromExternalContext();
        }
        exceptionHandlerCatched = exceptionHandler_catchAll(exMsg);
        return exMsg;
      }, err => {
        console.error(`echec de l'appel AgatheLink 'calculerHashFactureAssure' : ${err}`);
      });
    } catch (err) {
      stopTraitement(err);
    }
  }

  /**
   * <p>Appel API SSV_AjouterSignatureAssureFacture</p>
   * Cette fonction permet d’ajouter la signature de la FSE dans la FSE et/ou la signature de la DRE dans la DRE
   * lorsque la signature Vitale est réalisée avec l'ApCV
   *
   * @param grpFacture
   * @param callbackLastActionName
   * @param callbackOptions
   * @returns {*}
   */
  function ajouterSignatureAssureFacture(grpFacture, callbackLastActionName, callbackOptions) {
    logTra.debug("ajouterSignatureAssureFacture ");
    let ajouterSignatureApCVFacturePromise;
    let exceptionHandlerCatched = false;
    let params = "";

    // Dialog acces lecteur qui charge l'applet
    hideDialog("dialogFacturationEnCours");

    // Ajouter la signature de l'assuré dans la facture, la fonction n'accède pas au lecteur de carte
    try {
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_AJOUTERSIGNATUREASSUREFACTURE, params, grpFacture, false); // trace CNDA

      ajouterSignatureApCVFacturePromise = cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_AJOUTERSIGNATUREASSUREFACTURE, params, grpFacture); //Appel fonction AgatheLink

      return ajouterSignatureApCVFacturePromise.always(exMsg => {
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_AJOUTERSIGNATUREASSUREFACTURE, null, exMsg ? exMsg.dataBase64 : null, true);
        hideDialog("dialogAccesLecteur");
      }).then(exMsg => {
        if (callbackOptions && callbackOptions.showDialogFromExternalContext) {
          callbackOptions.showDialogFromExternalContext();
        }
        exceptionHandlerCatched = exceptionHandler_catchAll(exMsg);
        return exMsg;
      }, err => {
        console.error(`echec de l'appel AgatheLink 'ajouterSignatureAssureFacture' : ${err}`);
      });
    } catch (err) {
      stopTraitement(err);
    }
  }

  /**
   * Formatage d'un lot de factures
   * Retourne une promise qui est résolu avec un objet exMsg.
   * Si exMsg.erreurApi = 0, alors exMsg.database64 contient le lot formaté (sous forme de groupes SSV)
   * @param grpLot
   *            Groupes entrée FSV pour SSV_FormaterLots
   * @return a promise
   *
   */
  function formaterLot(lotZme) {
    logTra.debug("ACTION EmotionLink - AgatheLink : formaterLot");

    // Formatage du lot
    try {
      // APPEL FSVLINK
      var params = "";

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_FORMATERLOT, params, lotZme, false);
      return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_FORMATERLOT, params, lotZme, true).then(exMsg => {
        if (exceptionHandler_catchAll(exMsg)) {
          return exMsg;
        }
        // trace cnda
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_FORMATERLOT, null, exMsg.dataBase64, true);
        return exMsg;
      }, o => {
        stopTeletransmission("Vous avez choisi d'annuler cette télétransmission", TELETRANS_ETAPE_CANCEL);
        return o;
      });
    } catch (err) {
      stopTraitement(err);
    }
  }

  /**
   * Signe un lot de facture avec la CPS
   *
   * @param grpLot
   *            Groupes entrée FSV pour SSV_SignerLotCPS (= groupe en sortie de formaterLot)
   * @return a promise resolu avec un exMsg
   *
   */
  function signerLotCPS(grpZmeLotASigner, numeroLogiqueSituation, pinForFirstCallMandatory, callbackParentProcessActionName, affichageFunction) {
    logTra.debug("ACTION EmotionLink - AgatheLink : formaterLot" + cbaLink.environment.ressourceCps + cbaLink.environment.ressourceLec + cbaLink.environment.codePorteur + cbaLink.environment.cpsNumeroSerie);

    // Signature du lot
    try {
      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceLec + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.codePorteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NOLOGSITUATION + cbaLink.environment.ARGS_VALUE_SEPARATOR + numeroLogiqueSituation + cbaLink.environment.ARGS_SEPARATOR;

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_SIGNERLOTCPS, params, grpZmeLotASigner, false);
      return cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_SSV_SIGNERLOTCPS, params, grpZmeLotASigner, true, pinForFirstCallMandatory, affichageFunction).then(exMsg => {
        if (exceptionHandler_catchAll(exMsg)) {
          return exMsg;
        }
        // trace cnda
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_SIGNERLOTCPS, null, exMsg.dataBase64, true);
        return exMsg;
      }, o => {
        stopTeletransmission("Vous avez choisi d'annuler cette télétransmission", TELETRANS_ETAPE_CANCEL);
        return o;
      });
    } catch (err) {
      stopTraitement(err);
    }
  }
  /**
   * WEBSOCKET compliant. Formatage d'un fichier.
   *
   * @param grpFichier
   *            Groupes entrée FSV pour SSV_FormaterFichiers
   * @return a promise
   */
  function formaterFichier(bufferEntreeBase64) {
    logTra.debug("ACTION EmotionLink - AgatheLink : formaterFichier");

    // Formatage du lot
    try {
      // APPEL FSVLINK
      var params = '';

      // trace CNDA
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_FORMATERFICHIER, params, bufferEntreeBase64, false);

      // ***************** POUR TESTER L'ALGO ....

      // def CB
      var _formaterFichier_localCB = function (exMsg) {
        if (exceptionHandler_catchAll(exMsg)) {
          return exMsg;
        }
        // Récupération des données de la CV
        // fichierBufferSortieBase64 = exMsg.dataBase64;

        // trace CNDA
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_FORMATERFICHIER, null, exMsg.dataBase64, true);
        return exMsg;
      }; // fin def CB

      return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_FORMATERFICHIER, params, bufferEntreeBase64).then(o => _formaterFichier_localCB(o));
    } catch (err) {
      stopTraitement(err);
    }
  }

  /**
   * Fonction qui lit la configuration FSV du poste de travail.
   */
  function lireConfigFSV() {
    logTra.debug("ACTION EmotionLink - AgatheLink : lireConfigFSV");

    // splash d'attente accès aux API et lecteurs
    showDialog("dialogAccesLecteur");
    verificationConfigurationRessourcesWithPromise().then(success => {
      // Lecture de la config
      readConfigFSV().then(exMsg => {
        var content = [];
        content['configFsvDataBase64'] = exMsg.dataBase64;
        cbaLink.services.frontend.callService("/common/readConfigurationFsv", content).then(function (data) {
          // On a traité les données, on reset les variables globales
          // par sécurité
          resetDatas();
          hideDialog("dialogAccesLecteur");
          if (data.returnAction == "success") {
            // Affichage de la configuration
            showDialog('dialogInfosTexte', data.configurationFsvResume, 'Configuration FSV', 600);
          } else if (data.returnAction == "error") {
            stopTraitement(data.returnMessage);
          }
        }, function (error) {
          hideDialog("dialogAccesLecteur");
          stopTraitement(error.returnMessage);
        });
      }, error => {
        hideDialog("dialogAccesLecteur");
        logTra.error("echec readConfigFSV");
      });
    }, echec => {
      logTra.error("lireConfigFSV(): echec verificationConfigurationRessourcesWithPromise " + echec);
    });
  }

  /**
   * Traduit le exMsg pour lui faire porter dans .message un message d'erreur conforme a treatErrorApi
   *
   * @author GBE
   * @date 19/09/2017
   *
   * @param exMsg
   */
  function erreurApi(exMsg) {
    if (exMsg) {
      exMsg.message = _traiteErreurApi(exMsg.erreurApi, exMsg.message);
    }
    return exMsg;
  }

  /**
   * Traite les différents code erreurs retour des FSV à affiner.
   *
   * @author DQU
   * @date 4 juin 2015
   *
   * @param codeErreur
   * @param messageErreur
   */
  function _traiteErreurApi(codeErreur, messageErreur) {
    logTra.debug("traiteErreurApi - codeErreur : " + codeErreur + " - messageErreur : " + messageErreur);
    var reintroductionCPS = " Veuillez réintroduire la carte PS.";
    switch (codeErreur) {
      // Codes communs
      case -1:
        return messageErreur;
      case -1000:
        return "[" + codeErreur + "] " + "Erreur d'accès à l'API";
      case -1001:
        return "[" + codeErreur + "] " + "Erreur d'accès à l'API";
      case -2000:
        // Cas code porteur erroné
        return "[61443] Le code porteur n'est pas correct";
      case -2001:
        return "Erreur d'association des cartes";
      case -2002:
        // Cas code porteur erroné
        return "La carte ps a été changée";
      case -3000:
        // Cas CPS échangée donc nouveau code porteur
        return "CPS échangée, veuillez saisir le code porteur";

      // Commun PKCS11
      case 164:
        return "[61442] La carte est bloquée";
      case -1051:
        // Carte PS non présente
        return "[61441/61444] " + "La carte du Professionnel de Santé ne répond pas." + reintroductionCPS;
      //                return "[61441] " + "Le lecteur ne détecte pas la carte du Professionnel de Santé." + reintroductionCPS;
      case -1052:
        return "Le certificat de la CPS n'a pas pu être récupéré";
      case -1053:
        return "Les informations de la CPS n'ont pas pu être récupérées";
      case -1054:
        return "L'API PKCS11 n'est pas initialisée";
      case -1055:
        return "Une session sur la CPS n'a pas pu être établie";
      case -1056:
        return "[128] Lecteur introuvable, vérifiez le branchement";
      case -1057:
        return "[61444] " + "La carte du Professionnel de Santé ne répond pas." + reintroductionCPS;

      // Codes FSV

      case 61441:
        return "[" + codeErreur + "] " + "La carte du professionnel de santé est absente." + reintroductionCPS;
      case 61445:
        return "[" + codeErreur + "] " + " La Carte PS a été arrachée, veuillez la réintroduire dans votre lecteur.";
      case 61457:
        // CV absente
        return "[" + codeErreur + "] " + " La carte Vitale est absente, veuillez la réintroduire dans votre lecteur.";
      case 61460:
        // Defaut de communication avec la carte vitale
        return "[" + codeErreur + "] " + "La carte est invalide ou mal introduite dans le lecteur";
      case 61474:
        // Defaut de compatibilité TLA
        return "[" + codeErreur + "] " + "Erreur d'accès au TLA. Pour rappel les fonctions de chargement sont compatible uniquement avec un lecteur de type TLA. L'application TLA doit être compatible avec le cahier des charges 1.40, les TLA CDC 1.31 ne sont pas compatibles avec ce logiciel.";
      case 61476:
        // Cas CPS incorrect
        return "[" + codeErreur + "] " + messageErreur + reintroductionCPS;
      case 61475:
        // Cas carte Vitale incorrect
        return "[" + codeErreur + "] " + messageErreur;
      case 61478:
        // Cas CPS test / Vitale réelle en FSV
        return "[" + codeErreur + "] " + messageErreur;
      case 32780:
        // Lecteur introuvable
        return "[" + codeErreur + "] " + "Lecteur introuvable, vérifiez le branchement avec l'ordinateur";

      // Partie API CPS/PKCS11

      case 104:
        // CPS absente
        return "[" + codeErreur + "] " + "La carte du professionnel de santé est absente." + reintroductionCPS;
      case 128:
        return "[" + codeErreur + "] " + "Lecteur introuvable, vérifiez le branchement";
      case 6:
        return "[" + codeErreur + "] " + "Port de communication introuvable, vérifiez le branchement avec l'ordinateur";
      case 2:
        return "[61697] Le lecteur de CPS n'est pas défini dans la configuration Galss.ini. Veuillez utiliser l'outil de configuration et ensuite réessayer.";
      case 7:
        return "[61444] " + "La carte du Professionnel de Santé ne répond pas." + reintroductionCPS;
      case 8:
        return "[61441] " + "Le lecteur ne détecte pas la carte du Professionnel de Santé." + reintroductionCPS;
      default:
        if (codeErreur != 0) {
          logTra.error(`traduction de message d'erreur dans treat error api : code=${codeErreur} & message=${messageErreur}`);
          if (messageErreur && messageErreur.includes(codeErreur)) {
            //ne pas inclure x fois le code d'erreur dans le libellé du message
            return messageErreur;
          }
          return "[" + codeErreur + "] " + messageErreur;
        }
    }
    return "Aucune erreur";
  }

  /**
   * Traite notre message d'erreur de connexion avec EmotionLink - AgatheLink
   *
   * @param codeErreur
   */
  function _traiteErreurGlobale(codeErreur) {
    const dfd = $.Deferred();
    // cas ou le navigateur bloque l'ouverture de la socket (sans certificat) le dialogue ne s 'effectue pas
    if (codeErreur === undefined) {
      return cbaLink.controllers.tlaCommunicationController.showDialogAideDemarrageAgatheLink(dfd);

      // return "Votre application EmotionLink - AgatheLink est nécéssaire pour cette action. \n Connectez la et rechargez cette page." + "<br></br>"
      //     + "Il est également possible que votre navigateur bloque la connexion avec EmotionLink - AgatheLink : \n "
      //     + '<a href="https://localhost:8013/emotionLink/fsv/detect?url=' + _self.baseUrl + '/logout" '
      //     + ' id="but_check_certif_emotionlink" >' + '  Vérifier et débloquer' + '</a>';
    } else {
      dfd.reject();
    }
    return dfd.promise();
  }

  //

  /**
   * Arret du traitement avec affichage erreur. Les datas sont effacées.
   */
  function stopTraitement(erreur, notificationDivId, showErrorDialog = true) {
    hideDialog("dialogAccesLecteur");
    logTra.error("Erreur : " + erreur);
    if (!erreur) {
      showErrorDialog = false;
    }
    if (notificationDivId && showErrorDialog) {
      // Show notification d'erreur
      showNotificationMessage(notificationDivId, true, "error", erreur, true);
    } else if (showErrorDialog) {
      showDialog('dialogError', erreur);
    }
    resetDatas();
  }

  /**
   * Reset les variables globales utilisées par la chaine de callbacks.
   */
  function resetDatas() {
    // MODE OPTIMISE
    // on ne reset pas le cpsCodeActif : on est optimiste !
    // on reset le cpsEtatRead, ce qui est une verification indirecte optimisée

    logTra.debug("resetDatas");
    cbaLink.environment.codePorteur = "";
    // ressourceCps = undefined;
    // ressourceVitale = undefined;
    // ressourceLec = undefined;

    cbaLink.environment.cpsEtatRead = false;
    cbaLink.environment.cpsPresente = true; // important : on anticipe la présence de la carte
    cbaLink.environment.cpsCategorie = null;
    cbaLink.environment.cpsNbTentativeCodeRestantes = null;
    cbaLink.environment.cpsNomPs = null;
    cbaLink.environment.cpsIdNat = null;
    cbaLink.environment.cpsNumeroSerie = null;
  }

  /**
   * Trace les variables globales utilisées par la chaine de callbacks.
   */
  function _logDatas() {
    var content = [];
    content['codePorteur'] = cbaLink.environment.codePorteur;
    content['ressourceCps'] = cbaLink.environment.ressourceCps;
    content['ressourceVitale'] = cbaLink.environment.ressourceVitale;
    content['ressourceLec'] = cbaLink.environment.ressourceLec;
    content['cpsEtatRead'] = cbaLink.environment.cpsEtatRead;
    content['cpsPresente'] = cbaLink.environment.cpsPresente;
    content['cpsCodeActif'] = cbaLink.environment.cpsCodeActif;
    content['cpsCategorie'] = cbaLink.environment.cpsCategorie;
    content['cpsNbTentativeCodeRestantes'] = cbaLink.environment.cpsNbTentativeCodeRestantes;
    content['cpsNomPs'] = cbaLink.environment.cpsNomPs;
    content['cpsIdNat'] = cbaLink.environment.cpsIdNat;
    content['cpsNumeroSerie'] = cbaLink.environment.cpsNumeroSerie;

    //logTra.debug(content);
  }

  /**
   * WEBSOCKET compliant. Chargement de factures PDT vers le TLA. Appel FSVLINK.
   *
   * @param ressourceLecteur :
      *            nom de ressource du lecteur pour lequel on veut faire une identification
   * @param NumeroSituationPS :
      *            version du cahier des charges SESAM-Vitale géré par le poste de travail
   * @param callbackFuncName :
      *            fonction qui sera appelée
   *
   * @return la promise pour faire un bind de nouveau CB
   *
   */
  function chargerFacturesPdt(ressourceLecteur, numeroSituationPS, zmeChargerFacturesTla) {
    try {
      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + ressourceLecteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMFACTURATION + cbaLink.environment.ARGS_VALUE_SEPARATOR + numeroSituationPS;
      logTra.debug(params);
      logTra.debug(zmeChargerFacturesTla);

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_CHARGERFACTURESPDT, params, zmeChargerFacturesTla, false);

      // def CB
      var _chargerFacturesPdt_localCB = function (exMsg) {
        if (exceptionHandler_catchAll(exMsg)) {
          return exMsg;
        }
        // Récupération des données en sortie de chargement PDT
        // zmsChargerFacturesTla = exMsg.dataBase64;

        // FIN APPEL FSVLINK
        if (!exMsg.dataBase64 || exMsg.dataBase64 == "") {
          logTra.debug("Erreur FSV : Aucune donnée retournée");
          showDialog('dialogError', "Aucune donnée retournée");
          return exMsg;
        }

        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_CHARGERFACTURESPDT, null, exMsg.dataBase64, true);
        return exMsg;
      }; // fin def CB

      return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_CHARGERFACTURESPDT, params, zmeChargerFacturesTla).then(o => _chargerFacturesPdt_localCB(o));
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }

  /**
   * Effacement de données sur le TLA pour une Situation donnée.
   *
   * @param numFacturationPs
   * @param typeDonnee :
      *            type de donnee à supprimer
   *
   * @return a promise
   *
   */
  function effaceTLA(numFacturationPs, typeDonnee) {
    logTra.debug("ACTION EmotionLink - AgatheLink : effaceTLA - ressourceCps=" + cbaLink.environment.ressourceCps + "ressourceLec=" + cbaLink.environment.ressourceLec + "codePorteur=" + cbaLink.environment.codePorteur + "numFacturationPs=" + numFacturationPs + "typeDonnee=" + typeDonnee);
    let ressourceLecToUse = cbaLink.environment.ressourceLec;
    if (cbaLink.environment.typeLec == 'P') {
      //mode PCSC, on utilise la ressources CPS
      ressourceLecToUse = cbaLink.environment.ressourceCps;
    }
    try {
      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + ressourceLecToUse + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.codePorteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMFACTURATION + cbaLink.environment.ARGS_VALUE_SEPARATOR + numFacturationPs + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_TYPEDONNEE + cbaLink.environment.ARGS_VALUE_SEPARATOR + typeDonnee;

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_EFFACERTLA, params, null, false);

      // def CB
      var _effaceTLA_localCB = function (exMsg) {
        hideDialog("dialogAccesLecteur");
        if (exceptionHandler_catchAll(exMsg)) {
          //
        }
        return exMsg;
      }; // fin def CB

      return cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_SSV_EFFACERTLA, params, null, false, false).then(o => _effaceTLA_localCB(o));
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }

  /**
   * WEBSOCKET compliant. Chargement de données vers le TLA. Appel FSVLINK.
   *
   * @param donneesTLA :
      *            message données TLA
   *
   * @return a promise
   *
   */
  function chargerDonneesTLA(zme) {
    logTra.debug("ACTION EmotionLink - AgatheLink : chargerDonnesTLA - ressourceLec=" + cbaLink.environment.ressourceLec + "donneesTLA=" + zme);
    showDialog("dialogAccesLecteur");
    try {
      let ressourceLecToUse = cbaLink.environment.ressourceLec;
      if (cbaLink.environment.typeLec == 'P') {
        //mode PCSC, on utilise la ressources CPS
        ressourceLecToUse = cbaLink.environment.ressourceCps;
      }

      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + ressourceLecToUse;

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_CHARGERDONNEESTLA, params, zme, false);

      // def CB
      var _chargerDonneesTLA_localCB = function (exMsg) {
        hideDialog("dialogAccesLecteur");
        if (exceptionHandler_catchAll(exMsg)) {
          //
        }
        return exMsg;
      }; // fin def CB

      return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_CHARGERDONNEESTLA, params, zme, true, false).then(o => _chargerDonneesTLA_localCB(o));
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }

  /**
   * CHILD : Traduction des facture TLA (Actes isolés). Appel FSVLINK.
   *
   * @param zmeTraduireFseTla :
      *            Le groupe ssv 73 concernant la facture à traduire
   *
   * @return a promise
   *
   */
  function traduireFseTla(zmeTraduireFseTla) {
    try {
      // APPEL FSVLINK
      var params = "";
      logTra.debug(params);

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_TRADUIREFSE, params, zmeTraduireFseTla, false);

      // def CB
      var _traduireFseTla_localCB = function (exMsg) {
        hideDialog("dialogAccesLecteur");
        if (exceptionHandler_catchAll(exMsg)) {
          return exMsg;
        }

        // Récupération des données en sortie de traduire fse
        var zmsTraduireFseTla = exMsg.dataBase64;

        // FIN APPEL FSVLINK
        if (!zmsTraduireFseTla || zmsTraduireFseTla == "") {
          logTra.debug("Erreur FSV : Aucune donnée retournée");
          showDialog('dialogError', "Aucune donnée retournée");
          return exMsg;
        }
        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_TRADUIREFSE, null, zmsTraduireFseTla, true);
        return exMsg;
      }; // fin def CB

      return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_TRADUIREFSE, params, zmeTraduireFseTla).then(o => _traduireFseTla_localCB(o));
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }
  function getAssertionCps(signature, idf, niveauSecuriteAssertion, attributeStatement) {
    logTra.debug('getAssertionCps - signature=' + signature + ' - idf=' + idf + +' - attributeStatement=' + attributeStatement + ' - niveauSecuriteAssertion=' + niveauSecuriteAssertion);
    try {
      // APPEL FSVLINK
      var attributeParam = cbaLink.environment.ARGS_ASSERTION_ATTRIBUTE + cbaLink.environment.ARGS_VALUE_SEPARATOR + attributeStatement;
      var signatureInt = 0;
      if (signature) {
        signatureInt = 1;
      }
      var signatureParam = cbaLink.environment.ARGS_ASSERTION_SIGNATURE + cbaLink.environment.ARGS_VALUE_SEPARATOR + signatureInt;
      var idfParam = cbaLink.environment.ARGS_ASSERTION_IDF + cbaLink.environment.ARGS_VALUE_SEPARATOR + idf;
      var params = attributeParam + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + signatureParam + cbaLink.environment.ARGS_SEPARATOR + idfParam;
      if (niveauSecuriteAssertion) {
        params += cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_ASSERTION_NIVEAU_SECURITE + cbaLink.environment.ARGS_VALUE_SEPARATOR + niveauSecuriteAssertion;
      }
      logTra.debug(params);

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_TLSI_GETASSERTIONCPS, params, null, false);

      // def CB
      var _getAssertionCps_localCB = function (exMsg) {
        hideDialog("dialogAccesLecteur");
        if (exMsg == undefined || exMsg.isInError()) {
          if (exMsg == undefined || exMsg.isInGlobalError()) {
            let erreur = "EmotionLink - AgatheLink non disponible, essayez de recharger la page";
            exMsg.message = erreur;
          } else if (exMsg.isErreurAPI().ANY()) {
            erreurApi(exMsg);
          }
          return exMsg;
        }

        // Récupération des données
        var assertionCps = exMsg.dataBase64;

        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_TLSI_GETASSERTIONCPS, null, assertionCps, true);
        return exMsg;
      }; // fin def CB

      return cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_TLSI_GETASSERTIONCPS, params, null, true, false).then(o => _getAssertionCps_localCB(o), o => _getAssertionCps_localCB(o));
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }
  function verifieCpsPerimee() {
    let signature = true;
    // Niveau de sécurite de l'assertion PS
    let niveauSecuriteAssertion = 2;
    let attributeStatement = ``;
    let cle = Math.floor(Math.random() * 100000000);
    let idf = `CPS${cle}`; // Permet de créer un TLSi valable pendant 1 heure, et d'avoir l'assertion pour chaque situation.
    let def = $.Deferred();
    cbaLink.services.fsvcall.getAssertionCps(signature, idf, niveauSecuriteAssertion, attributeStatement).then(function (exMsg) {
      // on appelle l'action qui va vérifier si la cps est périmée ou non en lui passant l'assertion cps
      const contentOfCPS = exMsg.dataBase64;
      let content = [];
      content['assertionCpsBase64'] = contentOfCPS;
      cbaLink.services.frontend.callService("/common/verifieCpsPerimee", content).then(function (data) {
        if (data.returnAction === "error") {
          data.cpsPerimee = true;
          def.reject(data);
        } else if (data.returnAction === "success") {
          def.resolve(data);
        }
      }, error => {
        // cas erreur
        def.reject(error);
      });
    }, error => {
      def.reject(error);
    });
    return def.promise();
  }
  function getAssertionVitale(signature, numSerieVitale, niveauSecuriteAssertion) {
    logTra.debug('getAssertionVitale - signature=' + signature + ' - numSerieVitale=' + numSerieVitale + ' - niveauSecuriteAssertion=' + niveauSecuriteAssertion);
    // cbaLink.environment.ressourceVitale = this.ressourceVitaleK300;
    // 'Kapelse CCID Interface slot1 0'
    try {
      // APPEL FSVLINK
      var signatureInt = 0;
      if (signature) {
        signatureInt = 1;
      }
      var signatureParam = cbaLink.environment.ARGS_ASSERTION_SIGNATURE + cbaLink.environment.ARGS_VALUE_SEPARATOR + signatureParam;
      var params = cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + signatureInt;
      // cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_VIT + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceVitale;

      if (cbaLink.environment.ressourceVitale && cbaLink.environment.ressourceVitale != "") {
        params += cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_VIT + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceVitale;
      }
      if (numSerieVitale && numSerieVitale != "" && cbaLink.environment.ressourceVitale && cbaLink.environment.ressourceVitale != "") {
        params += cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_ASSERTION_NUM_SERIE_CV + cbaLink.environment.ARGS_VALUE_SEPARATOR + numSerieVitale;
      }
      if (niveauSecuriteAssertion) {
        params += cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_ASSERTION_NIVEAU_SECURITE + cbaLink.environment.ARGS_VALUE_SEPARATOR + niveauSecuriteAssertion;
      }
      logTra.debug(params);

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_TLSI_GETASSERTIONVITALE, params, null, false);

      // def CB
      var _getAssertionVitale_localCB = function (exMsg) {
        hideDialog("dialogAccesLecteur");
        if (exMsg.isInError()) {
          if (exMsg.isInGlobalError()) {
            let erreur = "EmotionLink - AgatheLink non disponible, essayez de recharger la page";
            exMsg.message = erreur;
          } else if (exMsg.isErreurAPI().ANY()) {
            erreurApi(exMsg);
          }
          let promise = $.Deferred();
          promise.reject(exMsg);
          return promise;
          // return exMsg;
        }

        // Récupération des données
        var assertionVitale = exMsg.dataBase64;

        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_TLSI_GETASSERTIONVITALE, null, assertionVitale, true);
        return exMsg;
      }; // fin def CB

      return cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_TLSI_GETASSERTIONVITALE, params, null, true, false).then(o => _getAssertionVitale_localCB(o), o => _getAssertionVitale_localCB(o));
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }
  function testPresenceCV(numSerieVitale) {
    logTra.debug('testPresenceCV - ' + numSerieVitale);
    try {
      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_RESSOURCE_VIT + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceVitale + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_ASSERTION_NUM_SERIE_CV + cbaLink.environment.ARGS_VALUE_SEPARATOR + numSerieVitale;
      logTra.debug(params);

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_TLSI_PRESENCE_CV, params, null, false);

      // def CB
      var _getTestPresenceCv_localCB = function (exMsg) {
        hideDialog("dialogAccesLecteur");
        if (exMsg.isInError()) {
          if (exMsg.isInGlobalError()) {
            let erreur = "EmotionLink - AgatheLink non disponible, essayez de recharger la page";
            exMsg.message = erreur;
          } else if (exMsg.isErreurAPI().ANY()) {
            erreurApi(exMsg);
          }
          return exMsg;
        }

        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_TLSI_PRESENCE_CV, null, null, true);
        return exMsg;
      }; // fin def CB

      return cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_TLSI_PRESENCE_CV, params, null, true, false).then(o => _getTestPresenceCv_localCB(o), o => _getTestPresenceCv_localCB(o));
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }

  /**
   *
   * @author SEB
   * @date 10/10/2018
   *
   * @param modeCnda
   * @param urlAMC = contient les parametres d'appels du service Annuaire
   * @param siteVersion Version agréée pour l'appel de l'annuaire
   * @returns {*}
   */
  function getUrlServiceAMC(modeCnda, urlAMC, siteVersion, ordonnanceId) {
    logTra.debug('getAnnuaireAMC');
    try {
      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_ANNU_SITE_VERSION + cbaLink.environment.ARGS_VALUE_SEPARATOR + siteVersion + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_MODE_CNDA + cbaLink.environment.ARGS_VALUE_SEPARATOR + (modeCnda == true ? '1' : '0');

      //Parametre d'appel = objet Json urlAMC
      let trace = {};
      trace.paramsFSV = params;
      trace.urlAmc = urlAMC;
      let jsonMessage = JSON.stringify(urlAMC, null, '\t');
      let t0 = performance.now(); //pour calculer le temps d'execution de l'appel annuaire

      // trace cnda
      let guid = _IInternal.getGuid() + "-" + urlAMC.typeConv + "-" + urlAMC.csr + "-" + urlAMC.amc;
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_TLSI_CALL_ANNUAIRE_AMC_TRADUIT, guid, JSON.stringify(trace, null, '\t'), false);

      // def CB
      var _getUrlServiceAMC_localCB = function (exMsg) {
        hideDialog("dialogAccesLecteur");

        // trace cnda (retour)
        let t1 = performance.now(); //pour calculer le temps d'execution de l'appel annuaire
        let cptRendu = {};
        cptRendu.executingTimeInMs = Math.round(t1 - t0);
        cptRendu.erreurApi = exMsg.erreurApi;
        cptRendu.erreurGlobale = exMsg.erreurGlobale;
        cptRendu.modeCnda = modeCnda;
        cptRendu.ordonnanceId = ordonnanceId;
        if (exMsg.erreurApi == 0 && exMsg.erreurGlobale == 0) {
          try {
            cptRendu.reponse = JSON.parse(exMsg.message);
          } catch (e) {}
        } else {
          cptRendu.reponse = exMsg.message;
        }
        cptRendu.criteresAppelAnnuaire = urlAMC;
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_TLSI_CALL_ANNUAIRE_AMC_TRADUIT, guid, JSON.stringify(cptRendu, null, '\t'), true);
        if (exMsg.isInError()) {
          if (exMsg.isInGlobalError()) {
            let erreur = "EmotionLink - AgatheLink non disponible, essayez de recharger la page";
            exMsg.message = erreur;
          } else if (exMsg.isErreurAPI().ANY()) {
            erreurApi(exMsg);
          }
          return exMsg;
        }
        return exMsg;
      }; // fin def CB

      //Appel FSV
      return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_TLSI_CALL_ANNUAIRE_AMC_TRADUIT, params, null, null, jsonMessage).then(o => _getUrlServiceAMC_localCB(o), o => _getUrlServiceAMC_localCB(o));
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }
  function rebootELinkMock() {
    //var configPromise = cbaLink.services.fsvlink.fsv(this.ELinkInstructions.Reboot, params, null);
    const exMsgStub = new cbaLink.services.fsvlink.ExchangeMessage();
    exMsgStub.erreurApi = 512;
    exMsgStub.message = 'Lecteur TLA non détecté';
    let comunicationDone = $.Deferred();
    setTimeout(() => {
      comunicationDone.resolve(exMsgStub);
    }, 1500);
    return comunicationDone.promise();
  }
  function rebootELink() {
    cbaLink.services.fsvlink.tlaRedetection = false;
    cbaLink.services.fsvlink.reboot = false;
    return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_REBOOT, "", null, false);
  }
  function redetectTla() {
    return cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_RESOLVE_TLA_DETECTION_ISSUE, "", null, false);
  }

  /**
   * Termine la sécurisation CPS d'une facture "signée Vitale en visite"
   *
   * @param situationPS
   * @param noLogiqueSituation
   * @param zmeSecuriserFacture
   * @returns {*}
   */
  function securiserFacture(situationPS, noLogiqueSituation, zmeSecuriserFacture) {
    logTra.debug("securiserFacture - ressourceCps=" + cbaLink.environment.ressourceCps + "ressourceLec=" + cbaLink.environment.ressourceLec + "codePorteur=" + cbaLink.environment.codePorteur + "numFacturationPs=" + situationPS + " noLogiqueSituation=" + noLogiqueSituation);
    let ressourceLecToUse = cbaLink.environment.ressourceLec;
    if (cbaLink.environment.typeLec == 'P') {
      //mode PCSC, on utilise la ressources CPS
      ressourceLecToUse = cbaLink.environment.ressourceCps;
    }
    try {
      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceLec + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.codePorteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMFACTURATION + cbaLink.environment.ARGS_VALUE_SEPARATOR + situationPS + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NOLOGSITUATION + cbaLink.environment.ARGS_VALUE_SEPARATOR + noLogiqueSituation + cbaLink.environment.ARGS_SEPARATOR;

      // manque numero logique ... stocké dans ps_situation

      logTra.debug(params);

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_SECURISERFACTURE, params, zmeSecuriserFacture, false);

      // def CB
      var _securiserFacture_localCB = function (exMsg) {
        hideDialog("dialogAccesLecteur");
        if (exMsg.isInError()) {
          if (exMsg.isInGlobalError()) {
            let erreur = "EmotionLink - AgatheLink non disponible, essayez de recharger la page";
            exMsg.message = erreur;
          } else if (exMsg.isErreurAPI().ANY()) {
            erreurApi(exMsg);
          }
          return exMsg;
        }

        // Récupération des données
        var zmsSecuriserFacture = exMsg.dataBase64;

        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_SECURISERFACTURE, null, zmsSecuriserFacture, true);
        return exMsg;
      }; // fin def CB

      // *********** Call Back ***************
      // Appel fonction FSV LINK (fsvemotioncall.js)
      var successCB = function (o) {
        _securiserFacture_localCB(o);
      };
      var failureCB = function (o) {
        _securiserFacture_localCB(o);
      };
      var _securiserFacturePromise = cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_SSV_SECURISERFACTURE, params, zmeSecuriserFacture, true, false);
      _securiserFacturePromise.then(successCB, failureCB);
      // *********** Call Me May be **********

      return _securiserFacturePromise;
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }

  /**
   * WEBSOCKET compliant. Decharger les factures TLA (Actes isolés). Appel FSVLINK.
   *
   * @param numSituationPS :
      *            Le numéro de situation du PS pour lequel on veut décharger les Factures TLA
   * @returns a promise
   *
   */
  function dechargerFseTla(situationPSForTla, versionCDCTla) {
    logTra.debug("dechargerFseTla - ressourceCps=" + cbaLink.environment.ressourceCps + "ressourceLec=" + cbaLink.environment.ressourceLec + "codePorteur=" + cbaLink.environment.codePorteur + "numFacturationPs=" + situationPSForTla + "versionCDCTla=" + versionCDCTla);
    let ressourceLecToUse = cbaLink.environment.ressourceLec;
    if (cbaLink.environment.typeLec == 'P') {
      //mode PCSC, on utilise la ressources CPS
      ressourceLecToUse = cbaLink.environment.ressourceCps;
    }
    try {
      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + ressourceLecToUse + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.codePorteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMFACTURATION + cbaLink.environment.ARGS_VALUE_SEPARATOR + situationPSForTla + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMVERSIONCDC + cbaLink.environment.ARGS_VALUE_SEPARATOR + versionCDCTla;
      logTra.debug(params);

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_DECHARGERFSETLA_ALL, params, null, false);

      // def CB
      var _dechargerFseTla_localCB = function (exMsg) {
        hideDialog("dialogAccesLecteur");
        if (exceptionHandler_catchAll(exMsg)) {
          return exMsg;
        }

        // Récupération des données
        // zmsDechargerFseTla = exMsg.dataBase64;

        // FIN APPEL FSVLINK
        if (!exMsg.dataBase64 || exMsg.dataBase64 == "") {
          logTra.debug("Erreur FSV : Aucune donnée retournée");
          showDialog('dialogError', "Aucune donnée retournée");
          return exMsg;
        }

        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_DECHARGERFSETLA_ALL, null, exMsg.dataBase64, true);
        return exMsg;
      }; // fin def CB

      // *********** Call Back ***************
      // Appel fonction FSV LINK (fsvemotioncall.js)
      var successCB = function (o) {
        _dechargerFseTla_localCB(o);
      };
      var failureCB = function (o) {
        _dechargerFseTla_localCB(o);
      };
      var dechargerFseTlaPromise = cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_SSV_DECHARGERFSETLA_ALL, params, null, false, false);
      dechargerFseTlaPromise.then(successCB, failureCB);
      // *********** Call Me May be **********

      return dechargerFseTlaPromise;
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }

  /**
   * Decharger les factures PDT. Appel FSVLINK.
   *
   * @param numSituationPS :
      *            Le numéro de situation du PS pour lequel on veut décharger les Factures TLA
   *
   */
  function dechargerFacturesPdt(situationPSForTla, zme) {
    try {
      let ressourceLecToUse = cbaLink.environment.ressourceLec;
      if (cbaLink.environment.typeLec == 'P') {
        //mode PCSC, on utilise la ressources CPS
        ressourceLecToUse = cbaLink.environment.ressourceCps;
      }

      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + ressourceLecToUse + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.codePorteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMFACTURATION + cbaLink.environment.ARGS_VALUE_SEPARATOR + situationPSForTla;
      logTra.debug(params);
      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_DECHARGERFACTURESPDT, params, zme, false);

      // def CB
      var _dechargerFacturesPdt_localCB = function (exMsg) {
        logTra.debug("_dechargerFacturesPdt_localCB - RETOUR FSV = " + (exMsg ? exMsg.erreurApi : "null"));
        hideDialog("dialogAccesLecteur");
        if (exceptionHandler_catchAll(exMsg)) {
          return exMsg;
        }

        // Récupération des données en sortie de dechargement PDT
        // zmsDechargerFacturesPdt = exMsg.dataBase64;
        if (!exMsg.dataBase64) {
          exMsg.dataBase64 = "";
        }
        // FIN APPEL FSVLINK

        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_DECHARGERFACTURESPDT, null, exMsg.dataBase64, true);
        return exMsg;
      }; // fin def CB

      // *********** Call Back ***************
      // Appel fonction FSV LINK (fsvemotioncall.js)
      var successCB = function (o) {
        _dechargerFacturesPdt_localCB(o);
      };
      var failureCB = function (o) {
        _dechargerFacturesPdt_localCB(o);
      };
      var dechargerFacturePdtPromise = cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_SSV_DECHARGERFACTURESPDT, params, zme, true, false);
      dechargerFacturePdtPromise.then(successCB, failureCB);
      // *********** Call Me May be **********

      return dechargerFacturePdtPromise;
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }

  /**
   * WEBSOCKET compliant. la phase d'initialisation a réussi, le lecteur est prêt, on va pouvoir invoquer le déchargement
   *
   * @returns a promise
   */
  function dechargerBeneficiairesTLA(situationPSForTla) {
    logTra.debug("dechargerBeneficiairesTLA - codePorteur=" + cbaLink.environment.codePorteur + "numFacturationPs=" + situationPSForTla);
    try {
      let ressourceLecToUse = cbaLink.environment.ressourceLec;
      if (cbaLink.environment.typeLec == 'P') {
        //mode PCSC, on utilise la ressources CPS
        ressourceLecToUse = cbaLink.environment.ressourceCps;
      }

      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + ressourceLecToUse + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.codePorteur + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMFACTURATION + cbaLink.environment.ARGS_VALUE_SEPARATOR + situationPSForTla;

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_DECHARGERBENEFICIAIRES, params, null, false);

      // def CB
      var _dechargerBeneficiairesTLA_localCB = function (exMsg) {
        hideDialog("dialogAccesLecteur");
        if (exceptionHandler_catchAll(exMsg)) {
          return exMsg;
        }

        // Récupération des données de decharger beneficaires
        // zmsBeneficiaires = exMsg.dataBase64;

        // FIN APPEL FSVLINK
        if (!exMsg.dataBase64) {
          hideDialog("dialogAccesLecteur");
          logTra.debug("Erreur FSV : Aucune donnée retournée");
          showDialog('dialogError', "Aucune donnée retournée");
          return exMsg;
        }
        logTra.debug("dechargerBeneficiairesTLA - réussi");

        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_SSV_DECHARGERBENEFICIAIRES, null, exMsg.dataBase64, true);
        return exMsg;
      }; // fin def CB

      // *********** Call Back ***************
      // Appel fonction FSV LINK (fsvemotioncall.js)
      var successCB = function (o) {
        _dechargerBeneficiairesTLA_localCB(o);
      };
      var failureCB = function (o) {
        _dechargerBeneficiairesTLA_localCB(o);
      };
      var dechargerBeneficiairePromise = cbaLink.services.fsvlink.fsvWithCpsConstraints(cbaLink.environment.COMMANDE_SSV_DECHARGERBENEFICIAIRES, params, null, false, false);
      dechargerBeneficiairePromise.then(successCB, failureCB);
      // *********** Call Me May be **********

      return dechargerBeneficiairePromise;
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }

  /**
   * Routine de traitement des erreurs générique. Lancera un Stop Traitement
   *
   * @param exMsg
   * @param unsuccessCallback
   * @returns
   */
  function exceptionHandler_catchAll(exMsg) {
    return _IInternal.exceptionHandler_StopTraitement(exMsg);
  }

  /**
   * Routine de traitement des erreurs encapsulés dans exMsg. Réalise uniquement un affichage de dialogError et prends en compte la
   * callBack methode d'échec passée en param.
   *
   * @param exMsg
   * @param unsuccessCallback
   * @returns
   */
  function exceptionHandler_BasicShowDialog(exMsg, unsuccessCallback) {
    if (exMsg && exMsg.isInGlobalError()) {
      if (unsuccessCallback) {
        window[unsuccessCallback]();
      }
      showDialog("dialogError", "EmotionLink - AgatheLink erreur technique: " + exMsg.message);
      return true;
    }
    if (exMsg && exMsg.isErreurAPI().ANY()) {
      if (unsuccessCallback) {
        if (cbaLink.environment.unsuccessErrorGlobal != undefined) {
          cbaLink.environment.unsuccessErrorGlobal = exMsg.message;
        }
        window[unsuccessCallback]();
      }
      showDialog("dialogError", "Erreur lors du chargement du TLA");
      return true;
    }
    return false;
  }

  /**
   * Test le exMsg pour réaliser un catch des erreurs entrainant alors un Stop Traitement. Routine de traitement des erreurs encapsulés
   * dans exMsg. Locale à fsvemotioncall elle est capable de finir un process en maintenant un état stable.
   *
   * @param exMsg
   * @param unsuccessCallback
   * @returns
   */
  function _exceptionHandler_StopTraitement(exMsg) {
    if (exMsg && exMsg.isInGlobalError()) {
      return _IInternal.exceptionHandler_catchErreurGlobale(exMsg);
    } else if (exMsg.isErreurAPI().ANY()) {
      return _IInternal.exceptionHandler_catchErreurApi(exMsg);
    }
    return false;
  }

  /**
   * Routine de traitement des erreurs globales encapsulés dans exMsg. Locale à fsvemotioncall elle est capable de finir un process en
   * maintenant un état stable.
   *
   * @param exMsg
   * @param unsuccessCallback
   * @returns
   */
  function _exceptionHandler_catchErreurGlobale(exMsg, unsuccessCallback) {
    if (exMsg && exMsg.isInGlobalError()) {
      stopTraitement("EmotionLink - AgatheLink non disponible, essayez de recharger la page");
      if (unsuccessCallback) {
        window[unsuccessCallback]();
      }
      return true;
    }
    return false;
  }

  /**
   * Routine de traitement des erreurs API encapsulés dans exMsg. Locale à fsvemotioncall elle est capable de finir un process en
   * maintenant un état stable.
   *
   * @param exMsg
   * @param unsuccessCallback
   * @returns
   */
  function _exceptionHandler_catchErreurApi(exMsg) {
    if (exMsg && exMsg.isErreurAPI().ANY()) {
      erreurApi(exMsg);

      // trace cnda
      _IInternal.traceCnda(exMsg.nomFonction, "Erreur FSV : " + exMsg.message, null, true);

      // si l'erreur retournée est 61476 ou 61441 (mauvaise CPS ou CPS absente) il y a un traitement spécifique
      // on doit proposer la désynchro vitale (sécurisation uniquement avec la carte vitale)
      // donc on passe a traverse l'affichage de l'erreur. Celle-ci est traitée dans le callback
      if (exMsg.erreurApi != 61476 && exMsg.erreurApi != 61441 && exMsg.erreurApi != 61446) {
        if (exMsg.isErreurAPI().LECTEUR()) {
          stopTraitement(exMsg.message, null, false);
        }
      }
      return true;
    }
    return false;
  }

  /**
   * @deprecated : est synchrone
   * @see verificationConfigurationRessourcesWithPromise
   *
   * Fonction vérifiant la mise à dispo de "configuration ressources"
   *
   * @param callbackFuncName
   */
  function verificationConfigurationRessources(callbackFuncName) {
    // Chargement de la connexion avec EmotionLink - AgatheLink
    if (!chargeFsvLink_Basic(true)) {
      return false;
    }

    // Récupération de la configuration ressources a appeler si non présente,
    // callback sur callbackFuncName
    if (!cbaLink.environment.ressourceCps || !cbaLink.environment.ressourceLec) {
      recupereConfigurationLecteur(callbackFuncName);
      return false;
    }
    return true;
  }

  /**
   * Appel à la fonction assistance STS. Appel FSVLINK.
   *
   * @param buffer
   *            d'entrée de l'appel :
   *
   * @return a promise
   *
   */
  function fsvStsAssistance(motifAppel, porteeAppel, zmeStsAssistance) {
    try {
      // APPEL FSVLINK
      var params = "";

      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_MOTIFAPPEL + cbaLink.environment.ARGS_VALUE_SEPARATOR + motifAppel + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_PORTEEAPPEL + cbaLink.environment.ARGS_VALUE_SEPARATOR + porteeAppel;

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_STS_ASSISTANCE, params, zmeStsAssistance, false);

      // def CB
      var _stsAssistance_localCB = function (exMsg) {
        hideDialog("dialogAccesLecteur");
        if (exceptionHandler_catchAll(exMsg)) {
          return exMsg;
        }

        // Récupération des données en sortie de traduire fse
        var zmsStsAssistance = exMsg.dataBase64;

        // FIN APPEL FSVLINK
        if (!zmsStsAssistance || zmsStsAssistance == "") {
          logTra.debug("Erreur FSV : Aucune donnée retournée");
          showDialog('dialogError', "Aucune donnée retournée");
          return exMsg;
        }
        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_STS_ASSISTANCE, null, zmsStsAssistance, true);
        return exMsg;
      }; // fin def CB

      // *********** Call Back ***************
      // Appel fonction FSV LINK (fsvemotioncall.js)
      var successCB = function (o) {
        _stsAssistance_localCB(o);
      };
      var stsAssistancePromise = cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_STS_ASSISTANCE, params, zmeStsAssistance);
      stsAssistancePromise.then(successCB);
      // *********** Call Me May be **********

      return stsAssistancePromise;
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }

  /**
   * Appel à la fonction tarification STS. Appel FSVLINK.
   *
   * @param buffer
   *            d'entrée de l'appel :
   *
   * @return a promise
   *
   */
  function fsvStsTarification(motifAppel, zmeStsTarification) {
    try {
      // APPEL FSVLINK
      let params = "";

      // APPEL FSVLINK
      params = cbaLink.environment.ARGS_MOTIFAPPEL + cbaLink.environment.ARGS_VALUE_SEPARATOR + motifAppel;
      logTra.debug(params);

      // trace cnda
      _IInternal.traceCnda(cbaLink.environment.COMMANDE_STS_TARIFICATION, params, zmeStsTarification, false);

      // def CB
      let _stsTarification_localCB = function (exMsg) {
        let zmsStsTarification;
        hideDialog("dialogAccesLecteur");
        if (exceptionHandler_catchAll(exMsg)) {
          return exMsg;
        }

        // Récupération des données en sortie de traduire fse
        zmsStsTarification = exMsg.dataBase64;

        // FIN APPEL FSVLINK
        if (!zmsStsTarification || zmsStsTarification === "") {
          logTra.debug("Erreur FSV : Aucune donnée retournée");
          showDialog('dialogError', "Aucune donnée retournée");
          return exMsg;
        }
        // trace cnda (retour)
        _IInternal.traceCnda(cbaLink.environment.COMMANDE_STS_TARIFICATION, null, zmsStsTarification, true);
        return exMsg;
      }; // fin def CB

      // *********** Call Back ***************
      // Appel fonction FSV LINK (fsvemotioncall.js)
      const successCB = function (o) {
        _stsTarification_localCB(o);
      };
      let stsTarificationPromise = cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_STS_TARIFICATION, params, zmeStsTarification);
      stsTarificationPromise.then(successCB);
      // *********** Call Me May be **********

      return stsTarificationPromise;
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
  }

  /**
   * @author SEB
   * @date 21/08/2019
   * @updated 21/01/2022
   *
   * Vérifie la présence d'un lecteur (PCSC ou TLA en mode PSS) et tente de résoudre un pb de connectivité
   * Retourne une promesse.<br>
   * La promesse est résolue si un lecteur est connecté (apres reconfiguration ou non).<br>
   * la promesse est rejetée si le PS abandonne la résolution du problème de connectivité<br>
   *
   * @param annulable si false, la fenêtre de connexion du TLA ne peut pas être fermée. Oblige l'utilisateur à le faire
   *      si il veut continuer le traitement.
   * @returns {*}
   */
  function checkPresenceLecteurOuTLA(annulable, dontShowAccesLecteur, forcage = false) {
    if (dontShowAccesLecteur == undefined || dontShowAccesLecteur == false) {
      showDialog("dialogAccesLecteur");
    }
    //Choix de la methode de controle de presence du lecteur en fonction de l'application WEB Emotion ou AgatheYou
    let promiseVerifLecteur = verifiePresenceLecteurWithTlaCommunicationController(forcage);
    return promiseVerifLecteur;
  }

  /**
   * Ancienne methode de détection des lecteurs, utilisable uniqument avec des lecteurs PSS
   * à n'utiliser qu'avec Emotion
   *
   * @deprecated sera remplacer par verifiePresenceLecteurWithTlaCommunicationController
   * @returns {*}
   */
  function verifiePresenceLecteurWithSsvLireDateLecteur(annulable) {
    return checkLecteurAndConfiguration().then(
    //le check de la configuration a marché, on appel LireDate Lecteur pour vérifier si le lecteur configuré est bien branché
    () => cbaLink.services.fsvlink.fsv(cbaLink.environment.COMMANDE_SSV_LIREDATELECTEUR, cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceLec, null));
  }

  /**
   * Détecte la presence d'un lecteur en se basant sur SSV_LireConfig
   *
   * Retourne un exMsg avec soit erreurApi=0 si un lecteur est trouvé , soit erreurApi=1024 (aucun lecteur trouvé)
   * @returns {*}
   */
  function verifiePresenceLecteurWithTlaCommunicationController(forcage = false) {
    let dfdVerifLect = $.Deferred();
    cbaLink.controllers.tlaCommunicationController.checkEmotionLinkAndLecteurConnected(forcage).then(() => {
      //lecteur trouvé
      const exMsg = new cbaLink.services.fsvlink.ExchangeMessage();
      exMsg.nomFonction = "checkEmotionLinkAndLecteurConnected";
      exMsg.erreurApi = 0;
      exMsg.erreurGlobale = 0;
      dfdVerifLect.resolve(exMsg);
    }, err => {
      if (err && err.code) {
        const exMsg = new cbaLink.services.fsvlink.ExchangeMessage();
        exMsg.nomFonction = "checkEmotionLinkAndLecteurConnected";
        exMsg.erreurApi = err.code;
        exMsg.erreurGlobale = 0;
        exMsg.message = err.libelle ? err.libelle : "Lecteur non trouvé";
        dfdVerifLect.reject(exMsg);
      } else {
        //echec recherche lecteur
        const exMsg = new cbaLink.services.fsvlink.ExchangeMessage();
        exMsg.nomFonction = "checkEmotionLinkAndLecteurConnected";
        exMsg.erreurApi = 32780;
        exMsg.erreurGlobale = 0;
        exMsg.message = "Lecteur non trouvé";
        dfdVerifLect.reject(exMsg);
      }
    });
    return dfdVerifLect.promise();
  }

  /**
   * réagit à un retour pour traiter un exMsg indiquant un pb de tla
   *
   * example of call : .then( (exMsg) => tla(exMsg, ()=>readFromCV(action, readFromCvDate) ) )
   *
   *
   * @param exMsg
   * @param caller , example : ()=>readFromCV(action, readFromCvDate)
   * @param [followUp]
   * @returns exMsg
   */
  function tla(exMsg, caller, followUp = true, annulable) {
    if (exMsg === undefined || !exMsg.isErreurAPI().LECTEUR()) {
      cbaLink.environment.tlaRedetection = false;
      cbaLink.environment.reboot = false;
      return $.Deferred().resolve(exMsg);
    }
    return $.Deferred().reject(exMsg);
    // return EmotionLinkTlaErrorManager.treatExMsg({exMsg : exMsg, retryCallback : caller, followUp: followUp}, annulable);
  }

  /****************************************************
   *****************  DMP *****************************
   ****************************************************/
  /* TD 0.0 - check trait identite */
  function appelCheckTraitsIdentitePatient(dmpAppelParamsLink) {
    logTra.debug('addAccesDmpTlsi()');
    return _IInternal.appelDmpTlsi(dmpAppelParamsLink, cbaLink.environment.COMMANDE_TLSI_DMP_CHECK_IDENTITE);
  }

  /* TD 0.3 - ajout */
  function addAutorisationDmpTlsi(dmpAppelParamsLink) {
    logTra.debug('addAccesDmpTlsi()');
    return _IInternal.appelDmpTlsi(dmpAppelParamsLink, cbaLink.environment.COMMANDE_TLSI_DMP_ADD_AUTORISATION);
  }

  /* TD 0.3  - remove */
  function removeAutorisationDmpTlsi(dmpAppelParamsLink) {
    logTra.debug('updateAccesDmpTlsi()');
    return _IInternal.appelDmpTlsi(dmpAppelParamsLink, cbaLink.environment.COMMANDE_TLSI_DMP_REMOVE_AUTORISATION);
  }

  /*TD 1.1 */
  function createDmpTlsi(dmpAppelParamsLink) {
    logTra.debug('createDmpTlsi()');
    return _IInternal.appelDmpTlsi(dmpAppelParamsLink, cbaLink.environment.COMMANDE_TLSI_DMP_CREATE);
  }

  /* TD 1.5 a */
  function createAccesDmpTlsi(dmpAppelParamsLink) {
    logTra.debug('createAccesDmpTlsi()');
    return _IInternal.appelDmpTlsi(dmpAppelParamsLink, cbaLink.environment.COMMANDE_TLSI_DMP_CREATE_ACCES);
  }

  /* TD1.5 d */
  function unlockAccesDmpTlsi(dmpAppelParamsLink) {
    logTra.debug('unlockAccesDmpTlsi()');
    return _IInternal.appelDmpTlsi(dmpAppelParamsLink, cbaLink.environment.COMMANDE_TLSI_DMP_UNLOCK_ACCES);
  }

  /*TD 1.5b gestion du canal OTP */
  function traiteCanalOTPDmpTlsi(dmpAppelParamsLink) {
    logTra.debug('traiteCanalOTPDmpTlsi()');
    return _IInternal.appelDmpTlsi(dmpAppelParamsLink, cbaLink.environment.COMMANDE_TLSI_DMP_UPDATE_CANAL_OTP);
  }

  /* TD 2.1 alimentation en documents du DMP */
  function alimenterDmpTlsi(dmpAppelParamsLink) {
    logTra.debug('alimentationDmp()');
    return _IInternal.appelDmpTlsi(dmpAppelParamsLink, cbaLink.environment.COMMANDE_TLSI_DMP_ALIMENTATION);
  }
  function _appelDmpTlsi(dmpAppelParamsLink, commandeTlsi) {
    logTra.debug('appelDmpTlsi()');
    let dfd = $.Deferred();
    try {
      // APPEL FSVLINK
      var params = cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_RESSOURCE_LEC + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceLec;

      //Parametre d'appel = objet Json urlAMC
      let trace = {};
      trace.paramsFSV = params;
      trace.dmpAppelParamsLink = dmpAppelParamsLink;
      let jsonMessage = JSON.stringify(dmpAppelParamsLink, null, '\t');
      let t0 = performance.now(); //pour calculer le temps d'execution de l'appel DMP

      // trace cnda
      let guid = _IInternal.getGuid() + "-" + dmpAppelParamsLink.patientId + "-" + dmpAppelParamsLink.situationId + "-" + dmpAppelParamsLink.remplacantSituationId;
      _IInternal.traceCnda(commandeTlsi, guid, JSON.stringify(trace, null, '\t'), false);

      // def CB
      var _saveTraceCnda = function (exMsg) {
        hideDialog("dialogAccesLecteur");

        // trace cnda (retour)
        let t1 = performance.now(); //pour calculer le temps d'execution de l'appel annuaire
        let cptRendu = {};
        cptRendu.executingTimeInMs = Math.round(t1 - t0);
        cptRendu.erreurApi = exMsg.erreurApi;
        cptRendu.erreurGlobale = exMsg.erreurGlobale;
        cptRendu.modeCnda = dmpAppelParamsLink.contextDataLink.modeCnda;
        if (exMsg.erreurApi == 0 && exMsg.erreurGlobale == 0) {
          try {
            cptRendu.reponse = JSON.parse(exMsg.message);
          } catch (e) {}
        } else {
          cptRendu.reponse = exMsg.message;
        }
        cptRendu.criteresAppelDmp = dmpAppelParamsLink;
        _IInternal.traceCnda(commandeTlsi, guid, JSON.stringify(cptRendu, null, '\t'), true);
        if (exMsg.isInError()) {
          if (exMsg.isInGlobalError()) {
            let erreur = "EmotionLink - AgatheLink non disponible, essayez de recharger la page";
            exMsg.message = erreur;
          } else if (exMsg.isErreurAPI().ANY()) {
            erreurApi(exMsg);
          }
          return dfd.resolve(exMsg);
        }
        return dfd.resolve(exMsg);
      }; // fin def CB

      //Appel FSV
      return cbaLink.services.fsvlink.fsv(commandeTlsi, params, null, null, jsonMessage).then(o => _saveTraceCnda(o), o => _saveTraceCnda(o));
    } catch (err) {
      hideDialog("dialogAccesLecteur");
      stopTraitement(err);
    }
    dfd.promise();
  }
  function verifCps() {
    var verifCps = $.Deferred();

    // check lecteur et CPS
    var dfdVerificationLecteurEtCPS = $.Deferred();
    // si verification OK : lancement du traitement des factures
    var _fsvVerificationLecteurEtCPS_onsuccess_localCB = function () {
      verifCps.resolve();
    };
    var _fsvVerificationLecteurEtCPS_onerror_localCB = function (o) {
      verifCps.reject(o);
    };
    dfdVerificationLecteurEtCPS.promise().then(_fsvVerificationLecteurEtCPS_onsuccess_localCB, _fsvVerificationLecteurEtCPS_onerror_localCB);
    cbaLink.services.fsvlink.fsvVerificationCartePSAndCodePorteur(true, false, dfdVerificationLecteurEtCPS);
    return verifCps.promise();
  }
  function verificationConfig(annulable, forcage = false) {
    var def = $.Deferred();
    cbaLink.services.fsvcall.checkPresenceLecteurOuTLA(annulable, false, forcage).then(succesCheckTla => {
      cbaLink.services.fsvcall.verifCps().then(succes => {
        return $.Deferred().resolve(succesCheckTla);
      }, exMsg => cbaLink.services.fsvcall.tla(exMsg, () => cbaLink.services.fsvcall.verificationConfig())).then(succesVerifCps => {
        def.resolve();
      }, echecverifCps => {
        def.reject(echecverifCps);
      });
    }, exMsg => {
      def.reject(exMsg);
    });
    return def.promise();
  }

  /**
   * <p>Check l'état de AgatheLink.</p>
   * <p>Resolve une promesse si la communication avec AgatheLink est établie</p>
   * @private
   */
  function getStatutEmotionLink(minutesToWait) {
    logTra.debug("_getStatutEmotionLink");
    let dfd = $.Deferred();
    let compteur = 0;
    let compteurApresConnexion = 0;
    let processingLoop = false;
    let emotionlinkConnected = false;
    let boucle = window.setInterval(() => {
      if (emotionlinkConnected) {
        this.isExistEmotionLink = true;
        compteurApresConnexion += 1;
        console.info("connecté à AgatheLink, attente chargement des FSV....");
      } else {
        console.error("tentative de connexion a EmotionLink - AgatheLink....");
        emotionlinkConnected = emotionlinkConnected || cbaLink.services.fsvlink.fsvConnect(true);
      }
      if (!processingLoop) {
        processingLoop = true;
        logTra.debug("fsvConnect()");
        let percentDonwloaded = 0;
        // au bout de "minutesToWait" minutes, il faut l'arreter
        if (compteur > 30 * minutesToWait) {
          console.error(`temps d'attente dépassé pour la connexion à AgatheLink après ${minutesToWait} minutes`);
          window.clearInterval(boucle);
          dfd.reject("timeout");

          //Si c'est ok => EmotionLink - AgatheLink est lancé => on attend 10 secondes que les API soient completement chargée et  c'est terminé
        } else if (compteurApresConnexion > 5) {
          console.info("connecté à AgatheLink avec succès");
          window.clearInterval(boucle);
          dfd.resolve("EL restarted");
        } else {
          //On attend la prochaine boucle
          compteur += 1;
        }
        processingLoop = false;
      }
    }, 2000 //relancer la fonction toute les 2 sec
    );

    return dfd.promise();
  }
  exports.fsvcall = new FsvCall();
})(cbaLink.services);

/***/ }),

/***/ "./projects/lib-agathe-link/js/fsvemotionlink.1.0.js":
/*!***********************************************************!*\
  !*** ./projects/lib-agathe-link/js/fsvemotionlink.1.0.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


//definition d'un module pour la communication avec le TLA via ce qu'ona appelé la partie lib fsvemotionlink
const mokLogTra = __webpack_require__(/*! ./logtra */ "./projects/lib-agathe-link/js/logtra.js");
const logTra = new mokLogTra();
const mokCbaService = __webpack_require__(/*! ./cbaservice */ "./projects/lib-agathe-link/js/cbaservice.js");
const cbaServices = new mokCbaService();
const EmotionGenDialog = __webpack_require__(/*! ./EmotionGenDialog */ "./projects/lib-agathe-link/js/EmotionGenDialog.js");
(function (exports) {
  var baseUrl = "";
  var _self = window;
  function FsvLink() {
    logTra.debug("MODULE : FsvLink");
  }
  function closeAllDialogFSV() {}
  function hideDialog(idDialog) {
    cbaLink.services.frontend.hideDialog(idDialog);
  }
  function showDialog(idDialog, errMessage) {
    cbaLink.services.frontend.showDialog(idDialog, errMessage);
  }

  // *************************************************
  // WebSocket Communication
  // *************************************************

  // parametre pour optimisation performance >> robustesse
  var EMOTIONLINK_PERFORMANCE_OVERRULE_ROBUSTNESS = true;

  // les éléments de gestion de l'échange de req/resp fsv
  var _fsvCalls = new FsvCallStack();
  // listener des actions (ex: pour la CPs et le codePorteur) qui sont renseignés par des popup de dialogue.
  var _fsvContext = new FsvMonitor();
  // la websocket
  var _websocketEmotionLink = new EmotionLinkWebSocket();
  // la tentative de redetection du tla
  cbaLink.environment.tlaRedetection = false;
  // la tentative de reboot de EmotionLink - AgatheLink
  cbaLink.environment.reboot = false;
  var EMOTIONLINK_VERSION_REQUIRED = 101;
  _self._clientInformations = {};

  //_versionEmotionLinkNewPopup
  //cette constante permet de choisir si on passe par l'assistant de mise à jour AL/EL ou par un popup simple qui démarre et signale la mise à jour
  //L'assistant de mise à jour est compatible à partir de EL 1.16
  //On passe la version minimum a 200 pour désactiver l'assistant le temps de le réparer voir EM-3722
  const _versionEmotionLinkNewPopup = 116;
  var _versionEmotionLinkRequise;
  var _versionOsObsolete = false;
  let withPatch_EM_2282 = false; //activation/desactivation du patch pour corriger le bug de détection des lecteurs PCSC; cf EM-2282 et EM-2562

  var _IInternal = {
    fsvVerificationCartePSAndCodePorteur: _fsvVerificationCartePSAndCodePorteur,
    fsvDisplayCartePSAbsente: _fsvDisplayCartePSAbsente,
    fsvDisplayCodePorteurDialog: _fsvDisplayCodePorteurDialog,
    fsvReinit: _fsvReinit,
    fsvLectureEtatCPS: _fsvLectureEtatCPS,
    parseEtatCartePs: _parseEtatCartePs,
    fillParametersWithCurrentCodePorteur: _fillParametersWithCurrentCodePorteur,
    _versionClientAutorise: "debugjeje",
    EnumErreurTLA: {
      API: {
        CPS_NON_PRESENTE: 8,
        CPS_NON_PRESENTE_PKCS11: -1051
      }
    }
  };
  FsvLink.prototype.ExchangeMessage = ExchangeMessage;
  FsvLink.prototype.fsv = fsv;
  FsvLink.prototype.fsvConnect = fsvConnect;
  FsvLink.prototype.fsvConnectAsync = fsvConnectAsync;
  FsvLink.prototype.fsvWithCpsConstraints = fsvWithCpsConstraints;
  FsvLink.prototype.fsvCodePorteurValidation = fsvCodePorteurValidation;
  FsvLink.prototype.fsvCartePSValidation = fsvCartePSValidation;
  FsvLink.prototype.codePorteurIns = codePorteurIns;
  FsvLink.prototype.codePorteurRst = codePorteurRst;
  FsvLink.prototype.fsvVerificationCartePSAndCodePorteur = _fsvVerificationCartePSAndCodePorteur;
  FsvLink.prototype.getEmotionLinkInformations = getEmotionLinkInformations;
  FsvLink.prototype.fsvEmotionLinkCheckVersion = fsvEmotionLinkCheckVersion;
  FsvLink.prototype.fsvEmotionLinkCheckVersionBis = fsvEmotionLinkCheckVersionBis;
  FsvLink.prototype.setEmotionLinkFsvVersionToUse = setEmotionLinkFsvVersionToUse;
  FsvLink.prototype.demarreGestionnaireCertificatCPS = emotionLinkDemarreGestionnaireCertificatCPS;
  FsvLink.prototype.downloadEmotionLinkComplete = downloadEmotionLinkComplete;
  FsvLink.prototype.getEmotionLinkTypeOS = getEmotionLinkTypeOS;
  FsvLink.prototype.getEmotionLinkVersionClientAutorise = getEmotionLinkVersionClientAutorise;
  FsvLink.prototype.updateTla = updateTla;
  FsvLink.prototype.sendTlaUpdatefile = sendTlaUpdatefile;
  FsvLink.prototype.getStatusUpdatingTla = getStatusUpdatingTla;
  FsvLink.prototype.getOsInformations = getOsInformations;
  FsvLink.prototype.getBrowserInformations = getBrowserInformations;
  FsvLink.prototype.fsvLectureEtatCPS = _fsvLectureEtatCPS;
  FsvLink.prototype.getStatusUpdatingEmotionlink = getStatusUpdatingEmotionlink;
  FsvLink.prototype.checkVersionAutorise = checkVersionAutorise;
  FsvLink.prototype.setIsVersionAutorise = _setIsVersionAutorise;
  FsvLink.prototype.clientVersion = function () {
    return _clientInformations.appVersion;
  };
  FsvLink.prototype.clientInformations = function () {
    return _clientInformations;
  };
  FsvLink.prototype.lectureEtatCps = lectureEtatCPS;

  /**
   * Une pile des appels fait à EmotionLink - AgatheLink. Le rôle de cette pile est de :
   *
   * 1/ placer un "post-it" appelé communicationId sur un appel pour être capable quand une réponse est récupérée d'identifier à quelle
   * requête elle fait référence.
   *
   * 2/ enregistrer le fait qu'un appel asynchrone a été lancé : pour cela le developer fournit le exMsg de l'appel et un deferred comme
   * "handler" représentant l'attente de la réponse.
   *
   * 3/ résoudre une réponse qui arrive en retour. La requête initiale est inconnue, la pile va chercher cette requête en regardant le
   * communicationId et elle va "fire" le deferred qui a été enregistré au moment de l'appel avec la requête. Le fire se fait en passant comme
   * paramètre le exMsg qui représente la réponse. On lira en particulier la propriété dataBase64 qui est le content de la réponse.
   */
  function FsvCallStack() {
    var _stack = new Map();
    this.registerCommunication = function (exMsg, dfd) {
      exMsg.communicationId = exMsg.nomFonction + Math.floor(Math.random() * (1 + 100000));
      logTra.debug("FsvCallStack $$$$ registration of token : " + exMsg.communicationId);
      _stack.set(exMsg.communicationId, dfd);
    };
    this.getCommunication = function (exMsg) {
      return _stack.get(exMsg.communicationId);
    };
    this.resolveCommunication = function (exMsg) {
      logTra.debug("FsvCallStack $$$$ resolution of token : " + exMsg.communicationId);
      let dfd = this.getCommunication(exMsg);
      if (dfd) {
        dfd.resolve(exMsg);
      }
    };
  }

  /**
   *
   * Un écouteur d'evenement de la durée de vie de la page web. Il permet de mettre en attente des traitements et de lancer des suites, sans
   * que le developer soit "condamné" à réaliser un chainage de CB. Le cas d'usage est l'utilisation de plusieurs popups intermédiaires
   * pendant un traitement qui rendent le chainage des CB avec des paramètres assez tordus(checkCodeporteur, checkCPS). Par souci de
   * lisibilité on peut aussi vouloir éviter N var globales et plutot enregistrer des "steps" d'un process via ce composant unique et protégé.
   *
   * Usage : on ajoute/retire des listeners sous la forme d'un deferred relié à un "nom logique". Un jour quelqu'un appel notre Monitor pour
   * résoudre un de ces nom logique avec en paramètre un objet utile (un exMsg pour nous) qui sera transmis au deferred. Cela relancera le
   * process mis en attente.
   *
   */
  function FsvMonitor() {
    var _listenerMap = new Map();
    this.addListener = function (listenerName, dfd) {
      logTra.debug("FsvMonitor :::: register a listener named : " + listenerName);
      _listenerMap.set(listenerName, dfd);
    };
    this.removeListener = function (listenerName) {
      logTra.debug("FsvMonitor :::: remove a listener named : " + listenerName);
      _listenerMap.pop(listenerName);
    };
    this.resolve = function (listenerName, o) {
      logTra.debug("FsvMonitor :::: is firing a resolve on : " + listenerName);
      if (_listenerMap.get(listenerName)) {
        return _listenerMap.get(listenerName).resolve(o);
      }
    };
    this.reject = function (listenerName, o) {
      logTra.debug("FsvMonitor :::: is firing a reject on : " + listenerName);
      if (_listenerMap.get(listenerName)) {
        return _listenerMap.get(listenerName).reject(o);
      }
    };
  }

  /**
   * La WebSocket encapsulé dans un composant métier.
   *
   * Elle envoit ET reçoit des messages, et s'interface avec notre pile d'appel pour gérer l'aspect request/response.
   */
  function EmotionLinkWebSocket() {
    // https://localhost:8013/emotionLink/fsv
    var protocol = "wss"; // "ws";
    var host = "localhost";
    var port = "8013";
    var buzUrl = "emotionLink/fsv";
    var wsUri = protocol + "://" + host + ":" + port + "/" + buzUrl;
    var ws = new WebSocket(wsUri);
    ws.onopen = function (evt) {
      logTra.debug("FsvLink >>>> WebSocket : open on " + wsUri + " at " + new Date());

      // Demande d'informations sur EmotionLink - AgatheLink et la validité de sa version
      fsvEmotionLinkCheckVersion();
    };
    ws.onclose = function (evt) {
      logTra.debug("FsvLink >>>> WebSocket : close");
    };
    ws.onerror = function (evt) {
      logTra.debug("FsvLink >>>> WebSocket : on error");
    };
    ws.onmessage = function (evt) {
      // 		logTra.debug("FsvLink >>>> WebSocket : on message ==> " + JSON.stringify(evt.data));
      var exMsg = new ExchangeMessage().init(JSON.parse(evt.data));
      // résout l'appelant grace au communicationId
      _fsvCalls.resolveCommunication(exMsg);
    };
    this.getWs = function () {
      return ws;
    };
    this.send = function (exMsg) {
      var sendMessage = JSON.stringify(exMsg);
      ws.send(sendMessage);
      //logTra.debug("FsvLink >>> WebSocket : has been send : sendMessage = " + sendMessage);
    };
  }

  /**
   * Est une représentation d'un message échangé avec EmotionLink - AgatheLink, correspondant à la classe java de EmotionLink - AgatheLink pour assurer une
   * JSONification simple.
   *
   * @param nomFonction
   * @param arguments
   * @param dataBase64
   */
  function ExchangeMessage(nomFonction, args, dataBase64, msg = null) {
    this.nomFonction = nomFonction;
    this.arguments = args;
    this.dataBase64 = dataBase64;
    this.communicationId = "non_renseigné";
    this.cpsEtatCarte = cbaLink.environment.cpsEtatRead;
    //gestion des erreurs sur EmotionLink - AgatheLink
    this.erreurGlobale = 0;
    this.erreurApi = 0;
    this.message = msg;
    this.isCrypted = false;
  }
  ExchangeMessage.prototype.init = function (initObj) {
    this.nomFonction = initObj.nomFonction ? initObj.nomFonction : null;
    this.arguments = initObj.arguments ? initObj.arguments : null;
    this.dataBase64 = initObj.dataBase64 ? initObj.dataBase64 : null;
    this.communicationId = initObj.communicationId ? initObj.communicationId : 'non_renseigné';
    this.cpsEtatCarte = initObj.cpsEtatCarte ? initObj.cpsEtatCarte : null;
    //gestion des erreurs sur EmotionLink - AgatheLink
    this.erreurGlobale = initObj.erreurGlobale ? initObj.erreurGlobale : 0;
    this.erreurApi = initObj.erreurApi ? initObj.erreurApi : 0;
    this.message = initObj.message ? initObj.message : null;
    this.isCrypted = initObj.isCrypted ? initObj.isCrypted : false;
    return this;
  };
  ExchangeMessage.prototype.isInError = function () {
    return this.isInGlobalError() || this.isErreurAPI().ANY();
  };
  ExchangeMessage.prototype.isInGlobalError = function () {
    return this.erreurGlobale !== 0;
  };
  ExchangeMessage.prototype.isErreurAPI = function () {
    var _self = this;
    return {
      CPS_NON_PRESENTE: function () {
        return _self.erreurApi === _IInternal.EnumErreurTLA.API.CPS_NON_PRESENTE || _self.erreurApi === _IInternal.EnumErreurTLA.API.CPS_NON_PRESENTE_PKCS11;
      },
      ANY: function () {
        return _self.erreurApi !== 0;
      },
      LECTEUR: function () {
        return _self.erreurApi === 512 || _self.erreurApi === 32780 || _self.erreurApi === -1056 || _self.erreurApi === 1024 /*|| _self.erreurApi === 61697*/;
      }
    };
  };

  /**
   * Connexion à FSV ? indique si la connexion websocket a été faites. Cela devrait déja être le cas à l'init d'une page (sauf indisponibilité
   * de EmotionLink - AgatheLink). Si on passe le initFsv on tentera quand même de créer la connexion si elle n'existe pas. Si pas de websocket on doit
   * informer l'utilisateur dans la fonction appelante.
   *
   * @param initFsv
   *            Indique si initialisation de la Websocket est nécessaire en cas de non dispo initiale
   */
  function fsvConnect(initFsv) {
    var wsStatus = false;

    // test de l'existence de la connexion websocket : ouverte et disponible
    if (_websocketEmotionLink && _websocketEmotionLink.getWs() && _websocketEmotionLink.getWs().readyState == 1) {
      return true;
    }

    // tentative de création du websocket si non ouverte/disponible, et si demande explicite via initFsv
    if (initFsv && !wsStatus) {
      if (_websocketEmotionLink && _websocketEmotionLink.getWs()) {
        _websocketEmotionLink.getWs().close();
        _websocketEmotionLink = null;
      }
      logTra.debug("FsvLink >>> WebSocket : fsvConnect : try to reconnect a non open ws");
      _websocketEmotionLink = new EmotionLinkWebSocket();
      if (_websocketEmotionLink && _websocketEmotionLink.getWs() && _websocketEmotionLink.getWs().readyState == 1) {
        wsStatus = true;
      }
    }
    logTra.debug("FsvLink >>> WebSocket : channel open status = " + wsStatus);
    return wsStatus;
  }
  function fsvConnectAsync() {
    let dfd = jquery__WEBPACK_IMPORTED_MODULE_0__.Deferred();
    let wsAvailable = function () {
      if (_websocketEmotionLink && _websocketEmotionLink.getWs() && _websocketEmotionLink.getWs().readyState == 1) {
        return true;
      }
      return false;
    };

    // test de l'existence de la connexion websocket : ouverte et disponible
    if (wsAvailable()) {
      logTra.debug("FsvLink.fsvConnectAsync >>> WebSocket is available");
      dfd.resolve();
    } else {
      logTra.debug("FsvLink.fsvConnectAsync >>> WebSocket : try to reconnect a non open ws");
      _websocketEmotionLink = new EmotionLinkWebSocket();
      let loopTestIndex = 5;
      let intervalID = setInterval(function () {
        logTra.debug("FsvLink.fsvConnectAsync: test de wsAvailable");
        if (wsAvailable()) {
          logTra.debug("FsvLink.fsvConnectAsync: yes wsAvailable - resolve");
          clearInterval(intervalID);
          dfd.resolve();
        } else {
          if (loopTestIndex === 5) {
            // connexionEnCoursDialog.show(cbaLink.ui.tools.messages.fsvemotionlink.fsvConnectAsync.message(), 5000); // debugjeje
            loopTestIndex--;
          } else if (loopTestIndex === 0) {
            logTra.debug("FsvLink.fsvConnectAsync: 5*no wsAvailable - reject");
            clearInterval(intervalID);
            dfd.reject();
          } else {
            loopTestIndex--;
          }
        }
      }, 1000);
    }
    return dfd.promise();
  }

  /**
   * Appel d'une fonction FSV. Les params sont encapsulés dans un exchangeMsg qui sera envoyé par Websocket. L'appel est asynchrone, on
   * retournera une promise. Le defered est dans une stack métier et sera "fired" par la websocket.
   *
   * @param name
   *            Le nom de la fonction
   * @param parameters
   *            Les paramètres
   * @param dataBase64
   *            Les données encodées en base 64
   * @param dontCheckVersionAutorise
   *           Indique de ne pas verifier la version
   * @param message
   *
   * @returns une promise surlaquelle d'autres CB peuvent être bind
   */
  function fsv(name, parameters, dataBase64, dontCheckVersionAutorise, message) {
    dontCheckVersionAutorise = true; // debugjeje

    var fsvCallActionDefered = jquery__WEBPACK_IMPORTED_MODULE_0__.Deferred();
    logTra.debug("FsvLink >>> fsv() called action = " + name + " & parameters = " + parameters);
    logTra.debug("FsvLink >>>> call fsv > _versionClientAutorise = " + self._versionClientAutorise);
    if (dontCheckVersionAutorise != true && self._versionClientAutorise == undefined) {
      // Cas check versions non fait > réessayer
      // TODO a voir showDialogRetry();
      return fsvCallActionDefered.reject();
    }
    checkVersionAutorise(dontCheckVersionAutorise).then(majNecessaire => {
      // EM-4627 : Si on est sur firefox, on ne propose pas la maj
      if (majNecessaire && getBrowserInformations().browserName != "Firefox") {
        // La maj d'EmotionLink - AgatheLink est necessaire
        if (_clientInformations.appVersion >= _versionEmotionLinkNewPopup) {
          cbaLink.fsv.miseAJourEmotionLinkController.loadPopupMiseAJourEmotionLink();
        } else {
          // la maj d'EmotionLink - AgatheLink est necessaire
          showDialogUpdateRequired();
        }
        return fsvCallActionDefered.reject();
      } else {
        //cas normal, appel la commmande EmotionLink - AgatheLink
        if (name != cbaLink.environment.COMMANDE_CHECK) {
          var exMsg = new ExchangeMessage(name, parameters, dataBase64, message);
          _fsvCalls.registerCommunication(exMsg, fsvCallActionDefered);
          _websocketEmotionLink.send(exMsg);
        } else {
          fsvCallActionDefered.resolve();
        }
      }
    });
    return fsvCallActionDefered.promise();
  }

  /**
   * Verifie si la versionEmotionLink du client peut etre utilisé pour travailler avec le site monAgathe Emotion.
   * verifie si l'OS n'est pas oboslète avant de proposer la maj d'EmotionLink - AgatheLink
   *
   * @param dontCheckVersionAutorise
   * @returns {*} retourne une promesse. la résolution de la promesse retourne "vrai" si une mise à jour est necessaire
   */
  function checkVersionAutorise(dontCheckVersionAutorise) {
    let dfd = jquery__WEBPACK_IMPORTED_MODULE_0__.Deferred();
    dfd.resolve(false);
    return dfd.promise();
    if (dontCheckVersionAutorise == true) {
      dfd.resolve(false);
    }
    if (self._versionClientAutorise == false) {
      // Cas version non à jour > mise à jour obligatoire
      dfd.resolve(true);
    } else if (_versionOsObsolete == true) {
      // Cas version à jour mais OS Obsolète, affiche un avertissment tous les x jours
      showDialogOsObsolete().then(() => {
        dfd.resolve(false);
      });
    } else {
      //Cas version client à jour ou autorisée
      dfd.resolve(false);
    }
    return dfd.promise();
  }

  /**
   * Force la variable "_versionClientAutorise" à true suite à une installation d'un nouveau client
   * Ne jamais setter dans un autre cas
   * Cette méthode pourra être supprimé et remplacer par la fonction fsvEmotionLinkCheckVersion() quand elle n'aura plus d'effet de bord
   * @deprecated
   */
  function _setIsVersionAutorise() {
    self._versionClientAutorise = true;
  }

  /**
   * Appel d'une fonction FSV, nécéssitant que le code porteur soit validé pour l'appel. La fonction propose 2 modes : optimiste (la CPS
   * en cache-page est la même pour notre infirmière) pessimiste (systématiquement reload des infos via le TLA)
   *
   * En mode pessimiste une conversation incluant les tests préliminaires à la réalisation de l'appel métier est créée. Elle sera
   * retournée sous forme d'un deferred qui sera resolve ou reject selon le résultat des tests.
   *
   * Notez bien que même "resolved" le exMsg peut porter les infos d'une exception dans ses fields ! Ceci explique qu'on peut traiter
   * seulement resolve sur cette conversation si on le désire, mais que cela nuit à la lisibilité de l'appel.
   *
   * @author GBE
   * @date revision 27/05/2016
   *
   * @param name
   *            Le nom de la fonction
   * @param parameters
   *            Les paramètres
   * @param dataBase64
   *            Les données encodées en base 64
   * @returns une promise surlaquelle d'autres CB peuvent être bind
   */
  function fsvWithCpsConstraints(name, parameters, dataBase64, cartePsPresenceMandatory, codePinMandatory, affichageFunction, callbackOptions) {
    logTra.debug("FsvLink >>> WebSocket : MODE OPTIMISE=" + EMOTIONLINK_PERFORMANCE_OVERRULE_ROBUSTNESS + " fsvWithCpsConstraints() " + name + " - " + parameters);

    // utilisé pour indiquer un changement de mode locale de optimisé vers
    // robuste
    var local_switch_mode_on_pessimistic = false;

    // le code pin mandatory repasse directement en mode pessimiste (demande
    // obligatoire de CP).la CPS aussi (chgt de CPS pour facturer en dégradé
    // chez une collègue sur la meme page web)
    if (codePinMandatory) {
      local_switch_mode_on_pessimistic = true;
      logTra.debug("FsvLink >>> WebSocket : fsvWithCpsConstraints() SWITCH MODE VERS ROBUST " + name + " - " + parameters);
    }

    // **********************************************************************************
    // OPTIMISTIC MODE (tried first) : check var global
    // **********************************************************************************
    // Mode optimisé, utilise les var globales cpsXXX
    // on tente l'appel métier directement (mode optimiste)
    if (EMOTIONLINK_PERFORMANCE_OVERRULE_ROBUSTNESS && !local_switch_mode_on_pessimistic) {
      // l'exception lire carte vitale sans carte CPS
      if (name === cbaLink.environment.COMMANDE_SSV_LIREDROITSVITALE) {
        if (cbaLink.environment.cpsPresente && !cbaLink.environment.cpsCodeActif) {
          local_switch_mode_on_pessimistic = true;
          logTra.debug("FsvLink >>> WebSocket : fsvWithCpsConstraints() SWITCH MODE VERS ROBUST " + name + " - " + parameters);
        } else {
          return fsv(name, _IInternal.fillParametersWithCurrentCodePorteur(parameters, cbaLink.environment.codePorteur), dataBase64);
        }
      } else {
        // la lecture (optimiste, le tla pouvant avoir une autre vision) du
        // code porteur avec la var en session globale. On indique en fait :
        // inutile de lire la CPs plusieurs fois si on a déja des infos de
        // session de page (même si elles peuvent être périmées sur evt
        // exceptionnel)
        if (cbaLink.environment.cpsEtatRead && cbaLink.environment.cpsCodeActif) {
          return fsv(name, _IInternal.fillParametersWithCurrentCodePorteur(parameters, cbaLink.environment.codePorteur), dataBase64);
        } else {
          local_switch_mode_on_pessimistic = true;
          logTra.debug("FsvLink >>> WebSocket : fsvWithCpsConstraints() SWITCH MODE VERS ROBUST " + name + " - " + parameters);
        }
      }
    }

    // **********************************************************************************
    // PESSIMISTIC MODE : check Cps
    // **********************************************************************************
    // Mode CNDA robuste OU on a mis en switch le mode localement ci dessus
    // on entame une conversation pour réaliser l'appel fsv après controles
    if (!EMOTIONLINK_PERFORMANCE_OVERRULE_ROBUSTNESS || local_switch_mode_on_pessimistic) {
      return _IInternal.fsvVerificationCartePSAndCodePorteur(cartePsPresenceMandatory, codePinMandatory, null, callbackOptions).then(function (exMsg) {
        if (exMsg && (exMsg.isErreurAPI().ANY() || exMsg.isInGlobalError())) {
          // let promise = $.Deferred();
          // promise.reject(exMsg);
          // return promise
          _fsvContext.reject("conversationFSV", exMsg);
          return exMsg;
        }
        if (affichageFunction) {
          affichageFunction();
        }
        return fsv(name, _IInternal.fillParametersWithCurrentCodePorteur(parameters, cbaLink.environment.codePorteur), dataBase64).then(function (o) {
          _fsvContext.resolve("conversationFSV", o);
          return o;
        });
      }, function (o) {
        _fsvContext.reject("conversationFSV", o);
        return o;
      }).then(exMsg => cbaLink.services.fsvcall.tla(exMsg, () => fsvWithCpsConstraints(name, parameters, dataBase64, cartePsPresenceMandatory, codePinMandatory, affichageFunction, callbackOptions)));
    }
  }

  /**
   * Fait une demande de renseignement du code porteur auprès de l'utilisateur. Détecte si la CPS est absente et demander son introduction au
   * préalable si c'est le cas.
   *
   * Ce process est un traitement "en parrallèle" d'un autre, et il se synchronize (thread.join like) avec un autre process via notre
   * fsvContext et ses listeners. Une fois réalisé le monitorDfd sera notifié.
   *
   * @param cartePsPresenceMandatory
   * @param codePinMandatory
   * @param monitorDfd
   *
   * @return void
   */
  function _fsvVerificationCartePSAndCodePorteur(cartePsPresenceMandatory, codePinMandatory, monitorDfd, callbackOptions) {
    var erreur = '';
    var listenerCPS = 'verificationCPS';
    var verificationCPSDfd = jquery__WEBPACK_IMPORTED_MODULE_0__.Deferred();
    var listenerCodePorteur = 'verificationCodePorteur';
    var verificationCodePorteurfd = jquery__WEBPACK_IMPORTED_MODULE_0__.Deferred();
    logTra.debug("_fsvVerificationCartePSAndCodePorteur - cartePsPresenceMandatory [" + cartePsPresenceMandatory + "] - codePinMandatory [" + codePinMandatory + "]");
    var verificationCPSandCodePorteurListener = "verificationCPSandCodePorteur";

    // si un defered est fourni (1er appel) alors
    // positionne le listener pour l'ensemble des verifications
    // si il est résolu on commitera sans doute la conversation chez le caller.

    if (monitorDfd) {
      _fsvContext.addListener(verificationCPSandCodePorteurListener, monitorDfd);
    }
    return _IInternal.fsvLectureEtatCPS().then(function (exMsg) {
      let cpsPresente = cbaLink.environment.cpsPresente;
      // CB : recommencer le check. Depend du bon/mauvais renseignement du
      // codePorteur et de l'introduction de la CPS
      function _doAgainCallback(exMsgResponse) {
        // Si on vient de renseigner le codePorteur et qu'il était mandatory
        var IsStillMandatory = true;
        if (!codePinMandatory) {
          IsStillMandatory = false;
        } else if (exMsgResponse && exMsgResponse.codePorteurHasBeenCorrectlyProvidedByUser) {
          IsStillMandatory = false;
        }
        return _IInternal.fsvVerificationCartePSAndCodePorteur(cartePsPresenceMandatory, IsStillMandatory);
      }
      ;
      function _refuseInsertionCPSByCancellingCallback() {
        let result = _fsvContext.reject(verificationCPSandCodePorteurListener, exMsg);
        if (result) {
          return result;
        }
        return exMsg;
      }
      function _refuseSaisieCodePorteurCPSByCancellingCallback() {
        let result = _fsvContext.reject(verificationCPSandCodePorteurListener, exMsg);
        if (result) {
          return result;
        }
        return exMsg;
      }

      //SEB : hijack de l'erreur retournée / cas particulier utilisation de la cryptolib/pkcs11
      if (exMsg && exMsg.erreurApi == -1051) {
        if (!cartePsPresenceMandatory) {
          //Si carte CPS absente ou invalide, et qu'elle n'est pas obligatoire (cas lecture droits vitale)
          //on fait quand meme appel aux fonction ssv pour recupérer le bon code erreur API
          //exMsg = new ExchangeMessage(exMsg.nomFonction, exMsg.args, null);
          exMsg.erreurApi = 0;
          return exMsg;
        } else {
          //on considère que la CPS est absente, propose de la réinsérer
        }
      }
      if (callbackOptions && callbackOptions.showDialogFromExternalContext) {
        callbackOptions.showDialogFromExternalContext();
      }
      if (exMsg.isInGlobalError()) {
        erreur = cbaLink.services.fsvcall.traiteErreurGlobale();
        if (callbackOptions && callbackOptions.hideDialogOpenedFromExternalContext) {
          callbackOptions.hideDialogOpenedFromExternalContext();
        }
        cbaLink.services.fsvcall.stopTraitement(erreur);
        _fsvContext.reject(verificationCPSandCodePorteurListener, exMsg);
        return exMsg;
      } else if (exMsg.isErreurAPI().CPS_NON_PRESENTE()) {
        cpsPresente = false;
        logTra.debug("CPS non présente, on va demander son introduction");
        _fsvContext.reject(verificationCPSandCodePorteurListener, exMsg);
        return exMsg;
      } else if (exMsg.isErreurAPI().ANY()) {
        //reject and return sur une erreur (ex: TLA non connecté)
        erreur = cbaLink.services.fsvcall.traiteErreurApi(exMsg.erreurApi, exMsg.message);
        if (callbackOptions && callbackOptions.hideDialogOpenedFromExternalContext) {
          callbackOptions.hideDialogOpenedFromExternalContext();
        }
        cbaLink.services.fsvcall.stopTraitement(erreur, undefined, !exMsg.isErreurAPI().LECTEUR());
        _fsvContext.reject(verificationCPSandCodePorteurListener, exMsg);
        return exMsg;
      } else {
        cpsPresente = true;
      }

      // carte PS doit être présente ?
      // (!cpsPresente && cartePsPresenceMandatory) => le Tla dit ne pas avoir
      // de CPS enclenchée, mais elle est obligatoire dans notre appel
      if (!cpsPresente && cartePsPresenceMandatory) {
        hideDialog("dialogAccesLecteur");
        if (callbackOptions && callbackOptions.hideDialogOpenedFromExternalContext) {
          callbackOptions.hideDialogOpenedFromExternalContext();
        }
        _fsvContext.addListener(listenerCPS, verificationCPSDfd);
        _IInternal.fsvDisplayCartePSAbsente(listenerCPS);
        return verificationCPSDfd.then(_doAgainCallback, _refuseInsertionCPSByCancellingCallback);
      }

      // le Tla indique que le code porteur n'est pas actif alors qu'une CPS
      // est enclenchée. OU saisir le code porteur est de toute facon
      // obligatoire
      // (cpsPresente && codePinMandatory) => la CPS est presente et le
      // codePin doit être demandé
      // (cpsPresente && !exMsg.cpsCodeActif) => la CPS est presente et le
      // code porteur n'est actuellement pas renseigné sur le Tla
      if (cpsPresente && codePinMandatory || cpsPresente && !exMsg.cpsCodeActif) {
        // saisie du code porteur nécessaire
        exMsg.erreurApi = -160;
        cbaLink.environment.cpsNumeroSerie = exMsg.cpsNumeroSerie;
        return _fsvContext.reject(verificationCPSandCodePorteurListener, exMsg);
      }

      // si tout est déja OK ou si après N retour cela s'est enfin bien passé
      return _fsvContext.resolve(verificationCPSandCodePorteurListener, exMsg);
    });
    // *********** Call Me May be **********

    // IMPORTANT : return void (thread like)
  }

  /**
   * Fonction générale demandant d'introduire la CPS. Se synchronize avec un autre traitement (thread like) via notre fsvContext et ses
   * listeners.
   *
   * @author SEB
   * @date 01 fevrier 2016
   * @param okCallback
   * @param cancelCallback
   * @param message
   *
   * @return a promise
   */
  function _fsvDisplayCartePSAbsente(listenerName, message) {
    showDialog("dialogIntroduireCPS");
  }
  function _fsvReinit() {
    let dfd = jquery__WEBPACK_IMPORTED_MODULE_0__.Deferred();
    try {
      logTra.debug("_fsvReinit : start");
      try {
        //le fait de lancer la commande "COMMANDE_RESOLVE_TLA_DETECTION_ISSUE" permet de recharger les API FSV, et donc de les reinit'
        fsv(cbaLink.environment.COMMANDE_RESOLVE_TLA_DETECTION_ISSUE, null, null, true).then(() => {
          dfd.resolve('succes reinit fsv');
        }, () => {
          dfd.resolve('succes reinit fsv');
        });
      } catch (err) {
        logTra.debug("_fsvReinit - Err - " + err);
      }
      logTra.debug("_fsvReinit : return promise");
    } catch (err) {
      logTra.debug("_fsvReinit - Err - " + err);
    }
    return dfd.promise();
  }

  /**
   * Fonction générale chargeant le dialog permettant de saisir le code porteur. On n'utilise plus d'action, juste affichage du popup.Se
   * synchronize avec un autre traitement (thread like) via notre fsvContext et ses listeners.
   *
   * @author DQU
   * @date 02 septembre 2015
   * @param ressource
   * @param nomPss
   * @param nbTentative
   * @param numeroSerie
   * @param functionJSToCall
   * @param message
   */
  function _fsvDisplayCodePorteurDialog(listenerName, nomPs, nbTentative, numeroSerie, message) {
    // Vérification - Si nb tentas épuisées on affiche carte bloquée
    if (nbTentative < 1) {
      cbaLink.services.fsvcall.stopTraitement("Tentatives de code épuisées, votre carte est bloquée");
      return;
    }

    //ancienemment dojo.byId("contentCodePorteur"); mais la fonction byId est undefined n'étant sans doute pas encore chargée (en loccurence
    // lors de la connexion en tant que remplaçant)
    var divCPorteur = document.getElementById("contentCodePorteur");

    // Texte Nombre de tentatives + msg erreur
    var texteTentas = "<div style='vertical-align: middle' class='evidence'>Il reste " + nbTentative;
    if (nbTentative > 1) {
      texteTentas += " tentatives</div>";
    } else {
      texteTentas += " tentative</div><br/><div class='warningRed'>DERNI&Egrave;RE TENTATIVE !</div>";
    }

    // Construction du contenu du popup de saisie du code porteur
    var chiffres = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
    var tableCPorteur = "";
    if (nomPs && nomPs !== "") {
      tableCPorteur += "<div id='divCodePorteurNomPs' style='width : 100%; text-align: center; min-height : 30px'>" + nomPs + "</div>";
    }
    if (message && message !== "") {
      tableCPorteur += "<div id='divSMessage' style='width : 100%; text-align: center; min-height : 20px'>" + message + "</div>";
    }
    tableCPorteur += texteTentas;
    if (numeroSerie) {
      tableCPorteur += "<input type='hidden' id='divCodePorteurCpsNumSerie' value='" + numeroSerie + "'></input>";
    }
    tableCPorteur += "<table id='tableCodePorteur' border='0' cellpadding='15' cellspacing='0' align='center' width='100%'>";
    tableCPorteur += "<input type='hidden' id='CodePorteurHid' value='' />";
    tableCPorteur += "<table border='0' cellpadding='15' cellspacing='10' align='center' width='100%' style='background-color:#d3d3d3;'>";
    tableCPorteur += "<tr>";
    tableCPorteur += "<td>";
    tableCPorteur += "<table border='0' cellpadding='0' cellspacing='10' align='center'>";
    tableCPorteur += "<tr>";
    tableCPorteur += "<td id='codePorteur' colspan='3' align='center'><input id='codePorteurVal' type='password' value='' maxlength='4' disabled='disabled' /></td>";
    tableCPorteur += "</tr>";
    tableCPorteur += "<tr>";
    var indTDcp = 0;
    var index;
    for (index = 0; index < chiffres.length; index++) {
      indTDcp++;
      if (index == 9) {
        tableCPorteur += "<td id='posANN' onclick='javascript:codePorteurRst();'>CORRIGER</td>";
      }
      tableCPorteur += "<td id='pos" + index + "' onclick='javascript:codePorteurIns(" + chiffres[index] + ");'>" + chiffres[index] + "</td>";
      if (index == 9) {
        tableCPorteur += "<td id='posOK' onclick='javascript:fsvCodePorteurValidation(\"" + listenerName + "\");'>OK</td>";
      }
      if (indTDcp == 3) {
        tableCPorteur += "</tr><tr>";
        indTDcp = 0;
      }
    }
    tableCPorteur += "</tr>";
    tableCPorteur += "</table>";
    tableCPorteur += "</td>";
    tableCPorteur += "</tr>";
    tableCPorteur += "</table>";
    showDialog("dialogCodePorteur", tableCPorteur);
  }

  /**
   * Fonction permettant de valider le code porteur entré. Appel FSV de présentation du code. Se synchronize avec un autre traitement (thread
   * like) via notre fsvContext et ses listeners.
   *
   * @param callbackFuncName
   */
  function fsvCodePorteurValidation(listenerName, codePorteurParamObject, numSerieParam) {
    logTra.debug("fsvCodePorteurValidation");
    var codePorteurVal;
    if (codePorteurParamObject) {
      codePorteurVal = codePorteurParamObject;
    } else {
      codePorteurVal = document.getElementById('codePorteurVal');
    }
    if (codePorteurVal && codePorteurVal.value.length == 4) {
      var cpEdited = codePorteurVal.value;
      hideDialog("dialogCodePorteur");
      if (document.getElementById('divCodePorteurCpsRessource')) {
        cbaLink.environment.ressourceCps = document.getElementById('divCodePorteurCpsRessource').value;
      }
      if (document.getElementById('divCodePorteurCpsNumSerie')) {
        cbaLink.environment.cpsNumeroSerie = document.getElementById('divCodePorteurCpsNumSerie').value;
      } else if (numSerieParam) {
        cbaLink.environment.cpsNumeroSerie = numSerieParam;
      }

      // Présentation du code porteur à l'API CPS pour validation
      // Appel FSV (API CPS)
      // On présente le code au lecteur
      var params = cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cpEdited + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_NUMSERIE + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.cpsNumeroSerie;

      // CB def
      var _codePorteurValidation_localCB = function (exMsg, cp) {
        // Parse CpsEtatCarte
        _IInternal.parseEtatCartePs(exMsg);
        if (exMsg.erreurApi != 0) {
          // Uniquement code porteur faux (erroné) qui affiche à nouveau
          // la saisie, sinon quitter
          if (exMsg.erreurApi == -2000 || exMsg.erreurApi == 61443) {
            // Saisie du code porteur KO
            var erreur = cbaLink.services.fsvcall.traiteErreurApi(exMsg.erreurApi, exMsg.message);
            logTra.debug("Erreur FSV : [" + exMsg.erreurApi + "] " + erreur);
            exMsg.conversation_codePorteur = "le codePorteur tapé est faux. Il faut encore essayer.";
            // try again
            _fsvContext.resolve(listenerName, exMsg);
          } else {
            var erreur = cbaLink.services.fsvcall.traiteErreurApi(exMsg.erreurApi, exMsg.message);
            cbaLink.services.fsvcall.stopTraitement(erreur);
            // fail on error
            _fsvContext.reject(listenerName, exMsg);
          }
        } else {
          exMsg.conversation_codePorteur = "le codePorteur sur le Tla est renseigné.";
          // var global
          cbaLink.environment.codePorteur = cp;
          exMsg.codePorteurHasBeenCorrectlyProvidedByUser = true;
          _fsvContext.resolve(listenerName, exMsg);
        }
      }; // end CB def

      // Lecture état CPS
      // *********** Call Back ***************
      // Appel fonction FSV LINK (fsvemotioncall.js)
      var successCB = function (o) {
        _codePorteurValidation_localCB(o, cpEdited);
      };
      var presenteCodePorteurPromise = fsv(cbaLink.environment.COMMANDE_CPS_CHECKCODEPORTEUR, params, null);
      presenteCodePorteurPromise.then(successCB);
      // *********** Call Me May be **********
    } else {
      logTra.error("Le code saisi ne fait pas 4 caractères");
    }
  }

  /**
   * Fonction permettant de OK/Cancel la demande de carte PS.
   *
   * @param callbackFuncName
   */
  function fsvCartePSValidation(listenerName, action) {
    logTra.debug("fsvCartePSValidation - listenerName [" + listenerName + "] - action [" + action + "]");
    if (action == 'CANCEL') {
      _fsvContext.reject(listenerName);
    } else {
      _fsvContext.resolve(listenerName);
    }
  }
  function lectureEtatCPS() {
    return _IInternal.fsvLectureEtatCPS();
  }

  /**
   * lecture technique de la CPS, qui alimente le exMsg.
   *
   * @return a promise
   */
  function _fsvLectureEtatCPS() {
    // Check l'état de la CPS
    var params = cbaLink.environment.ARGS_RESSOURCE_CPS + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.ressourceCps;
    return fsv(cbaLink.environment.COMMANDE_CPS_READINFOSCARTE, params, null).then(function (exMsg) {
      //fix "erreur globale positionnée à -1 " > déclenche la demande de démarrer Agathelink alors qu'il est forcement démarrer ici
      //à corriger dans AgatheLink avant de supprimer les 2 lignes suivantes
      if (exMsg.erreurGlobale == -1) {
        exMsg.erreurGlobale = 0;
        if (exMsg.message.includes('ARGS_RESSOURCE_CPS')) {
          //c'est une rreur de configuration d'accès au lecteur dans le cas des lecteurs PCSC
          exMsg.erreurApi = 32780; //-> force la redétection des lecteurs
        }
      }

      // Parse CpsEtatCarte
      _IInternal.parseEtatCartePs(exMsg);
      exMsg.conversation_cps = "conversation : on a lu l'état de la carte PS";
      return exMsg;
    });
  }

  /**
   * Prend la liste des params initialement demandée dans un appel fsv. Remplace le codePorteur par la valeur à jour.
   *
   * @param params
   * @returns
   */
  function _fillParametersWithCurrentCodePorteur(params, cp) {
    // pour travailler simplement avec la String on la cloture par un separator
    // cbaLink.environment.ARGS_SEPARATOR
    params = params + cbaLink.environment.ARGS_SEPARATOR;

    // remplace le codePorteur ("" ou "XXXX")
    var searchCodePorteur = new RegExp(cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + ".{0,4}" + cbaLink.environment.ARGS_SEPARATOR);
    var paramReplaced = params.replace(searchCodePorteur, cbaLink.environment.ARGS_CODEPORTEUR + cbaLink.environment.ARGS_VALUE_SEPARATOR + cp + cbaLink.environment.ARGS_SEPARATOR);

    // retire la fin : cbaLink.environment.ARGS_SEPARATOR
    var paramsTrim = paramReplaced.substring(0, paramReplaced.length - cbaLink.environment.ARGS_SEPARATOR.length);
    return paramsTrim;
  }

  /**
   * Prend le exMsg et lui fait parser son cpsEtatCarte.
   *
   * @param exMsg
   */
  function _parseEtatCartePs(exMsg) {
    cbaLink.environment.cpsEtatRead = true;
    var etatCarteCps = exMsg.cpsEtatCarte;
    if (exMsg.erreurApi == -1056) {
      //EmotionLink - AgatheLink ne gère pas un code différent quand la CPS est non lisible, mais ce n'ets pas nécéssairement le lecteur.
      //exMsg.erreurApi = -1057; //EM386 : on ne fait plus cette translation de code erreur car la cryptolib peut retouné cette erreur quand l'api ne trouve pas de slot PCSC, dans ce cas il faut retourné une erreur lecteur
    }
    if (exMsg.erreurApi == -1051) {
      cbaLink.environment.cpsCodeActif = false;
    }
    if (etatCarteCps == null) {
      return exMsg;
    }
    var i;
    var mapCpsEtatCarte = new Map();
    var argsCouples = etatCarteCps.split(cbaLink.environment.ARGS_SEPARATOR);
    for (i = 0; i < argsCouples.length; i++) {
      var items = argsCouples[i].split(cbaLink.environment.ARGS_VALUE_SEPARATOR);
      if (items.length == 2) {
        mapCpsEtatCarte.set(items[0], items[1]);
      }
    }
    if (mapCpsEtatCarte) {
      // met a jour les vars globales
      cbaLink.environment.cpsCategorie = mapCpsEtatCarte.get(cbaLink.environment.ARGS_CPS_CATEGORIE);
      cbaLink.environment.cpsNbTentativeCodeRestantes = mapCpsEtatCarte.get(cbaLink.environment.ARGS_CODEPORTEUR_NB_TENTAS);
      cbaLink.environment.cpsNomPs = mapCpsEtatCarte.get(cbaLink.environment.ARGS_CPS_NOM_PS);
      cbaLink.environment.cpsIdNat = mapCpsEtatCarte.get(cbaLink.environment.ARGS_CPS_IDNAT);
      cbaLink.environment.cpsNumeroSerie = mapCpsEtatCarte.get(cbaLink.environment.ARGS_NUMSERIE);
      cbaLink.environment.cpsTest = false;
      var isTest = mapCpsEtatCarte.get(cbaLink.environment.ARGS_CPS_TEST);
      if (isTest && isTest === "true") {
        cbaLink.environment.cpsTest = true;
      }
      cbaLink.environment.cpsCodeActif = false;
      var isCodeActif = mapCpsEtatCarte.get(cbaLink.environment.ARGS_CPS_CODE_ACTIF);
      if (isCodeActif && isCodeActif === "true") {
        cbaLink.environment.cpsCodeActif = true;
      }
      // augmentation de exMsg
      exMsg.cpsEtatRead = cbaLink.environment.cpsEtatRead;
      exMsg.cpsCodeActif = cbaLink.environment.cpsCodeActif;
      exMsg.cpsCategorie = cbaLink.environment.cpsCategorie;
      exMsg.cpsNbTentativeCodeRestantes = cbaLink.environment.cpsNbTentativeCodeRestantes;
      exMsg.cpsNomPs = cbaLink.environment.cpsNomPs;
      exMsg.cpsNumeroSerie = cbaLink.environment.cpsNumeroSerie;
    }
    return exMsg;
  }

  /**
   * insertion code Porteur
   *
   * @param cpc :
      */
  function codePorteurIns(cpc) {
    if (document.getElementById('codePorteurVal').value.length <= 3) {
      document.getElementById('codePorteurVal').value + cpc;
      document.getElementById('codePorteurVal').value = cpc_cum;
    }
  }

  /**
   * Reset du code Porteur
   */
  function codePorteurRst() {
    document.getElementById('codePorteurVal').value = "";
  }
  function setEmotionLinkFsvVersionToUse() {
    try {
      logTra.debug("setEmotionLinkFsvVersionToUse : start");
      try {
        let params = cbaLink.environment.ARGS_APP_FSV_SOCLE_VERSION + cbaLink.environment.ARGS_VALUE_SEPARATOR + cbaLink.environment.fsvVersionToUse;
        var VersionPromise = fsv(cbaLink.environment.COMMANDE_SET_SOCLEFSV, params, null, true);
      } catch (err) {
        logTra.debug("setEmotionLinkFsvVersionToUse - Err - " + err);
      }
      logTra.debug("setEmotionLinkFsvVersionToUse : return promise");
      return VersionPromise;
    } catch (err) {
      logTra.debug("setEmotionLinkFsvVersionToUse - Err - " + err);
    }
  }

  /**
   * getEmotionLinkInformations
   * <p>
   *     Appel la méthode "fsv emotionlink" qui récupère les informations du client Emotionlink-AgatheLink.
   * </p>
   * EmotionLink - AgatheLink du client
   * @returns {*} retourne un objet
   */
  function getEmotionLinkInformations() {
    try {
      logTra.debug("readVersionEmotionLink : start");
      let clientInfosPromise;
      try {
        clientInfosPromise = fsv(cbaLink.environment.COMMANDE_GET_CLIENTINFOS, "", null, true);
      } catch (err) {
        logTra.debug("getEmotionLinkInformations - Err - " + err);
      }
      logTra.debug("readVersionEmotionLink : return promise");
      return clientInfosPromise;
    } catch (err) {
      logTra.debug("getEmotionLinkInformations - Err - " + err);
    }
  }

  /**
   * Initialise l'objet _clientInformations avec les données d'un exMsg
   *
   * @param exMsg
   */
  function readClientInformationFromExMsg(exMsg) {
    let informationsClientTemp = exMsg.message.split('#').join('').split(';');

    //transforme le tableau clé/valeur en objet:
    _clientInformations = informationsClientTemp.reduce(function (result, item) {
      //var key = Object.keys(item)[0]; //first property: a, b, c
      let keyValue = item.split("=");
      let key = keyValue[0];
      let value = keyValue[1];
      result[key] = value;
      return result;
    }, {});

    //rattrapage ancienne version EmotionLink - AgatheLink (<1.12)
    if (!_clientInformations.appOsVersion) {
      let osInformation = getOsInformations();
      _clientInformations.appOsVersion = osInformation.majorVersion + "." + osInformation.minorVersion;
    }
  }

  /**
   * Vérification de la validité de la version de EmotionLink - AgatheLink.
   * Commande de récupération des informations du client EmotionLink - AgatheLink.
   * Lancer 1 fois à la connexion de la websocket.
   * @DQ 19/10/16
   */
  function fsvEmotionLinkCheckVersion() {
    logTra.debug("fsvEmotionLinkCheckVersion");
    let dfd = jquery__WEBPACK_IMPORTED_MODULE_0__.Deferred();
    let _updateClient = function (exMsg) {
      if (!exMsg) {
        logTra.debug("fsvEmotionLinkCheckVersion - Erreur FSV : Aucune donnée retournée");
        return;
      } else {
        logTra.debug("fsvEmotionLinkCheckVersion - OK");
        readClientInformationFromExMsg(exMsg);
        logTra.debug("fsvEmotionLinkCheckVersion - Infos client : ");
        //logTra.debug(_clientInformations);
        var content = [];
        content['typeOS'] = _clientInformations.appSysteme;
        content['versionAppli'] = _clientInformations.appVersion;
        content['versionOs'] = _clientInformations.appOsVersion;
        if (_clientInformations.configurationPdt) {
          content['configurationPdtJson'] = _clientInformations.configurationPdt;
        }

        // Récupération de la version requise => constante
        cbaLink.services.frontend.callService("/common/getVersionEmotionLinkRequise", content).then(function (data) {
          logTra.debug("fsvEmotionLinkCheckVersion - getVersionEmotionLinkRequise - OK");
          //logTra.debug(data);

          if (data.returnAction == "success") {
            _versionEmotionLinkRequise = data.versionRequise;
            logTra.debug("Test version EmotionLink - AgatheLink : " + _clientInformations.appVersion + " / Requise : " + _versionEmotionLinkRequise);
            //if (_clientInformations.appVersion == _versionEmotionLinkRequise) {
            if (_clientInformations.appVersion >= _versionEmotionLinkRequise) {
              //SEB: On stocke dans la BDD la version minimum requise,
              //le client peut avoir une version supérieure (permet de diffuser plusieurs versions)
              self._versionClientAutorise = true;

              //verifie si le socle utilisé dans EL est le bon (à partir de EL 1.16)
              setEmotionLinkFsvVersionToUse().then(
              //met à jour les infos clients
              exMsg => {
                readClientInformationFromExMsg(exMsg);
              }, echec => {
                logTra.trace("echec changement d'API : ");
              }).then(() => {
                if (data.listeComposantsFsvToUpdateJson) {
                  //mise à jour des composants est nécessaire (à partir de EmotionLink - AgatheLink 1.15)
                  //le contenu de configurationPdt contient la listes des composants à mettre à jour et leur url de téléchargement
                  let listeComposantsToUpdate = JSON.parse(data.listeComposantsFsvToUpdateJson);
                  if (listeComposantsToUpdate.length > 0) {
                    //appeler methode maj composant d'EmotionLink - AgatheLink
                    emotionLinkUpdateComponents(listeComposantsToUpdate);
                  }
                }
              });
            } else {
              self._versionClientAutorise = false;

              //cas particulier : Si OS trop ancien on ne propose pas la MAJ
              let osInformation = getOsInformations();
              if (osInformation.osName == "Macintosh" && (osInformation.majorVersion < 10 || osInformation.majorVersion == 10 && osInformation.minorVersion < 14
              //||  (osInformation.majorVersion==10 && osInformation.minorVersion==13 && osInformation.releaseVersion<6 )
              )) {
                self._versionClientAutorise = true;
                _versionOsObsolete = true;
              }
            }
          } else {
            hideDialog("dialogAccesLecteur");
            logTra.debug("getVersionEmotionLinkRequise - KO - " + data.returnMessage);
            showDialog("dialogError", data.returnMessage);
          }
        }, function (error) {
          hideDialog("dialogAccesLecteur");
          logTra.debug("getVersionEmotionLinkRequise - KO - " + error);
          showDialog("dialogError", error);
        });
      }
    };
    let successCB = function (o) {
      _updateClient(o);
    };
    let versionPromise = getEmotionLinkInformations();
    versionPromise.then(successCB).then(dfd.resolve());
    return dfd.promise();
  }

  /**
   * Test la version EmotionLink par rapport à celle attendue par le backend<br>
   * Retourne une promesse résolue a true si la version est à jour, à false si elle n'est pas à jour<br>
   * Retourne une promesse échec si les informations n'ont pas pu être obtenues
   * @returns {*}
   */
  function fsvEmotionLinkCheckVersionBis() {
    logTra.debug("fsvEmotionLinkCheckVersionBis");
    let dfd = jquery__WEBPACK_IMPORTED_MODULE_0__.Deferred();

    //demande à EmotionLink les informations version et pdt
    getEmotionLinkInformations().then(exMsg => {
      //traduit la reponse retournée par EL/AL
      readClientInformationFromExMsg(exMsg);

      //demande au backend la version attendue
      var content = [];
      content['typeOS'] = _clientInformations.appSysteme;
      content['versionAppli'] = _clientInformations.appVersion;
      content['versionOs'] = _clientInformations.appOsVersion;

      // Récupération de la version requise => constante
      return cbaLink.services.frontend.callService("/common/getVersionEmotionLinkRequise", content).then(data => {
        //vérifie si la version EL/AL est la bonne et met à jour la variable globale
        if (data.returnAction == "success" && data.versionRequise) {
          self._versionClientAutorise = _clientInformations.appVersion >= data.versionRequise;
          dfd.resolve(self._versionClientAutorise);
        } else {
          dfd.reject("noresponse");
        }
      }, echec => {
        //echec de communication avec le backend
        dfd.reject("noresponse");
      });
    }, echec => {
      //echec de communication avec le backend
      dfd.reject("noresponse");
    });
    return dfd.promise();
  }
  function emotionLinkUpdateComponents(listeComposantsToUpdate) {
    let dfd = jquery__WEBPACK_IMPORTED_MODULE_0__.Deferred();
    dfd.done(() => {
      logTra.debug("emotionLinkUpdateComponents");
      try {
        let jsonMessage = JSON.stringify(listeComposantsToUpdate);
        fsv(cbaLink.environment.COMMANDE_UPDATE_COMPONENTS, "", null, null, jsonMessage).then(exMsg => {
          logTra.debug("emotionLinkUpdateComponents : success call" + exMsg.message);
        }, error => {
          logTra.debug("emotionLinkUpdateComponents : error call");
        });
      } catch (err) {
        logTra.debug("emotionLinkUpdateComponents - Err - " + err);
      }
    });
    dfd.resolve("doit");
    return dfd.promise();
  }
  function emotionLinkDemarreGestionnaireCertificatCPS() {
    let dfd = jquery__WEBPACK_IMPORTED_MODULE_0__.Deferred();
    logTra.debug("emotionLinkDemarreGestionnaireCertificatCPS");
    try {
      showDialog("dialogAccesLecteur");
      fsv(cbaLink.environment.COMMANDE_RUN_CCM, "").then(exMsg => {
        logTra.debug("emotionLinkDemarreGestionnaireCertificatCPS : success call" + exMsg.message);
        hideDialog("dialogAccesLecteur");
        dfd.resolve();
      }, error => {
        logTra.debug("emotionLinkDemarreGestionnaireCertificatCPS : error call");
        hideDialog("dialogAccesLecteur");
        dfd.resolve(); //on "resolve" dans tous les cas, cet appel n'est pas obligatoire pour le bon déroulement de la suite du process
      });
    } catch (err) {
      logTra.debug("emotionLinkDemarreGestionnaireCertificatCPS - Err - " + err);
    }
    return dfd.promise();
  }
  function getOsInformations() {
    let osInformation = {
      osName: "unknow",
      majorVersion: "0",
      minorVersion: "0",
      releaseVersion: "0"
    };
    if (navigator.platform.includes("Mac") || navigator.userAgentData && navigator.userAgentData.platform.includes("Mac")) {
      osInformation.osName = "Macintosh";
      //"5.0 (Macintosh; Intel Mac OS X 10_14_5) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.1.1 Safari/605.1.15"
      let versionOs = navigator.userAgent.substring(navigator.userAgent.indexOf("Mac OS X ") + 9, navigator.userAgent.indexOf(") "));
      let versionMac = versionOs.split("_");
      osInformation.majorVersion = versionMac[0];
      osInformation.minorVersion = versionMac[1];
      osInformation.releaseVersion = versionMac[2];
    } else if (navigator.platform.includes("Win") || navigator.userAgentData && navigator.userAgentData.platform.includes("Win")) {
      osInformation.osName = "Window";
      //"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/74.0.3729.169 Safari/537.36"
      let versionOs = navigator.userAgent.substring(navigator.userAgent.indexOf(" NT ") + 4, navigator.userAgent.indexOf("; "));
      let versionWinTmp = "";
      try {
        versionWinTmp = parseFloat(versionOs);
        if (isNaN(versionWinTmp)) {
          versionOs = '5.0';
        }
      } catch (e) {
        versionOs = '5.0';
      }
      let versionWin = versionOs.split(".");
      osInformation.majorVersion = versionWin[0];
      osInformation.minorVersion = versionWin[1];
      osInformation.releaseVersion = "0"; //versionMac[2];
    }

    return osInformation;
  }
  function getBrowserInformations() {
    let browserInfo = {
      browserName: "Non identifié",
      browserVersion: "0",
      browserChromeCompatible: false
    };
    let userAgent = navigator.userAgent;
    let browserIndex = function (agent) {
      switch (true) {
        case agent.indexOf("edge") > -1:
          return agent.indexOf("edge");
        // MS Edge
        case agent.indexOf("edg/") > -1:
          return agent.indexOf("edg/");
        // Edge (chromium)
        case agent.indexOf("opr") > -1 && !!window.opr:
          return agent.indexOf("opr");
        // Opera
        case agent.indexOf("chrome") > -1 && !!window.chrome:
          return agent.indexOf("chrome");
        // Chrome
        case agent.indexOf("trident") > -1:
          return agent.indexOf("trident");
        // MS IE
        case agent.indexOf("firefox") > -1:
          return agent.indexOf("firefox");
        // Mozilla Firefox
        case agent.indexOf("safari") > -1:
          return agent.indexOf("safari");
        // Safari
        default:
          return -1;
      }
    }(userAgent.toLowerCase());
    if (userAgent.includes("Chrome")) {
      browserInfo.browserChromeCompatible = true;
    }
    if (browserIndex > -1) {
      let nextSpaceIndex = userAgent.indexOf(' ', browserIndex);
      if (nextSpaceIndex != -1) {
        let browser = userAgent.substring(browserIndex, nextSpaceIndex).split('/');
        browserInfo.browserName = browser[0];
        browserInfo.browserVersion = browser[1];
      } else {
        let browser = userAgent.substr(browserIndex).split('/');
        browserInfo.browserName = browser[0];
        browserInfo.browserVersion = browser[1];
      }
    }
    return browserInfo;
  }

  /**
   * Vérification de la validité de la version de l'application TLA.
   *
   * @author SEB
   * @date 13/08/2018
   *
   */
  function fsvTlaCheckVersion() {
    logTra.debug("fsvTlaCheckVersion");
    var _updateTla = function (exMsg) {
      if (!exMsg) {
        logTra.debug("fsvTlaCheckVersion - Erreur FSV : Aucune donnée retournée");
        return;
      } else {
        logTra.debug("fsvTlaCheckVersion - OK");
        var informationsClientTemp = exMsg.message.split('#').join('').split(';');
        _clientInformations.appVersion = informationsClientTemp[0].replace('appVersion=', '');
        _clientInformations.appSysteme = informationsClientTemp[1].replace('appSysteme=', '');
        logTra.debug("fsvEmotionLinkCheckVersion - Infos client : ");
        //logTra.debug(_clientInformations);
        var content = [];
        content['typeOS'] = _clientInformations.appSysteme;
        content['versionAppli'] = _clientInformations.appVersion;
        // Récupération de la version requise => constante
        cbaLink.services.frontend.callService("/common/getVersionEmotionLinkRequise", content).then(function (data) {
          logTra.debug("fsvEmotionLinkCheckVersion - getVersionEmotionLinkRequise - OK");
          //logTra.debug(data);

          if (data.returnAction == "success") {
            _versionEmotionLinkRequise = data.versionRequise;
            logTra.debug("Test version EmotionLink - AgatheLink : " + _clientInformations.appVersion + " / Requise : " + _versionEmotionLinkRequise);
            //if (_clientInformations.appVersion == _versionEmotionLinkRequise) {
            if (_clientInformations.appVersion >= _versionEmotionLinkRequise) {
              //SEB: On stocke dans la BDD la version minimum requise,
              //le client peut avoir une version supérieure (permet de diffuser plusieurs versions)
              self._versionClientAutorise = true;
            } else {
              self._versionClientAutorise = false;
            }
          } else {
            hideDialog("dialogAccesLecteur");
            logTra.debug("getVersionEmotionLinkRequise - KO - " + data.returnMessage);
            showDialog("dialogError", data.returnMessage);
          }
        }, function (error) {
          hideDialog("dialogAccesLecteur");
          logTra.debug("getVersionEmotionLinkRequise - KO - " + error);
          showDialog("dialogError", error);
        });
      }
    };
    var successCB = function (o) {
      _updateTla(o);
    };
    var VersionPromise = getEmotionLinkInformations();
    VersionPromise.then(successCB);
  }

  /**
   * Dialog qui indique à l'utilisateur de réessayer son action.
   */
  function showDialogRetry() {
    var dialogConfirmation = new EmotionGenDialog();
    dialogConfirmation.setTitle("Vérification EmotionLink - AgatheLink");
    dialogConfirmation.hideCloseButton();
    dialogConfirmation.setCancelButtonLabel("Fermer");
    dialogConfirmation.show("La vérification de connexion à EmotionLink - AgatheLink n'était pas terminée.<br>Veuillez ré-essayer.");
  }

  /**
   * Dialog qui indique à l'utilisateur de mettre à jour EmotionLink - AgatheLink.
   */
  function showDialogUpdateRequired() {
    var dialogConfirmation = new EmotionGenDialog();
    dialogConfirmation.setTitle("Mise à jour de EmotionLink - AgatheLink requise");
    dialogConfirmation.hideCloseButton();
    dialogConfirmation.setOkButtonLabel("Mettre à jour");
    dialogConfirmation.setCancelButtonLabel("Annuler");
    dialogConfirmation.setOkCallback(function () {
      // Fonction appel update sur EmotionLink - AgatheLink
      logTra.debug("Mise à jour !");
      launchEmotionLinkUpdate();
    });
    const messageToShow = `Votre version de EmotionLink - AgatheLink nécessite une mise à jour  <br></br>

            <br></br>
            <b><font color='red'>Vérifiez que votre lecteur est bien branché à l'ordinateur.</font></b><br></br> Cette mise à jour peut prendre quelques minutes.`;
    dialogConfirmation.show(messageToShow);
    closeAllDialogFSV();
  }
  function showDialogOsObsolete() {
    let dfd = jquery__WEBPACK_IMPORTED_MODULE_0__.Deferred();

    //si déjà signaler il y a moins de 15 jours, on n'affiche pas le message
    let lastDateWarning = localStorage.getItem("dateWarningOsObsolete");
    if (lastDateWarning) {
      // Vérifie si le message d'alerte a déjà été affiché
      let date1_ms = new Date(lastDateWarning).getTime();
      let date2_ms = new Date().getTime();

      // Calculate the difference in milliseconds
      let difference_ms = date2_ms - date1_ms;
      //conversion en jour
      let days = difference_ms / 1000 / 60 / 60 / 24;
      if (days > 15) {
        localStorage.setItem("dateWarningOsObsolete", new Date());
      } else {
        return dfd.resolve();
      }
    } else {
      localStorage.setItem("dateWarningOsObsolete", new Date());
    }
    var dialogConfirmation = new EmotionGenDialog();
    dialogConfirmation.setTitle("Mise à jour système requise");
    dialogConfirmation.hideCloseButton();
    dialogConfirmation.setOkButtonLabel("Continuer");
    dialogConfirmation.hideCancelButton();
    dialogConfirmation.setOkCallback(function () {
      dfd.resolve();
    });
    let libelleOS = "Windows";
    if (navigator.platform.includes("Mac") || navigator.userAgentData && navigator.userAgentData.platform.includes("Mac")) {
      libelleOS = "Macintosh";
    }
    const messageToShow = "La version de votre ordinateur est obsolète et nécessite d'être mise à jour pour profiter de toutes les fonctionnalités d'Agathe Emotion.<br/>";
    dialogConfirmation.show(messageToShow);
    //closeAllDialogFSV();

    return dfd.promise();
  }
  function launchEmotionLinkUpdate() {
    logTra.debug("launchEmotionLinkUpdate");
    var content = [];
    content['versionEmotionLink'] = _clientInformations.appVersion;
    content['typeOS'] = _clientInformations.appSysteme;
    content['versionOs'] = _clientInformations.appOsVersion;
    cbaLink.services.frontend.callService("/common/getEmotionLinkUpdateUpdateForVersionCibleWithOS", content).then(function (data) {
      if (data.returnAction == "success") {
        var emotionLinkInfosSerialized = JSON.parse(data.returnMessage);
        if (emotionLinkInfosSerialized == null) {
          downloadEmotionLinkComplete();
        } else {
          updateClient(emotionLinkInfosSerialized.lienUpdate, emotionLinkInfosSerialized.crcUpdater, emotionLinkInfosSerialized.versionActuelle);
        }
      }
    });
  }
  function downloadEmotionLinkComplete() {
    logTra.debug("downloadEmotionLinkComplete");
    let typeOs = undefined;
    if (navigator.appVersion.indexOf("Win") != -1) {
      typeOs = "WIN";
    } else if (navigator.appVersion.indexOf("Mac") != -1) {
      typeOs = "MAC";
    }
    if (typeOs === undefined) {
      let messageToShow = `Votre système d'exploitation n'est pas compatible avec le logiciel EmotionLink - AgatheLink <br/>`;
      let dialog = new EmotionGenDialog();
      dialog.setTitle("EmotionLink - AgatheLink");
      dialog.hideOkButton();
      dialog.setCancelButtonLabel("Fermer");
      dialog.show(messageToShow);
      return;
    }
    let content = [];
    content['typeOS'] = typeOs;
    cbaLink.services.frontend.callService("/common/getDefaultVersionAgatheLink", content).then(data => {
      let messageToShow = "Unknown OS";
      if (data.returnAction == "error") {
        messageToShow = data.returnMessage;
      } else {
        let linkDefaulVersion = data.agatheLinkDefaultVersion.lienUpdate;
        messageToShow = `Aucune mise a jour n'a été trouvée pour votre version de EmotionLink - AgatheLink <br/>
                                        Veuillez ré-installer la dernière version complète de EmotionLink - AgatheLink
                                        <br></br>
                                        <a href="${linkDefaulVersion}"
                                        id="but_download_completeEmotionLink" download>Télécharger</a><br/>`;
      }
      let dialog = new EmotionGenDialog();
      dialog.setTitle("EmotionLink - AgatheLink");
      dialog.hideOkButton();
      dialog.setCancelButtonLabel("Fermer");
      dialog.show(messageToShow);
    }, error => {
      console.error(error);
    });
  }

  /**
   * Cette fonction va updater le client
   * reelement si besoin
   * il faudra lui donner l'os, le lien de download et le crc
   *
   */
  function updateClient(downloadUrl, crc, versionCible) {
    try {
      var params = cbaLink.environment.ARGS_URL + cbaLink.environment.ARGS_VALUE_SEPARATOR + downloadUrl + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CRC + cbaLink.environment.ARGS_VALUE_SEPARATOR + crc + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_VERSION + cbaLink.environment.ARGS_VALUE_SEPARATOR + versionCible;
      var dialogReload = new EmotionGenDialog();
      dialogReload.setTitle("Finalisation de l'installation");
      dialogReload.hideCloseButton();
      dialogReload.hideCancelButton();
      dialogReload.setOkButtonLabel("Recharger");
      dialogReload.setOkCallback(function () {
        location.reload();
      });
      dialogReload.show("Veuillez cliquer sur le bouton ci-dessous une fois l'installation<br> de EmotionLink - AgatheLink terminée<br>");
      var successCB = function (o) {
        _updateClientMAJ(o);
      };
      var configPromise = fsv(cbaLink.environment.COMMANDE_UPDATECLIENT, params, null, true);
      configPromise.then(successCB);
      return configPromise;
    } catch (err) {
      logTra.debug("updateClient - Err - " + err);
    }
  }

  /**
   * Cette fonction va updater le logiciel TLA du lecteire de carte
   */
  function updateTla(downloadUrl, crc, versionCible) {
    try {
      var params = cbaLink.environment.ARGS_URL + cbaLink.environment.ARGS_VALUE_SEPARATOR + downloadUrl + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CRC + cbaLink.environment.ARGS_VALUE_SEPARATOR + crc + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_VERSION + cbaLink.environment.ARGS_VALUE_SEPARATOR + versionCible;
      var dialogReload = new EmotionGenDialog();
      dialogReload.setTitle("Mise à jour du TLA");
      dialogReload.hideCloseButton();
      dialogReload.hideCancelButton();
      dialogReload.setOkButtonLabel("Recharger");
      dialogReload.setOkCallback(function () {
        location.reload();
      });
      dialogReload.show("Veuillez cliquer sur le bouton ci-dessous une fois la mise à jour<br> du TLA terminée<br>");
      var successCB = function (o) {
        //_updateClientMAJ(o);
        return o;
      };
      var configPromise = fsv(cbaLink.environment.COMMANDE_UPDATE_TLA, params, null, true);
      configPromise.then(successCB);
      return configPromise;
    } catch (err) {
      logTra.debug("updateClient - Err - " + err);
    }
  }

  /**
   * Envoi d'un fichier de mise à jour du lecteur de carte à EmotionLink - AgatheLink
   *
   *  @author SEB
   *  @date 22/03/2019
   *
   * @param url du fichier à télécharger
   * @param crc crc du fichier
   * @param versionCible version de l'application à mettre à jour
   * @returns retourne une promise. La promise renvoie un objet ExchangeMessage
   */
  function sendTlaUpdatefile(url, crc, versionCible) {
    try {
      var params = cbaLink.environment.ARGS_URL + cbaLink.environment.ARGS_VALUE_SEPARATOR + url + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_CRC + cbaLink.environment.ARGS_VALUE_SEPARATOR + crc + cbaLink.environment.ARGS_SEPARATOR + cbaLink.environment.ARGS_VERSION + cbaLink.environment.ARGS_VALUE_SEPARATOR + versionCible;
      var successCB = function (o) {
        return o;
      };
      var configPromise = fsv(cbaLink.environment.COMMANDE_UPDATE_TLA_WITHOUT_WIZARD, params, null, true);
      configPromise.then(successCB);
      return configPromise;
    } catch (err) {
      logTra.debug("updateClient - Err - " + err);
    }
  }

  /**
   * Retourne l'état d'avancement de la mise à jour du lecteur
   * Permet de savoir si le lecteur est pret à accepter le fichier de mise à jour,
   *  si le fichier de mise à jour a été copié sur le lecteur ou si le fichier de mise à jour est en cours de copie
   *
   * @author SEB
   * @date 22/03/2019
   *
   * @param resetBeforeUpdate true/false, à mettre à true au primei appel pour supprimer les fichiers temporaires d'une précédente maj
   * @returns retourne une promise. La promise renvoie un objet ExchangeMessage
   */
  function getStatusUpdatingTla(resetBeforeUpdate = false) {
    try {
      let params = cbaLink.environment.ARGS_RESET_BEFORE_UPDATE + cbaLink.environment.ARGS_VALUE_SEPARATOR + (resetBeforeUpdate ? "O" : "N");
      var successCB = function (o) {
        return o;
      };
      var configPromise = fsv(cbaLink.environment.COMMANDE_UPDATE_TLA_STATUS, params, null, true);
      configPromise.then(successCB);
      return configPromise;
    } catch (err) {
      logTra.debug("updateClient - Err - " + err);
    }
  }

  /**
   * Cette fonction doit renvoyer le type OS
   *
   */
  function getEmotionLinkTypeOS() {
    //on controle si le typeOS est bien renseigné, si ce n'est pas le cas, il faut refaire l'appel a EmotionLink - AgatheLink
    if (_clientInformations.appSysteme == undefined || _clientInformations.appSysteme == null) {
      fsvEmotionLinkCheckVersion();
    }
    return _clientInformations.appSysteme;
  }

  /**
   * Permet d'acceder à la variable _versionClientAutorise mis à jour a chaque appel fsv
   */
  function getEmotionLinkVersionClientAutorise() {
    return self._versionClientAutorise == null || self._versionClientAutorise === true;
  }

  /**
   * Permet de connaitre l'état d'avancement d'une mise à jour EmotionLink - AgatheLink
   */
  function getStatusUpdatingEmotionlink() {
    try {
      logTra.debug("readVersionEmotionLink : start");
      try {
        var VersionPromise = fsv(cbaLink.environment.COMMANDE_GET_UPDATECLIENT_STATUS, "", null, true);
      } catch (err) {
        logTra.debug("getEmotionLinkInformations - Err - " + err);
      }
      logTra.debug("readVersionEmotionLink : return promise");
      return VersionPromise;
    } catch (err) {
      logTra.debug("getEmotionLinkInformations - Err - " + err);
    }
  }
  exports.fsvlink = new FsvLink();
  exports.fsvlink.ExchangeMessage = ExchangeMessage;
})(cbaLink.services);

/***/ }),

/***/ "./projects/lib-agathe-link/js/init.js":
/*!*********************************************!*\
  !*** ./projects/lib-agathe-link/js/init.js ***!
  \*********************************************/
/***/ ((module) => {

const init = function () {
  const cbaLink = {};
  cbaLink.config = {};
  cbaLink.services = {};
  cbaLink.controllers = {};
  cbaLink.beans = {
    factory: null
  };
  cbaLink.uitools = {};
  cbaLink.ui = {
    tools: {},
    routers: {},
    controllers: {},
    services: {},
    components: {
      soignantFilter: {},
      notationComponent: {},
      switchThreeStatesComponent: {}
    }
  };
  cbaLink.environment = {
    // RessourceCps=Kapelse CCID Interface slot0 0#;#RessourceLec=Kapelse CCID Interface slot1 0#;#CodePorteur=#;#NumSerie=undefined#;#DateConsultation=20120601

    COMMANDE_GET_CLIENTINFOS: "clientInfos",
    COMMANDE_CHECK: "Check",
    ARGS_RESSOURCE_LEC: "RessourceLec",
    ARGS_RESSOURCE_VIT: "RessourceVit",
    ARGS_RESSOURCE_CPS: "RessourceCps",
    ARGS_SEPARATOR: "#;#",
    ARGS_VALUE_SEPARATOR: "=",
    //CODE SECURISATION pour la facturation

    MODESECURISATION_VISITE: 2,
    MODESECURISATION_CABINET: 3,
    MODESECURISATION_VITALE: 4,
    MODESECURISATION_DEGRADE: 5,
    MODESECURISATION_PAPIER: 20,
    MODESECURISATION_SESAM_SANS_VITALE: 1,
    //CODE ERREURS pour le CODE PORTEUR

    ERREUR_SSV_CP_ERRONE: 61443,
    ERREUR_SSV_EMOTIONLINK_CP_ERRONE: -2000,
    // Liste des commandes utilisables

    COMMANDE_GET_CLIENTINFOS: "clientInfos",
    //Mise à jour d'EmotionLink - AgatheLink
    COMMANDE_SET_SOCLEFSV: "setSocleFsv",
    COMMANDE_DISCONNECT: "disconnect",
    COMMANDE_SHUTDOWN: "shutdown",
    COMMANDE_REINIT: "reinit",
    COMMANDE_CLOSE_API_FSV: "closeApiFsv",
    COMMANDE_GIVEREF: "giveMeRef",
    COMMANDE_UPDATECLIENT: "UpdateClient",
    COMMANDE_GET_UPDATECLIENT_STATUS: "GetUpdateClientStatus",
    //Mise à jour de l'application TLA
    COMMANDE_UPDATE_TLA: "UpdateTla",
    COMMANDE_UPDATE_TLA_WITHOUT_WIZARD: "UpdateTlaWithoutWizard",
    //Commande de mise à disposition d'un fichier de mise à jour pour le lecteur
    COMMANDE_UPDATE_TLA_STATUS: "UpdateTlaStatus",
    //permet d'indiquer à emotion le status du process de mise à jour du TLA
    COMMANDE_UPDATE_COMPONENTS: "UpdateComposants",
    COMMANDE_RUN_CCM: "RunCCM",
    //demande de démarrage du gestionnaire de certificat (sous windows)

    COMMANDE_UPDATEAPI: "UpdateAPI",
    COMMANDE_SHOWMESSAGE: "showMessage",
    COMMANDE_SSV_LIREDATELECTEUR: "SSV_LireDateLecteur",
    COMMANDE_SSV_MAJDATELECTEUR: "SSV_MajDateLecteur",
    COMMANDE_SSV_LIRECARTEPS: "SSV_LireCartePS",
    COMMANDE_SSV_LIRECONFIG: "SSV_LireConfig",
    COMMANDE_SSV_LIREDROITSVITALE: "SSV_LireDroitsVitale",
    COMMANDE_SSV_CHARGERAPPLI: "SSV_ChargerAppli",
    COMMANDE_SSV_FORMATERFACTURES: "SSV_FormaterFactures",
    COMMANDE_SSV_SECURISERFACTURE: "SSV_SecuriserFacture",
    COMMANDE_SSV_CHIFFRERFACTURE: "SSV_ChiffrerFacture",
    COMMANDE_SSV_SIGNERFACTUREVITALE: "SSV_SignerFactureVitale",
    COMMANDE_SSV_SIGNERFACTURECPS: "SSV_SignerFactureCPS",
    COMMANDE_SSV_CALCULERHASHFACTUREASSURE: "SSV_CalculerHashFactureAssure",
    COMMANDE_SSV_AJOUTERSIGNATUREASSUREFACTURE: "SSV_AjouterSignatureAssureFacture",
    COMMANDE_SSV_TRADUIREARL: "SSV_TraduireARL",
    COMMANDE_SSV_FORMATERLOT: "SSV_FormaterLot",
    COMMANDE_SSV_SIGNERLOTCPS: "SSV_SignerLotCPS",
    COMMANDE_SSV_FORMATERFICHIER: "SSV_FormaterFichier",
    //fonction TLA
    COMMANDE_SSV_IDENTIFIERTLA: "SSV_IdentifierTLA",
    COMMANDE_SSV_CHARGERDONNEESTLA: "SSV_ChargerDonneesTLA",
    COMMANDE_SSV_DECHARGERFSETLA_ALL: "SSV_DechargerFSETLA_ALL",
    COMMANDE_SSV_DECHARGERFSETLA: "SSV_DechargerFSETLA",
    COMMANDE_SSV_DECHARGERFSETLANC: "SSV_DechargerFSETLANC",
    COMMANDE_SSV_DECHARGERBENEFICIAIRES: "SSV_DechargerBeneficiaires",
    COMMANDE_SSV_TRADUIREFSE: "SSV_TraduireFSE",
    COMMANDE_SSV_EFFACERTLA: "SSV_EffacerTLA",
    COMMANDE_SSV_CHARGERFACTURESPDT: "SSV_ChargerFacturesPdT",
    COMMANDE_SSV_DECHARGERFACTURESPDT: "SSV_DechargerFacturesPdt",
    COMMANDE_SRT_LIREVERSION: "SRT_LireVersion",
    COMMANDE_SRT_SAUVEGARDERREGERENTIEL: "SRT_SauvegarderRegerentiel",
    COMMANDE_SRT_RECHERCHERPARMOTCLE: "SRT_RechercherParMotCle",
    COMMANDE_SRT_RECHERCHERPARFILTRE: "SRT_RechercherParFiltre",
    COMMANDE_SRT_CONTROLERDONNEES: "SRT_ControlerDonnees",
    COMMANDE_SRT_CONTROLECOMPLET: "SRT_ControleComplet",
    COMMANDE_SRT_APPLIQUERREGLE: "SRT_AppliquerRegle",
    COMMANDE_SRT_CONSULTERDONNEE: "SRT_ConsulterDonnee",
    COMMANDE_SRT_MODIFIERDONNEE: "SRT_ModifierDonnee",
    COMMANDE_SRT_ANNULERMODIFICATION: "SRT_AnnulerModification",
    COMMANDE_STS_LIREVERSION: "STS_LireVersion",
    COMMANDE_STS_ASSISTANCE: "STS_Assistance",
    COMMANDE_STS_TARIFICATION: "STS_Tarification",
    COMMANDE_LEC_INFORMATIONSAPI: "Lec_InformationsAPI",
    COMMANDE_CPS_OUVERTURESESSION: "CPS_OuvertureSession",
    COMMANDE_CPS_FERMETURESESSION: "CPS_FermetureSession",
    COMMANDE_CPS_INTRODUCTIONCARTE: "CPS_IntroductionCarte",
    COMMANDE_CPS_RETRAITCARTE: "CPS_RetraitCarte",
    COMMANDE_CPS_LECTURECARTE: "CPS_LectureCarte",
    COMMANDE_CPS_PRESCODEPORTEUR: "CPS_PresCodePorteur",
    COMMANDE_CPS_READINFOSCARTE: "CPS_ReadInformationsCarte",
    COMMANDE_CPS_CHECKCODEPORTEUR: "CPS_CheckCodePorteur",
    COMMANDE_CPS_TESTPRESENCECARTE: "CPS_TestPresenceCarte",
    COMMANDE_CPS_LECTURETOUTENUNAVECCODE: "CPS_LectureToutEnUnAvecCode",
    COMMANDE_VITALE_OUVERTURESESSIONCPS: "Vitale_OuvertureSessionCps",
    COMMANDE_VITALE_FERMETURESESSIONCPS: "Vitale_FermetureSessionCps",
    COMMANDE_VITALE_INTRODUCTIONCARTECPS: "Vitale_IntroductionCarteCps",
    COMMANDE_VITALE_RETRAITCARTECPS: "Vitale_RetraitCarteCps",
    COMMANDE_VITALE_CONTROLECPS: "Vitale_ControleCps",
    COMMANDE_VITALE_OUVERTURESESSION: "Vitale_OuvertureSession",
    COMMANDE_VITALE_FERMETURESESSION: "Vitale_FermetureSession",
    COMMANDE_VITALE_INTRODUCTIONCARTE: "Vitale_IntroductionCarte",
    COMMANDE_VITALE_RETRAITCARTE: "Vitale_RetraitCarte",
    COMMANDE_VITALE_LECTURECARTE: "Vitale_LectureCarte",
    COMMANDE_TLSI_VERSIONMICA: "TLSi_VersionMica",
    COMMANDE_TLSI_GETASSERTIONCPS: "TLSi_GetAssertionCps",
    COMMANDE_TLSI_GETASSERTIONVITALE: "TLSi_GetAssertionVitale",
    COMMANDE_TLSI_PRESENCE_CV: "TLSi_PresenceCv",
    COMMANDE_TLSi_CALL_ANNUAIRE_AMC: "TLSi_CallAnnuaireAmc",
    COMMANDE_TLSI_CALL_ANNUAIRE_AMC_TRADUIT: "TLSi_CallAnnuaireAmcTraduit",
    COMMANDE_CONF_LIRECONFGALSS: "CONF_Lire_Config_Galss",
    COMMANDE_CONF_LECTEURS: "CONF_Lire_Lecteurs",
    COMMANDE_RESOLVE_TLA_DETECTION_ISSUE: "redetectionTla",
    COMMANDE_REBOOT: "Reboot",
    COMMANDE_CHECK: "Check",
    //DMP
    COMMANDE_TLSI_DMP_CREATE: "TLSi_DmpCreate",
    COMMANDE_TLSI_DMP_CREATE_ACCES: "TLSi_DmpCreateAcces",
    COMMANDE_TLSI_DMP_UNLOCK_ACCES: "TLSi_DmpUnlockAcces",
    COMMANDE_TLSI_DMP_ADD_AUTORISATION: "TLSi_DmpAddAutorisation",
    COMMANDE_TLSI_DMP_REMOVE_AUTORISATION: "TLSi_DmpRemoveAutorisation",
    COMMANDE_TLSI_DMP_UPDATE_CANAL_OTP: "TLSi_DmpUpdateCanalOTP",
    COMMANDE_TLSI_DMP_CHECK_IDENTITE: "TLSi_DmpCheckIdentite",
    COMMANDE_TLSI_DMP_ALIMENTATION: "TLSi_DmpAlimentation",
    //AppCV
    COMMANDE_READ_NFC: "ReadNFC",
    ARGS_MAJ_DIRECT_TYPE_OS: "OS_Type",
    ARGS_URL: "url",
    ARGS_CRC: "crc",
    ARGS_RESET_BEFORE_UPDATE: "resetBeforeUpdate",
    ARGS_VERSION: "version",
    ARGS_DATEHEURE: "DateHeure",
    ARGS_CODEPORTEUR: "CodePorteur",
    ARGS_NUMSERIE: "NumSerie",
    ARGS_CODEPORTEUR_NB_TENTAS: "CodeNbTentas",
    ARGS_NUMFACTURATION: "NumFacturation",
    ARGS_NUMVERSIONCDC: "NumVersionCDC",
    ARGS_FACTUREACREER: "FactureACreer",
    ARGS_MODESECUR: "ModeSecur",
    ARGS_NOLOGSITUATION: "NologSituation",
    ARGS_TYPEFLUX: "TypeFlux",
    ARGS_APP_FSV_SOCLE_VERSION: "appFsvSocleVersion",
    ARGS_TYPEDONNEE: "TypeDonnee",
    ARGS_MOTIFAPPEL: "MotifAppel",
    ARGS_PORTEEAPPEL: "PorteeAppel",
    ARGS_COMMENTAIRE: "Commentaire",
    ARGS_MOTCLE: "MotCle",
    ARGS_CADRERECHERCHE: "CadreRecherche",
    ARGS_FILTRE: "Filtre",
    ARGS_IDENTIFIANT: "Identifiant",
    ARGS_DATEREFERENCE: "DateReference",
    ARGS_DATEEFFET: "DateEffet",
    ARGS_DATECONSULTATION: "DateConsultation",
    ARGS_CPS_IDNAT: "CpsIdnat",
    ARGS_CPS_NOM_PS: "CpsNom",
    ARGS_CPS_CATEGORIE: "CpsCategorie",
    ARGS_CPS_TEST: "CpsTest",
    ARGS_CPS_CODE_ACTIF: "CpsCodePresente",
    ARGS_ASSERTION_SIGNATURE: "AssertionSign",
    ARGS_ASSERTION_ISSUER: "AssertionIssuer",
    ARGS_ASSERTION_IDF: "AssertionIdf",
    ARGS_ASSERTION_ATTRIBUTE: "AssertionAttribute",
    ARGS_ASSERTION_ATTRIBUTE_SEP: "#/#",
    ARGS_ASSERTION_ATTRIBUTE_VALUE_SEP: "#:#",
    ARGS_ASSERTION_NUM_SERIE_CV: "AssertionNumSerieVitale",
    ARGS_ASSERTION_NIVEAU_SECURITE: "AssertionNivSecurite",
    ARGS_MODE_CNDA: "ModeCnda",
    ARGS_ANNU_SITE_VERSION: "SiteEmotionVersion",
    //Variables maj quand on lit les infos du lecteur configuré, utiles en global
    // ressourceCps: "Kapelse CCID Interface slot0 0",
    ressourceCps: null,
    ressourceVitale: null,
    // ressourceLec: "Kapelse CCID Interface slot1 0",
    ressourceLec: null,
    numeroSerieLec: null,
    modeTraceCnda: null,
    versionCDCSV: null,
    typeLec: null,
    cpsEtatRead: false,
    cpsPresente: true,
    // important : on anticipe la presence de la carte CPS
    codePorteur: null,
    cpsCategorie: null,
    cpsNbTentativeCodeRestantes: null,
    cpsNomPs: null,
    cpsIdNat: null,
    cpsNumeroSerie: null,
    cpsTest: false,
    cpsCodeActif: false,
    fsvVersionToUse: '14014',
    tlaRedetection: false,
    reboot: false,
    unsuccessErrorGlobal: null,
    projetAngular: false
  };
  return cbaLink;
}();
module.exports = init;

/***/ }),

/***/ "./projects/lib-agathe-link/js/logtra.js":
/*!***********************************************!*\
  !*** ./projects/lib-agathe-link/js/logtra.js ***!
  \***********************************************/
/***/ ((module) => {

const logtra = function () {
  var baseUrl = "";
  var _self;
  function logtra() {
    // console.log("MODULE : logtra");
    _self = this;
  }
  logtra.prototype.debug = debug;
  logtra.prototype.error = error;
  function debug(txt) {
    return console.log(txt);
  }
  function error(txt) {
    return console.error(txt);
  }
  // ..... toutes les autres fonctions etc ...
  return logtra;
}();
module.exports = logtra;

/***/ }),

/***/ "./node_modules/jquery/dist/jquery.js":
/*!********************************************!*\
  !*** ./node_modules/jquery/dist/jquery.js ***!
  \********************************************/
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-05-11T18:29Z
 */
( function( global, factory ) {

	"use strict";

	if (  true && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.0",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			return elem.textContent;
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented
// as part of Sizzle so let's maintain them in the 3.x line
// for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!**********************************************!*\
  !*** ./projects/lib-agathe-link/js/index.js ***!
  \**********************************************/
window.cbaLink = __webpack_require__(/*! ./init.js */ "./projects/lib-agathe-link/js/init.js");
__webpack_require__(/*! ./fsvemotioncalls.1.0.js */ "./projects/lib-agathe-link/js/fsvemotioncalls.1.0.js");
__webpack_require__(/*! ./ADRService.js */ "./projects/lib-agathe-link/js/ADRService.js");
__webpack_require__(/*! ./SELAMCService.js */ "./projects/lib-agathe-link/js/SELAMCService.js");
})();

lib_agathe_link = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=lib-agathe-link.js.map
function startIntercom(appId, callback) {
	window.intercomSettings = {
		app_id: appId,
	};
	var w = window;
	var ic = w.Intercom;
	if (typeof ic === "function") {
		ic("reattach_activator");
		ic("update", w.intercomSettings);
	} else {
		var d = document;
		var i = function () {
			i.c(arguments);
		};
		i.q = [];
		i.c = function (args) {
			i.q.push(args);
		};
		w.Intercom = i;
		var l = function () {
			const s = d.createElement("script");
			s.type = "text/javascript";
			s.async = true;
			s.src = "https://widget.intercom.io/widget/" + appId;
			const x = d.getElementsByTagName("script")[0];
			x.parentNode.insertBefore(s, x);
		};
		if (document.readyState === "complete") {
			l();
		} else if (window.attachEvent) {
			window.attachEvent("onload", l);
		} else {
			window.addEventListener("load", l, false);
		}
	}
	callback();
}
